{
  "a11y": {
    "activeBatches": "Aktive Batches, {{count}} ausstehend",
    "activeBatchesButton": "Aktive Batches",
    "addToFavorites": "Zu Favoriten hinzufügen",
    "addTag": "Tag hinzufügen",
    "audioPlayer": "Audioplayer",
    "backupCode": "Backup-Code",
    "cancelAllDownloads": "Alle Downloads abbrechen",
    "clearAllNotifications": "Alle Benachrichtigungen löschen",
    "clearSelection": "Auswahl aufheben",
    "clearUploadQueue": "Upload-Warteschlange leeren",
    "copyLink": "Link kopieren",
    "closePanel": "Panel schließen",
    "composerFab": "Neue E-Mail verfassen",
    "detailsPanel": "Detailbereich",
    "emailSending": "E-Mail wird gesendet",
    "emptyFilesTable": "Keine Dateien zum Anzeigen",
    "editFileTags": "Dateitags bearbeiten",
    "fileTagsCount": "Stichworte, {{count}}",
    "enterFilePasswordForm": "Dateipasswort eingeben",
    "expandUploadProgress": "Upload-Fortschritt erweitern",
    "fileTypesFilter": "Nach Dateityp filtern",
    "filters": "Filter",
    "fullscreen": "Vollbild",
    "fileMoveForm": "Dateien verschieben",
    "filePublicLinkForm": "Einstellungen für öffentlichen Link",
    "filesTable": "Dateiliste",
    "globalSearch": "Dateien suchen",
    "goBack": "Zurück",
    "groupForm": "Gruppenform",
    "loading": "Wird geladen, bitte warten",
    "minimizeUploadProgress": "Upload-Fortschritt minimieren",
    "mute": "Stummschalten",
    "mainNavigation": "Hauptnavigation",
    "markAllRead": "Alle Benachrichtigungen als gelesen markieren",
    "notificationsButton": "Benachrichtigungen",
    "notificationsCount": "Benachrichtigungen, {{count}} ungelesen",
    "notificationsList": "Benachrichtigungsliste",
    "openEmailsSection": "E-Mail-Bereich öffnen",
    "openFileMenu": "Dateimenü öffnen",
    "openFolder": "Ordner {{name}} öffnen",
    "openList": "Öffnen Sie {{name}}",
    "openMoreActions": "Weitere Aktionen öffnen",
    "openFilesSection": "Datei-Bereich öffnen",
    "otpCode": "Einmalpasswort",
    "pendingGrants": "Ausstehende Förderanträge, {{count}}",
    "pendingGrantsButton": "Ausstehende Freigabeanfragen",
    "playbackProgress": "Wiedergabefortschritt, {{current}} von {{duration}}",
    "playPause": "Wiedergeben oder pausieren",
    "quickShare": "Schneller Share-Upload, {{percent}} Prozent",
    "removeFromFavorites": "Aus Favoriten entfernen",
    "removeException": "Ausnahme entfernen",
    "removeSharedFile": "Freigegebene Datei entfernen",
    "searchExactMatch": "Suche nach exakter Übereinstimmung",
    "searchWholeWord": "Ganzes Wort suchen",
    "sectionSelector": "Abschnittsauswahl",
    "selectCountry": "Wählen Sie {{country}}",
    "settingsSearch": "Sucheinstellungen",
    "skipToMain": "Zum Hauptinhalt springen",
    "tagActions": "Aktionen für Tag {{name}}",
    "tagNotSelected": "nicht ausgewählt",
    "tagSelected": "ausgewählt",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Textdatei-Editor",
    "totpCode": "Authentifizierungscode",
    "unmute": "Stummschaltung aufheben",
    "activityMap": "Weltaktivitätskarte nach Ländern",
    "cancelAllFailed": "Alle fehlgeschlagenen Batches abbrechen",
    "copyBackupCodes": "Backup-Codes kopieren",
    "deleteSelected": "Ausgewählte löschen",
    "downloadBackupCodes": "Laden Sie Backup-Codes herunter",
    "downloadProgress": "Download-Fortschritt",
    "exitEditMode": "Bearbeitungsmodus verlassen",
    "expandDownloadProgress": "Erweitern Sie den Download-Fortschritt",
    "exportCsv": "Export nach CSV",
    "imageEditor": "Bildeditor",
    "markdownEditor": "Markdown-Editor",
    "markdownHeading": "Überschriftenstil",
    "markdownLinkActions": "Aktionen verknüpfen",
    "markdownToolbar": "Formatierungssymbolleiste",
    "minimizeDownloadProgress": "Download-Fortschritt minimieren",
    "pdfViewer": "PDF Dokumentbetrachter",
    "printDashboard": "Dashboard drucken",
    "refreshFolderStats": "Ordnerstatistiken aktualisieren",
    "refreshList": "Liste aktualisieren",
    "removeFile": "Datei entfernen",
    "saveFile": "Datei speichern",
    "selectUser": "Wählen Sie {{name}}",
    "viewUploadErrors": "Upload-Fehler anzeigen",
    "uploadProgress": "Fortschritt hochladen",
    "viewAsGrid": "Rasteransicht",
    "viewAsList": "Listenansicht",
    "userForm": "Benutzerformular",
    "userMenu": "Benutzermenü",
    "viewRiskIndicator": "{{name}}, Details anzeigen",
    "verifyingFile": "Datei überprüfen",
    "videoPlayer": "Videoplayer",
    "volume": "Volumen, {{percent}} Prozent",
    "messageInput": "Nachrichteneingabe",
    "sendMessage": "Nachricht senden",
    "stopGenerating": "Generierung stoppen"
  },
  "antivirus": {
    "quarantine": {
      "title": "Quarantäne",
      "description": "Infizierte, fehlgeschlagene und übersprungene Scans prüfen und Fehlalarme freigeben.",
      "empty": "Keine Dateien entsprechen diesem Filter",
      "rescan": "Erneut scannen",
      "release": "Freigeben",
      "delete": "Löschen",
      "rescanSuccess": "Erneuter Scan eingereiht",
      "releaseSuccess": "Datei aus Quarantäne freigegeben",
      "releaseModalTitle": "Datei aus Quarantäne freigeben",
      "releaseConfirmDescription": "\"{{fileName}}\" aus der Quarantäne freigeben? Die Datei wird wieder verfügbar. Geben Sie einen Grund für das Audit-Protokoll an.",
      "releaseReasonLabel": "Grund",
      "releaseReasonPlaceholder": "Erklären Sie, warum die Datei freigegeben werden soll",
      "releaseReasonRequired": "Ein Freigabegrund ist erforderlich",
      "deleteConfirmTitle": "Quarantänedatei löschen?",
      "deleteConfirmDescription": "\"{{fileName}}\" in den Papierkorb verschieben? Verwendet den normalen Dateilöschpfad.",
      "status": {
        "infected": "Infiziert",
        "error": "Fehler",
        "skipped": "Übersprungen",
        "toolarge": "Zu groß"
      },
      "columns": {
        "name": "Dateiname",
        "threat": "Bedrohung",
        "engine": "Engine",
        "ownerEmail": "E-Mail des Eigentümers",
        "scannedAt": "Gescannt am",
        "actions": "Aktionen"
      },
      "errors": {
        "loadFailed": "Quarantänedateien konnten nicht geladen werden",
        "rescanFailed": "Erneuter Scan konnte nicht eingereiht werden",
        "releaseFailed": "Datei konnte nicht freigegeben werden",
        "deleteFailed": "Datei konnte nicht gelöscht werden",
        "invalidParams": "Ungültiger Filter oder Freigabegrund"
      }
    }
  },
  "account": {
    "title": "Konto",
    "description": "Verwalten Sie Ihr Profil, Ihre Einstellungen und Ihre Sicherheit.",
    "navAria": "Kontoabschnitte",
    "profile": "Profil",
    "profileDescription": "Aktualisieren Sie Ihren Namen. Die E-Mail-Adresse kann hier nicht geändert werden.",
    "profileUnavailable": "Profil ist nicht verfügbar.",
    "profileUpdated": "Profil aktualisiert",
    "preferences": "Einstellungen",
    "preferencesDescription": "Optionen für Sprache, Erscheinungsbild und Barrierefreiheit.",
    "languageDescription": "Wählen Sie die Sprache der Benutzeroberfläche.",
    "appearanceDescription": "Wählen Sie hell, dunkel oder folgen Sie dem System.",
    "accessibilityDescription": "Schalten Sie zwischen hohem Kontrast und reduzierter Bewegung um.",
    "security": "Sicherheit",
    "securityDescription": "Zwei-Faktor-Authentifizierung und Passkeys.",
    "twoFactorDescription": "Authentifizierungs-App-Codes hinzufügen oder verwalten.",
    "passkeysDescription": "Registrieren und verwalten Sie Passkeys für dieses Konto.",
    "openTwoFactor": "2FA verwalten",
    "openPasskeys": "Passkeys verwalten",
    "sessions": "Sitzungen",
    "sessionsDescription": "Verwalten Sie angemeldete Sitzungen und Sitzungen zum Entsperren von Ordnern.",
    "activeSessionsDescription": "Überprüfen und widerrufen Sie aktive Browsersitzungen.",
    "folderSessionsDescription": "Verwalten Sie Sitzungen zum Entsperren von Passwörtern für Ordner.",
    "openActiveSessions": "Aktive Sitzungen verwalten",
    "openFolderSessions": "Ordnersitzungen verwalten",
    "publicLinks": "Öffentliche Links",
    "publicLinksDescription": "Von Ihnen erstellte öffentliche Freigabelinks anzeigen und widerrufen.",
    "publicLinksCtaDescription": "Öffnen Sie die Liste Ihrer öffentlichen Links.",
    "openPublicLinks": "Öffentliche Links verwalten"
  },
  "pageTitle": {
    "app": "Filegrant",
    "login": "Anmelden",
    "logout": "Abmelden",
    "settings": "Einstellungen",
    "account": "Konto",
    "filesPersonal": "Dateien",
    "filesReceived": "Empfangen",
    "filesShared": "Geteilt",
    "filesFavorites": "Favoriten",
    "filesRecent": "Zuletzt",
    "filesHidden": "Versteckt",
    "filesTrash": "Papierkorb",
    "publicLink": "Öffentlicher Link",
    "emails": "E-Mails",
    "emailsInbox": "Posteingang",
    "emailsSent": "Gesendet",
    "emailsDrafts": "Entwürfe",
    "emailsFavorites": "E-Mail-Favoriten",
    "emailsArchive": "Archiv",
    "emailsTrash": "E-Mail-Papierkorb",
    "users": "Benutzer",
    "groups": "Gruppen",
    "dashboard": "Dashboard",
    "salesDashboard": "Vertriebs-Dashboard",
    "activityLogs": "Aktivitätsprotokolle",
    "antivirusQuarantine": "Quarantäne",
    "viewer": "Zuschauer",
    "office": "Office",
    "quickShare": "Schnell teilen",
    "store": "Speichern",
    "purchase": "Kaufen",
    "paymentSuccess": "Zahlungserfolg",
    "fileShareRequests": "Teilen Sie Anfragen",
    "protectedFile": "Geschützte Datei",
    "extensionAuthorize": "Erweiterungsberechtigung",
    "sharePointStatus": "SharePoint-Status"
  },
  "activityLogOperationTypes": {
    "CreateFile": "Datei erstellt",
    "CreateFolder": "Ordner erstellt",
    "CreateFileFailed": "Die Dateierstellung ist fehlgeschlagen",
    "CreateFolderFailed": "Die Ordnererstellung ist fehlgeschlagen",
    "ReadFile": "Datei angesehen",
    "ReadFolder": "Ordner angezeigt",
    "DownloadFile": "Datei heruntergeladen",
    "DownloadFileEncrypted": "Verschlüsselte Datei heruntergeladen",
    "DownloadFileZip": "Datei als Zip heruntergeladen",
    "SearchFiles": "Durchsuchte Dateien",
    "ReadFileFailed": "Dateiansicht fehlgeschlagen",
    "ReadFolderFailed": "Ordneransicht fehlgeschlagen",
    "DownloadFileFailed": "Der Dateidownload ist fehlgeschlagen",
    "DownloadFileEncFailed": "Der Download der verschlüsselten Datei ist fehlgeschlagen",
    "DownloadFileZipFailed": "Der Download der Zip-Datei ist fehlgeschlagen",
    "UpdateFile": "Datei aktualisiert",
    "RenameFile": "Datei umbenannt",
    "MoveFile": "Datei verschoben",
    "DuplicateFile": "Datei dupliziert",
    "UploadFile": "Datei hochgeladen",
    "UpdateFileFailed": "Die Dateiaktualisierung ist fehlgeschlagen",
    "RenameFileFailed": "Das Umbenennen der Datei ist fehlgeschlagen",
    "MoveFileFailed": "Das Verschieben der Datei ist fehlgeschlagen",
    "DuplicateFileFailed": "Die Dateiduplizierung ist fehlgeschlagen",
    "UploadFileFailed": "Das Hochladen der Datei ist fehlgeschlagen",
    "DeleteFileToRecycleBin": "Datei in den Papierkorb verschoben",
    "DeleteFolderToRecycleBin": "Ordner in den Papierkorb verschoben",
    "DeleteFileToRecycleBinFailed": "Datei konnte nicht in den Papierkorb verschoben werden",
    "DeleteFolderToRecycleBinFailed": "Der Ordner konnte nicht in den Papierkorb verschoben werden",
    "DeleteFilePermanently": "Datei dauerhaft gelöscht",
    "DeleteFolderPermanently": "Ordner endgültig gelöscht",
    "DeleteFilePermanentlyFailed": "Das endgültige Löschen der Datei ist fehlgeschlagen",
    "DeleteFolderPermanentlyFailed": "Das dauerhafte Löschen des Ordners ist fehlgeschlagen",
    "ShareFile": "Datei geteilt",
    "ShareFolder": "Ordner freigegeben",
    "RevokeShare": "Freigabe widerrufen",
    "ShareFileFailed": "Dateifreigabe fehlgeschlagen",
    "ShareFolderFailed": "Die Ordnerfreigabe ist fehlgeschlagen",
    "RevokeShareFailed": "Das Widerrufen der Freigabe ist fehlgeschlagen",
    "ViewAuditLog": "Audit-Protokoll angezeigt",
    "ExportAuditLog": "Audit-Protokoll exportiert",
    "ViewAuditLogFailed": "Die Ansicht des Audit-Protokolls ist fehlgeschlagen",
    "ExportAuditLogFailed": "Der Export des Audit-Protokolls ist fehlgeschlagen",
    "PurgeAuditLog": "Prüfprotokoll gelöscht (Aufbewahrung)",
    "GrantAccess": "Zugriff gewährt",
    "RevokeAccess": "Zugriff widerrufen",
    "GrantAccessFailed": "Die Zugriffsgewährung ist fehlgeschlagen",
    "RevokeAccessFailed": "Der Widerruf des Zugriffs ist fehlgeschlagen",
    "CreateVersion": "Version erstellt",
    "RevertVersion": "Version zurückgesetzt",
    "CreateVersionFailed": "Die Versionserstellung ist fehlgeschlagen",
    "RevertVersionFailed": "Das Zurücksetzen der Version ist fehlgeschlagen",
    "CommentFile": "Kommentar hinzugefügt",
    "ReplyComment": "Der Kommentar wurde beantwortet",
    "AssignTask": "Aufgabe zugewiesen",
    "CommentFileFailed": "Kommentar fehlgeschlagen",
    "ReplyCommentFailed": "Die Antwort auf den Kommentar ist fehlgeschlagen",
    "AssignTaskFailed": "Die Aufgabenzuweisung ist fehlgeschlagen",
    "PreviewFile": "Vorschau der Datei",
    "HiddenFile": "Datei ausgeblendet",
    "UnhiddenFile": "Datei nicht ausgeblendet",
    "AddToFavorites": "Zu den Favoriten hinzugefügt",
    "RemoveFromFavorites": "Aus den Favoriten entfernt",
    "PreviewFileFailed": "Dateivorschau fehlgeschlagen",
    "HiddenFileFailed": "Datei ausblenden fehlgeschlagen",
    "UnhiddenFileFailed": "Datei konnte nicht eingeblendet werden",
    "AddToFavoritesFailed": "Das Hinzufügen zu den Favoriten ist fehlgeschlagen",
    "RemoveFromFavoritesFailed": "Das Entfernen aus den Favoriten ist fehlgeschlagen",
    "CreateUser": "Benutzer erstellt",
    "EditUser": "Benutzer bearbeitet",
    "RemoveUser": "Benutzer entfernt",
    "CreateGroup": "Gruppe erstellt",
    "EditGroup": "Gruppe bearbeitet",
    "RemoveGroup": "Gruppe entfernt",
    "OnBehalfOfAccess": "Zugriff im Namen des Benutzers",
    "OnBehalfOfOperation": "Wird im Auftrag des Benutzers betrieben",
    "CreateUserFailed": "Die Benutzererstellung ist fehlgeschlagen",
    "EditUserFailed": "Die Benutzerbearbeitung ist fehlgeschlagen",
    "RemoveUserFailed": "Das Entfernen des Benutzers ist fehlgeschlagen",
    "CreateGroupFailed": "Die Gruppenerstellung ist fehlgeschlagen",
    "EditGroupFailed": "Die Gruppenbearbeitung ist fehlgeschlagen",
    "RemoveGroupFailed": "Das Entfernen der Gruppe ist fehlgeschlagen",
    "OnBehalfOfAccessFailed": "Im Auftrag ist der Zugriff fehlgeschlagen",
    "OnBehalfOfOperationFailed": "Der Vorgang im Auftrag ist fehlgeschlagen",
    "LogIn": "Benutzer angemeldet",
    "LogOut": "Benutzer abgemeldet",
    "OTPRequest": "OTP angefordert",
    "LogInFailed": "Fehler bei der Anmeldung",
    "LogOutFailed": "Die Abmeldung ist fehlgeschlagen",
    "OTPRequestFailed": "OTP Anfrage fehlgeschlagen",
    "AddTag": "Tag hinzugefügt",
    "RemoveTag": "Tag entfernt",
    "UpdateTag": "Tag aktualisiert",
    "ListTags": "Schlagworte aufgelistet",
    "AddTagFailed": "Das Hinzufügen des Tags ist fehlgeschlagen",
    "RemoveTagFailed": "Das Entfernen des Tags ist fehlgeschlagen",
    "UpdateTagFailed": "Tag-Aktualisierung fehlgeschlagen",
    "ListTagsFailed": "Tag-Liste fehlgeschlagen",
    "RestoreFile": "Datei wiederhergestellt",
    "TagFile": "Zur Datei hinzugefügte Tags",
    "RemoveTagFile": "Tags aus der Datei entfernt",
    "EncryptFile": "Datei verschlüsselt",
    "DecryptFile": "Datei entschlüsselt",
    "ChangeFileOwner": "Dateieigentümer geändert",
    "SetFileExpiration": "Dateiablauf festgelegt",
    "GenerateShareLink": "Teilen-Link generiert",
    "ValidateUser": "Vom Benutzer validiert",
    "SignFile": "Datei signiert",
    "FileDescription": "Dateibeschreibungssatz",
    "ShortCut": "Dateiverknüpfung erstellt",
    "RestoreFileFailed": "Die Wiederherstellung der Datei ist fehlgeschlagen",
    "TagFileFailed": "Tagging-Datei fehlgeschlagen",
    "RemoveTagFileFailed": "Das Entfernen von Tags aus der Datei ist fehlgeschlagen",
    "EncryptFileFailed": "Die Dateiverschlüsselung ist fehlgeschlagen",
    "DecryptFileFailed": "Die Dateientschlüsselung ist fehlgeschlagen",
    "ChangeFileOwnerFailed": "Fehler beim Ändern des Dateieigentümers",
    "SetFileExpirationFailed": "Ablaufdatum konnte nicht festgelegt werden",
    "GenerateShareLinkFailed": "Beim Generieren des Freigabelinks ist ein Fehler aufgetreten",
    "ValidateUserFailed": "Die Benutzervalidierung ist fehlgeschlagen",
    "SignFileFailed": "Dateisignatur fehlgeschlagen",
    "FileDescriptionFailed": "Das Festlegen der Dateibeschreibung ist fehlgeschlagen",
    "ShortCutFailed": "Die Erstellung der Dateiverknüpfung ist fehlgeschlagen",
    "ScreenCaptureAttempt": "Bildschirmaufnahme versucht",
    "ClipboardCopyAttempt": "Es wurde versucht, die Zwischenablage zu kopieren",
    "UnauthorizedAccessAttempt": "Unbefugter Zugriffsversuch",
    "ScreenCaptureAttemptFailed": "Der Versuch der Bildschirmaufnahme ist fehlgeschlagen",
    "ClipboardCopyAttemptFailed": "Der Versuch, die Zwischenablage zu kopieren, ist fehlgeschlagen",
    "UnauthorizedAccessAttemptFailed": "Der unberechtigte Zugriffsversuch ist fehlgeschlagen",
    "MalwareDetection": "Malware erkannt",
    "MalwareRemoval": "Schadsoftware entfernt",
    "SuspiciousActivityDetected": "Verdächtige Aktivität festgestellt",
    "IntrusionDetection": "Einbruch erkannt",
    "IntrusionPrevention": "Einbruch verhindert",
    "DataLeakageAttempt": "Versuchter Datenleck",
    "DataLeakageAttemptFailed": "Der Datenleckversuch ist fehlgeschlagen",
    "PhishingAttemptDetected": "Phishing-Versuch erkannt",
    "RansomwareAttackDetected": "Ransomware-Angriff erkannt",
    "BruteForceAttackDetected": "Brute-Force-Angriff erkannt",
    "TwoFactorAuthEnabled": "Zwei-Faktor-Authentifizierung aktiviert",
    "TwoFactorAuthDisabled": "Zwei-Faktor-Authentifizierung deaktiviert",
    "TwoFactorAuthAttemptFailed": "Der Versuch der Zwei-Faktor-Authentifizierung ist fehlgeschlagen",
    "PasswordChange": "Passwort geändert",
    "PasswordChangeFailed": "Die Passwortänderung ist fehlgeschlagen",
    "SecuritySettingsUpdate": "Sicherheitseinstellungen aktualisiert",
    "SecuritySettingsUpdateFailed": "Die Aktualisierung der Sicherheitseinstellungen ist fehlgeschlagen",
    "FirewallRuleChange": "Firewall-Regel geändert",
    "FirewallRuleChangeFailed": "Die Änderung der Firewall-Regel ist fehlgeschlagen",
    "EncryptionKeyManagement": "Verschlüsselungsschlüssel verwaltet",
    "EncryptionKeyManagementFailed": "Die Verwaltung des Verschlüsselungsschlüssels ist fehlgeschlagen",
    "AccessControlPolicyChange": "Zugriffskontrollrichtlinie geändert",
    "AccessControlPolicyChangeFailed": "Die Änderung der Zugriffskontrollrichtlinie ist fehlgeschlagen",
    "SecurityPatchApplied": "Sicherheitspatch angewendet",
    "SecurityPatchAppliedFailed": "Die Anwendung des Sicherheitspatches ist fehlgeschlagen",
    "LastCheckToken": "Letzte Check-Token-Aktivität",
    "UpdateSetting": "Update-Einstellung",
    "ViewGroupsList": "Gruppenliste angezeigt",
    "ViewUsersList": "Benutzerliste angezeigt",
    "ViewTrash": "Papierkorb angezeigt",
    "ViewArchivedFiles": "Versteckte Dateien angezeigt",
    "ViewFavoriteFiles": "Lieblingsdateien angezeigt",
    "ViewSharedFiles": "Freigegebene Dateien angezeigt",
    "ViewReceivedFiles": "Empfangene Dateien angezeigt",
    "ViewSettings": "Einstellung angesehen",
    "EmailSent": "E-Mail gesendet",
    "EmailRead": "E-Mail gelesen",
    "EmailSaveDraft": "Entwurf gespeichert",
    "EmailUpdateDraft": "Entwurf aktualisiert",
    "EmailTrash": "E-Mail wurde in den Papierkorb verschoben",
    "EmailRestore": "E-Mail aus dem Papierkorb wiederhergestellt",
    "EmailDelete": "E-Mail dauerhaft gelöscht",
    "EmailArchive": "E-Mail archiviert",
    "EmailUnarchive": "E-Mail nicht archiviert",
    "EmailFavourite": "E-Mail als Favorit markiert",
    "EmailUnfavourite": "E-Mail als Favorit nicht markiert",
    "EmailAttachmentRemoved": "Anhang aus gesendeter E-Mail entfernt",
    "EmailRecipientRemoved": "Empfänger aus gesendeter E-Mail entfernt",
    "EmailReplied": "E-Mail-Antwort gesendet",
    "EmailForwarded": "E-Mail weitergeleitet",
    "CreateSetting": "Einstellung erstellt",
    "DeleteSetting": "Einstellung gelöscht",
    "PaymentSessionCreated": "Zahlungssitzung erstellt",
    "PaymentCompleted": "Zahlung abgeschlossen",
    "SessionRevoked": "Sitzung widerrufen",
    "AllSessionsRevoked": "Alle Sitzungen widerrufen",
    "AdminSessionRevoked": "Der Administrator hat die Benutzersitzung widerrufen",
    "CreateCompany": "Unternehmen gegründet",
    "UpdateCompany": "Firma aktualisiert",
    "BackOfficeCreateUser": "Über das Backoffice angelegter Benutzer",
    "BackOfficeUpdateUser": "Benutzer über Backoffice aktualisiert",
    "SystemMaintenance": "Systemwartung",
    "CreateCertificate": "Zertifikat erstellt",
    "CreateAccessRule": "Zugriffsregel erstellt",
    "VersionRetention": "Versionsbeibehaltung angewendet",
    "CleanupDeletedVersions": "Gelöschte Versionen bereinigt",
    "CreateIdentityProvider": "Identitätsanbieter erstellt",
    "UpdateIdentityProvider": "Identitätsanbieter aktualisiert",
    "CreateAIAgent": "KI-Agent erstellt",
    "UpdateAIAgent": "KI-Agent aktualisiert",
    "DeleteAIAgent": "KI-Agent gelöscht",
    "AIChatRequest": "KI-Chat-Anfrage",
    "AIChatWithDocument": "KI-Chat mit Dokument",
    "AIChatDeleteConversation": "KI-Chat-Konversation gelöscht",
    "CancelBatch": "Batch abgebrochen",
    "CancelFileJobs": "Dateiaufträge abgebrochen",
    "RetryFileJobs": "Dateijobs wurden wiederholt",
    "InviteUsers": "Benutzer eingeladen",
    "ViewExecutiveReport": "Geschäftsbericht eingesehen",
    "CreatePublicLink": "Öffentlicher Link erstellt",
    "RevokePublicLink": "Öffentlicher Link entfernt",
    "PublicLinkAccess": "Öffentlicher Link aufgerufen",
    "PublicLinkDownload": "Öffentlicher Link-Download",
    "PublicLinkViewerAccess": "Zugriff für Betrachter öffentlicher Links",
    "PublicLinkAccessFailed": "Der Zugriff auf den öffentlichen Link ist fehlgeschlagen",
    "IpRegionLoginBlocked": "Anmeldung durch IP/Region blockiert",
    "IpRegionFileOperationBlocked": "Dateivorgang durch IP/Region blockiert",
    "EntraIdSyncStarted": "Entra ID Synchronisierung gestartet",
    "EntraIdSyncCompleted": "Entra ID Synchronisierung abgeschlossen",
    "EntraIdUserImported": "Benutzer importiert von Entra ID",
    "EntraIdGroupImported": "Gruppe importiert von Entra ID",
    "EntraIdSyncFailed": "Entra ID Synchronisierung fehlgeschlagen",
    "SetFolderPassword": "Ordnerpasswort festgelegt",
    "RemoveFolderPassword": "Ordnerpasswort entfernt",
    "FolderPasswordVerified": "Ordnerpasswort überprüft",
    "FolderPasswordFailed": "Die Überprüfung des Ordnerkennworts ist fehlgeschlagen",
    "FolderPasswordLockout": "Ordner-Passwortsperre",
    "FolderPasswordSessionRevoked": "Ordner-Passwort-Sitzung widerrufen",
    "FolderPasswordResetOtpRequested": "Zurücksetzen des Ordnerpassworts OTP angefordert",
    "FolderPasswordResetWithOtp": "Ordnerpasswort mit OTP zurücksetzen",
    "FolderPasswordResetOtpFailed": "Das Zurücksetzen des Ordnerpassworts OTP ist fehlgeschlagen",
    "TotpExemptionGranted": "TOTP Befreiung gewährt",
    "TotpExemptionRevoked": "TOTP Befreiung widerrufen",
    "TotpExemptionExpired": "TOTP Befreiung abgelaufen",
    "TransferOwnership": "Eigentum übertragen",
    "TransferOwnershipFailed": "Die Eigentumsübertragung ist fehlgeschlagen",
    "UserLoginTokenCreated": "Anmeldetoken erstellt",
    "UserLoginTokenDeleted": "Login-Token gelöscht",
    "UserLoginTokenStatusChanged": "Der Status des Anmeldetokens wurde geändert",
    "UserLoginTokenUsed": "Mit Login-Token angemeldet",
    "UserLoginTokenFailed": "Die Authentifizierung des Anmeldetokens ist fehlgeschlagen",
    "PasskeyRegistered": "Passkey registriert",
    "PasskeyRemoved": "Passkey entfernt",
    "PasskeyRemovedByAdmin": "Passkey vom Administrator entfernt",
    "PasskeyAuthenticationFailed": "Die Passkey-Authentifizierung ist fehlgeschlagen",
    "PasskeyPasswordlessLogin": "Passkey-Passwortlose Anmeldung",
    "PasskeyBlocked": "Passkey blockiert",
    "SharePointFileEncrypted": "SharePoint Datei verschlüsselt",
    "SharePointFileEncryptionFailed": "SharePoint Dateiverschlüsselung fehlgeschlagen",
    "SharePointFileEncryptionSkipped": "SharePoint Datei übersprungen",
    "SharePointScanCycleCompleted": "SharePoint Scanzyklus abgeschlossen",
    "SharePointScanCycleFailed": "SharePoint Scan-Zyklus fehlgeschlagen",
    "SharePointConnectionTested": "SharePoint Verbindung überprüft",
    "SharePointConnectionTestFailed": "SharePoint Verbindungsüberprüfung fehlgeschlagen",
    "SharePointPerimeterBrowsed": "SharePoint Perimeter durchsucht",
    "SharePointViewerTokenIssued": "SharePoint Zuschauer-Token ausgestellt",
    "SharePointViewerTokenDenied": "SharePoint Zuschauer-Token verweigert",
    "SharePointEditSessionOpened": "SharePoint Bearbeitungssitzung geöffnet",
    "SharePointEditSessionDenied": "SharePoint Bearbeitungssitzung abgelehnt",
    "SharePointFileEdited": "SharePoint Datei bearbeitet"
  },
  "activityLogTargetTypes": {
    "File": "Datei",
    "Folder": "Ordner",
    "Files": "Dateien",
    "FilesAndFolders": "Dateien und Ordner",
    "FilesAndTags": "Dateien und Tags",
    "FilesFoldersAndTags": "Dateien, Ordner und Tags",
    "User": "Benutzer",
    "Group": "Gruppe",
    "Share": "Eintrag teilen",
    "ShareLink": "Link teilen",
    "Version": "Version einer Datei oder eines Dokuments",
    "Comment": "Kommentieren Sie ein Dokument oder eine Datei",
    "Task": "Aufgabe in einer kollaborativen Umgebung zugewiesen",
    "Permission": "Erlaubnis",
    "AccessControl": "Zugriffskontrolleinträge",
    "Admin": "Verwaltungsbezogene Vorgänge",
    "Configuration": "Systemkonfiguration",
    "Setting": "Individuelle Einstellung",
    "Tag": "Tag oder Etikett",
    "Metadata": "Metadateneintrag",
    "Notification": "Benachrichtigungseintrag",
    "Workflow": "Workflow- oder Prozessdefinition",
    "Template": "Vorlage für Dokumente oder Dateien",
    "AuditLog": "Audit-Protokoll",
    "Security": "Sicherheitsrelevante Ziele",
    "Monitoring": "Überwachungs- und Protokollierungsziele",
    "Authentication": "Authentifizierungsbezogene Ziele",
    "TwoFactorAuth": "Ziele der Zwei-Faktor-Authentifizierung",
    "Session": "Benutzersitzung oder Token",
    "Encryption": "Verschlüsselungsbezogene Ziele",
    "EncryptionKey": "Verwaltung von Verschlüsselungsschlüsseln",
    "Payment": "Zahlung oder Transaktion",
    "Company": "Firma oder Mieter",
    "Certificate": "RSA-Zertifikat für den Unternehmenszugriff",
    "AccessRule": "Zugriffskontrollregel",
    "IdentityProvider": "Identitätsanbieter (z. B. Microsoft, Google)",
    "AIAgent": "KI-Klassifizierungsagent",
    "AIChat": "KI-Chat-Gespräch",
    "Batch": "Batch-Betrieb",
    "Report": "Executive- oder anderer Bericht",
    "Other": "Andere generische Ziele",
    "GroupsList": "Gruppen",
    "UsersList": "Benutzer",
    "SpecialFolder": "Spezialordner",
    "SettingsList": "Einstellungen",
    "Email": "E-Mail",
    "SharePointFile": "SharePoint Datei"
  },
  "realtime": {
    "connected": "Verbunden",
    "connecting": "Verbinden…",
    "disconnected": "Getrennt",
    "reconnecting": "Wieder verbinden…"
  },
  "settings": {
    "settings": "Einstellungen",
    "unavailable": "Die Einstellungen sind derzeit nicht verfügbar",
    "retry": "Klicken Sie, um es erneut zu versuchen",
    "authentication": "Authentifizierung",
    "saveCard": {
      "message": "Klicken Sie auf <strong>Speichern</strong>, wenn Sie die Änderungen abgeschlossen haben."
    },
    "informations": "Informationen",
    "preview": "Vorschau",
    "externalUserEnforcement": "Durchsetzung externer Benutzer",
    "externalUserEnforcementDescription": "Erzwingen Sie die Anzeige im Anti-Capture-Modus für alle externen Benutzer.",
    "tagBasedEncryption": "Tag-basierte Verschlüsselung",
    "tagBasedEncryptionDescription": "Erzwingen Sie die Anzeige im Anti-Capture-Modus für Dateien mit bestimmten Tags.",
    "tagBasedEncryptionPlaceholder": "Tags (durch Kommas getrennt), z. B. 'vertraulich, geheim'",
    "companyBranding": {
      "title": "Firmenbranding",
      "description": "Passen Sie das Erscheinungsbild der Plattform an das Branding Ihres Unternehmens an. Dazu gehört das Festlegen des Logos, der Farben und anderer visueller Elemente, die den Benutzern angezeigt werden.",
      "companyName": "Name der Firma",
      "preferredLanguage": "Bevorzugte Sprache",
      "companyLogos": "Firmenlogos",
      "companyLogosDescription": "Die Dateigröße darf nicht größer als 1 MB sein",
      "loginPageLogo": "Logo der Anmeldeseite",
      "loginPageLogoDescription": "Legen Sie das Logo fest, das auf der Anmeldeseite für Benutzer angezeigt wird. Vorschläge: Quadratisches oder horizontales Logo mit transparentem Hintergrund und einer maximalen Breite von 200 Pixeln.",
      "topBarLogo": "Logo der oberen Leiste",
      "topBarLogoDescription": "Legen Sie das Logo fest, das in der oberen Leiste der Plattform angezeigt wird. Vorschläge: Quadratisches oder horizontales Logo mit transparentem Hintergrund.",
      "emailNotificationLogo": "E-Mail-Benachrichtigungslogo",
      "emailNotificationLogoDescription": "Legen Sie das Logo fest, das in den an Benutzer gesendeten E-Mail-Benachrichtigungen verwendet werden soll.",
      "quickShareBackground": "Hintergrund schnell teilen",
      "quickShareBackgroundDescription": "Legen Sie das Hintergrundbild fest, das auf der Quick-Share-Seite angezeigt wird. Empfohlene Größe: 1200 x 1920 Pixel",
      "companyColors": "Firmenfarben",
      "topBarColors": "Farben der oberen Leiste",
      "topBarColorsDescription": "Legen Sie die Hintergrund- und Textfarbe für die obere Leiste der Plattform fest.",
      "mainButtonsColors": "Farben der Hauptschaltflächen",
      "mainButtonsColorsDescription": "Legen Sie die Hintergrund- und Textfarbe für die Hauptschaltfläche fest.",
      "loginPageTitle": "Titel der Anmeldeseite",
      "loginPageSubtitle": "Untertitel der Anmeldeseite",
      "loginTermsAndConditions": "Allgemeine Geschäftsbedingungen für die Anmeldung",
      "loginPagePreview": "Vorschau der Anmeldeseite und der oberen Leiste",
      "mainButtonsPreview": "Vorschau der Texte und Farben der Hauptschaltflächen",
      "emailNotificationsPreview": "Vorschau der E-Mail-Benachrichtigungen",
      "quickSharePreview": "Vorschau des Quick Share-Hintergrunds",
      "addLogo": "Logo hinzufügen"
    },
    "emailCustomizations": {
      "title": "E-Mail-Anpassungen",
      "description": "Passen Sie die HTML-Vorlagen an, die für von der Plattform gesendete E-Mail-Benachrichtigungen verwendet werden.",
      "language": "Sprache",
      "noTemplates": "Keine E-Mail-Vorlagen verfügbar",
      "subject": "Thema",
      "availablePlaceholders": "Verfügbare Platzhalter (zum Einfügen klicken)",
      "preview": "Vorschau",
      "customized": "Maßgeschneidert",
      "default": "Standard",
      "resetToDefault": "Auf Standard zurücksetzen",
      "resetTitle": "Vorlage zurücksetzen",
      "resetConfirm": "Zurücksetzen",
      "resetConfirmDescription": "Dadurch werden Ihre Anpassungen entfernt und die Standardvorlage wiederhergestellt. Diese Aktion kann nicht rückgängig gemacht werden.",
      "resetSuccess": "Vorlage auf Standard zurückgesetzt",
      "resetError": "Vorlage konnte nicht zurückgesetzt werden",
      "saveSuccess": "Vorlage erfolgreich gespeichert",
      "saveError": "Vorlage konnte nicht gespeichert werden",
      "sendTest": "Test-E-Mail senden",
      "testSuccess": "Test-E-Mail gesendet",
      "testError": "Test-E-Mail konnte nicht gesendet werden"
    },
    "downloadRestrictions": {
      "title": "Laden Sie die Verschlüsselungsdurchsetzung herunter",
      "description": "Kontrollieren Sie die Einstellungen für Downloadbeschränkungen für alle Mitglieder. Dazu gehört die Durchsetzung der Verschlüsselung bei Downloads, die Anwendung spezifischer Regeln für externe Benutzer und das Überschreiben dieser Einstellungen basierend auf Datei-Tags.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Erzwingen Sie die Download-Verschlüsselung für Mitglieder, die bereits über Download-Berechtigungen verfügen, entweder weil sie Eigentümer sind oder Bearbeitungsberechtigungen erhalten haben. Wenn die Funktion nicht aktiviert ist, funktionieren Downloads ggf. normal.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "externalUserEnforcementTitle": "Durchsetzung externer Benutzer",
      "externalUserEnforcementDescription": "Erzwingen Sie die Download-Verschlüsselung für alle externen Benutzer",
      "tagBasedEncryptionTitle": "Tag-basierte Verschlüsselung",
      "tagBasedEncryptionDescription": "Verschlüsselten Download mit bestimmten Tags erzwingen",
      "tagBasedEncryptionPlaceholder": "Tags (durch Kommas getrennt), z. B. 'vertraulich, geheim'",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich"
    },
    "downloadAllowedTags": {
      "title": "Laden Sie erlaubte Tags herunter",
      "description": "Ermöglicht Mitgliedern das Herunterladen von Dokumenten, die mit schreibgeschützten Berechtigungen geteilt werden.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "externalUserEnforcementTitle": "Durchsetzung externer Benutzer",
      "externalUserEnforcementDescription": "Erzwingen Sie die Download-Verschlüsselung für alle externen Benutzer",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Aktivieren Sie den Download für schreibgeschützte Dateien nur für Dateien mit diesen Tags.",
      "tagsPlaceholder": "Tags (durch Kommas getrennt), z. B. 'vertraulich, geheim'",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich"
    },
    "forcedAntiCaptureMode": {
      "title": "Erzwungener Anti-Capture-Modus",
      "description": "Erzwingen Sie die Anzeige freigegebener Dateien mit bestimmten Tags nur im Anti-Capture-Modus.",
      "forcedAntiCaptureModeTitle": "Anticapture-Durchsetzung",
      "forcedAntiCaptureModeDescription": "Wählen Sie aus, ob Anti-Capture auf alle oder keine angewendet werden soll. Durch die Aktivierung von Anti-Capture werden auch sichere Dateidownloads aktiviert.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "tagBasedEncryptionTitle": "Tag-basierte Verschlüsselung",
      "tagBasedEncryptionDescription": "Wenden Sie diese Regel nur auf Dateien mit bestimmten Tags an"
    },
    "aiTagging": {
      "title": "KI-Tagging",
      "description": "Aktivieren Sie AI-Tagging für Dateien. Dadurch werden Dateien automatisch anhand ihres Inhalts markiert.",
      "descriptionInternal": "Aktivieren Sie AI-Tagging für Dateien. Dadurch werden Dateien automatisch anhand ihres Inhalts markiert. <DangerText>Hinweis: Dies gilt nur für Dateien, die kleiner als 250 MB sind. Änderungen an diesen Einstellungen werden NICHT rückwirkend angewendet, was bedeutet, dass Dateien mit vorhandenen Tags nicht automatisch klassifiziert werden.</DangerText>",
      "isRuleEnabledTitle": "Aktivieren Sie die AI-Tagging-Regel",
      "isRuleEnabledDescription": "Ermöglichen Sie Benutzern (Administratoren und Mitwirkenden), die KI ihre Dateien anhand ihres Inhalts mit Tags versehen zu lassen.",
      "isAutomaticClassificationEnabledTitle": "Aktivieren Sie die automatische Klassifizierung",
      "isAutomaticClassificationEnabledDescription": "Aktivieren Sie die automatische Klassifizierung von Dateien basierend auf ihrem Inhalt.",
      "ruleTargetTitle": "Regelziel",
      "ruleTargetDescription": "Wählen Sie das Ziel der Regel aus.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regel nur auf Dateien mit bestimmten Tags an",
      "aiAgentTitle": "KI-Agent",
      "aiAgentDescription": "Wählen Sie den KI-Agenten aus, der zum Markieren von Dateien verwendet werden soll.",
      "aiAgentPlaceholder": "Wählen Sie einen KI-Agenten aus",
      "membersTitle": "Wer kann mit dem ausgewählten Agenten klassifizieren?",
      "membersDescription": "Wählen Sie aus, für welche Mitglieder der ausgewählte Agent gilt.",
      "exceptionsTitle": "Ausnahmen verwalten",
      "exceptionsDescription": "Fügen Sie Benutzer hinzu, für die Sie keine automatische Klassifizierung wünschen",
      "exceptionsButtonText": "Benutzer verwalten",
      "filesTypeTitle": "Dateierweiterungsverwaltung",
      "filesTypeDescription": "Geben Sie die Dateierweiterungen an, die vom Agenten klassifiziert werden sollen.",
      "externalUserTitle": "Externer Benutzer",
      "externalUserDescription": "Klassifizierung durch externe Benutzer zulassen.",
      "filesTypePlaceholder": "Bitte wählen Sie eine oder mehrere aus",
      "folderIdsTitle": "Zu klassifizierende Ordner",
      "folderIdsDescription": "Wählen Sie die Ordner aus, die vom ausgewählten Agenten klassifiziert werden sollen."
    },
    "singleSignOn": {
      "title": "Einmaliges Anmelden (SSO)",
      "enableTitle": "Aktivieren Sie Single Sign-On",
      "description": "Aktivieren Sie Single Sign-On (SSO) für Ihre Organisation. Dadurch können sich Ihre Benutzer mit ihren vorhandenen Anmeldeinformationen von einem unterstützten Identitätsanbieter bei Filegrant Enterprise anmelden.",
      "providers": "Anbieter",
      "providersDescription": "Wählen Sie die Anbieter aus, die Sie für Single Sign-On aktivieren möchten (SSO).",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "CyberGrant",
      "notificationSsoEnableMessage": "Die Single Sign-On-Funktion (SSO) wird aktiviert. Dieser Vorgang kann einige Minuten dauern. Bitte bleiben Sie auf dieser Seite, bis der Vorgang abgeschlossen ist.",
      "notificationSsoEnabledMessage": "Die Single Sign-On-Funktion (SSO) wurde erfolgreich aktiviert.",
      "copyRedirectUriHint": "Kopieren Sie es und fügen Sie es in die Konfiguration Ihres IdP ein.",
      "redirectUri": "Umleitungs-URI",
      "copyRedirectUriDesc": "Kopieren Sie es und fügen Sie es in die Konfiguration Ihres IdP ein.",
      "notificationSsoEnableTimeout": "Fehler beim Aktivieren von SSO",
      "notificationSsoEnableTimeoutDesc": "Die Funktion Single Sign-On (SSO) konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.",
      "domainAlreadySet": "Diese Domäne ist bereits festgelegt",
      "mobileRedirectUri": "Mobile-Redirect-URI",
      "mobileRedirectUriHint": "Fügen Sie diesen Umleitungs-URI nur hinzu, wenn Sie SSO in der mobilen App aktivieren möchten.",
      "clientCertificate": "Clientzertifikat",
      "certificateInUse": "Zertifikat in Verwendung",
      "certificateThumbprint": "Fingerabdruck",
      "certificateExpiresAt": "Läuft ab",
      "certificateExpired": "Dieses Zertifikat ist am {{date}} abgelaufen. SSO-Anmeldung und Entra-ID-Sync schlagen fehl, bis Sie es ersetzen.",
      "certificateExpiringSoon": "Dieses Zertifikat läuft am {{date}} ab (in {{days}} Tagen).",
      "certificateTooLarge": "Die Zertifikatdatei ist zu groß. Verwenden Sie ein PKCS#12 (.pfx/.p12) unter dem Größenlimit.",
      "certificateReadyToUpload": "Neues Zertifikat ausgewählt. Geben Sie das Passwort ein (leer lassen, falls keines) und speichern Sie.",
      "uploadCertificate": "Zertifikat hochladen",
      "replaceCertificate": "Zertifikat ersetzen",
      "clearCertificate": "Zertifikat entfernen",
      "certificatePassword": "Zertifikatpasswort",
      "certificatePasswordHint": "PKCS#12-Passwort bei jedem neuen Upload eingeben; das gespeicherte Passwort wird nie wiederverwendet. Leer lassen, wenn die Datei kein Passwort hat.",
      "certificatePasswordPlaceholder": "PKCS#12-Passwort (optional)",
      "noCredentialsWarning": "Weder Client Secret noch Zertifikat konfiguriert. Fügen Sie mindestens eine Anmeldeinformation hinzu, bevor Sie diesen Anbieter aktivieren.",
      "clientIdChangeWarning": "Client-ID geändert. Senden Sie ein neues Client Secret und/oder laden Sie das Zertifikat erneut hoch, sonst werden maskierte Anmeldeinformationen gelöscht.",
      "clientIdChangeBlocksSave": "Speichern nicht möglich: Client-ID geändert bei beibehaltenen maskierten Anmeldeinformationen",
      "clientIdChangeBlocksSaveHint": "Microsoft-Konfiguration {{index}}: Geben Sie ein neues Client Secret ein und/oder laden Sie ein Zertifikat hoch, bevor Sie speichern.",
      "certificateProblemEntry": "{{provider}} — Konfiguration {{index}}: {{message}}",
      "errors": {
        "certificateInvalid": "Das Clientzertifikat konnte nicht akzeptiert werden",
        "certificateNotSupported": "Zertifikate werden für diesen Anbieter nicht unterstützt",
        "invalidConfiguration": "Ungültige Single-Sign-On-Konfiguration"
      }
    },
    "fileDeletionRestriction": {
      "title": "Einschränkung beim Löschen von Dateien",
      "description": "Ermöglichen Sie eine detaillierte Kontrolle über das Löschen von Dateien durch Benutzer. Mit dieser Einstellung können Sie Löschberechtigungen basierend auf der Rolle des Benutzers in Bezug auf die Datei definieren: Ersteller, Eigentümer oder Empfänger. Dies sorgt für klare und sichere Content-Management-Regeln, verhindert unbefugte Löschungen und unterstützt die Einhaltung von Unternehmensrichtlinien.",
      "allowDeletionFor": "Löschen zulassen für",
      "allowDeletionForDescription": "Wählen Sie, ob alle oder keiner der Benutzer Dateien löschen darf.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "fileAccessTypeTitle": "Autorisierte Zugriffstypen",
      "fileAccessTypeDescription": "Wählen Sie die Arten des Datei-/Ordnerzugriffs aus, die zum Löschen der Datei berechtigt sind.",
      "owner": "Eigentümer",
      "creator": "Schöpfer",
      "receiver": "Empfänger"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Sichtbarkeit registrierter Mitglieder durch den Administrator",
      "description": "Steuern Sie die Sichtbarkeit von als Administrator registrierten Mitgliedern oder Gruppen für Benutzer. Zu den Optionen gehört es, allen Benutzern zu erlauben, vom Administrator registrierte Benutzer oder keine zu sehen. Die Sichtbarkeit erfolgt hauptsächlich durch Dateifreigabe. Wenn ein Benutzer eine Datei mit einer E-Mail-Adresse teilt, die einem als Administrator registrierten Mitglied entspricht, sieht der Benutzer nach der Freigabe den Vor- und Nachnamen des Mitglieds, auch wenn der Benutzer gemäß dieser Einstellung nicht über die Berechtigung zum Anzeigen von als Administrator registrierten Benutzern verfügt. Diese Einschränkung gilt nicht für Benutzer oder Gruppen, denen der Status Privat zugewiesen wurde.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "sectionTitle": "Sichtbarkeitseinschränkungen für Benutzer",
      "visibilityTitle": "Sichtbarkeit für vom Administrator registrierte Mitglieder",
      "visibilityDescription": "Steuern Sie die Sichtbarkeit von als Administrator registrierten Mitgliedern oder Gruppen für Benutzer. Zu den Optionen gehört es, allen Benutzern zu erlauben, vom Administrator registrierte Benutzer oder keine zu sehen. Die Sichtbarkeit erfolgt hauptsächlich durch Dateifreigabe. Wenn ein Benutzer eine Datei mit einer E-Mail-Adresse teilt, die einem als Administrator registrierten Mitglied entspricht, sieht der Benutzer nach der Freigabe den Vor- und Nachnamen des Mitglieds, auch wenn der Benutzer gemäß dieser Einstellung nicht über die Berechtigung zum Anzeigen von als Administrator registrierten Benutzern verfügt. Diese Einschränkung gilt nicht für Benutzer oder Gruppen, denen der Status Privat zugewiesen wurde."
    },
    "aiFileSummary": {
      "title": "Zusammenfassung der AI-Datei",
      "description": "Aktivieren Sie die AI-Dateizusammenfassung für Dateien. Dadurch wird automatisch eine Zusammenfassung der Datei basierend auf ihrem Inhalt erstellt.",
      "descriptionInternal": "Aktivieren Sie die AI-Dateizusammenfassung für Dateien. Dadurch wird automatisch eine Zusammenfassung der Datei basierend auf ihrem Inhalt erstellt. <DangerText>Hinweis: Dies gilt nur für Dateien, die kleiner als 250 MB sind.</DangerText>",
      "activeForAllTitle": "Zugriff auf die AI-Dateizusammenfassung",
      "activeForAllDescription": "Wählen Sie, ob die von der KI generierten Dateizusammenfassungen allen Benutzern oder keinem zur Verfügung stehen.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "externalUserTitle": "Externer Benutzer",
      "externalUserDescription": "Erlauben Sie die Erstellung von Zusammenfassungen durch externe Benutzer.",
      "filesTypeTitle": "Dateierweiterungsverwaltung",
      "filesTypeDescription": "Geben Sie die Dateierweiterungen an, die von der KI zusammengefasst werden sollen.",
      "filesTypePlaceholder": "Bitte wählen Sie eine oder mehrere aus"
    },
    "aiFileChat": {
      "title": "AI-Datei-Chat",
      "description": "Aktivieren Sie den AI-Datei-Chat für Dateien. Dadurch können Benutzer mit dem Dateiinhalt chatten.",
      "descriptionInternal": "Aktivieren Sie den AI-Datei-Chat für Dateien. Dadurch können Benutzer mit dem Dateiinhalt chatten. <DangerText>Hinweis: Dies gilt nur für Dateien, die kleiner als 250 MB sind.</DangerText>",
      "activeForAllTitle": "Zugriff auf AI File Chat",
      "activeForAllDescription": "Wählen Sie, ob der KI-generierte Datei-Chat allen Benutzern oder keinem zur Verfügung steht.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "externalUserTitle": "Externer Benutzer",
      "externalUserDescription": "Chatten mit Dateiinhalten durch externe Benutzer zulassen.",
      "filesTypeTitle": "Dateierweiterungsverwaltung",
      "filesTypeDescription": "Geben Sie die Dateierweiterungen an, mit denen Sie mit der KI chatten möchten.",
      "filesTypePlaceholder": "Bitte wählen Sie eine oder mehrere aus"
    },
    "aiScraping": {
      "title": "KI-Scraping",
      "description": "Verweigern Sie das KI-Scraping nach Dateien. Dadurch wird verhindert, dass ein KI-Tool den Dateiinhalt auswertet.",
      "descriptionInternal": "Verweigern Sie das KI-Scraping nach Dateien. Dadurch wird verhindert, dass ein KI-Tool den Dateiinhalt auswertet. <DangerText>Hinweis: AI-Scraping wird nur auf Dateien angewendet, die im schreibgeschützten Modus geöffnet sind und kleiner als 250 MB sind. Der Scraping-Schutz ist derzeit nur für PDF- und Office-Dateien aktiv.</DangerText>",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "externalUserTitle": "Externer Benutzer",
      "externalUserDescription": "Ermöglichen Sie das Scrapen des Dateiinhalts durch externe Benutzer.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "onBehalfMode": {
      "title": "Im Namensmodus",
      "description": "Steuern Sie den Im-Namen-Modus für die Plattform. Auf diese Weise können Sie angeben, welche Mitwirkenden im Namen anderer Mitwirkender Aktionen durchführen können.",
      "internalTitle": "Admin-Aktionen im Namen von Benutzern",
      "internalDescription": "Autorisierte Administratoren können die Liste der Mitwirkendendateien einsehen und im Namen der Benutzer notwendige Aktionen wie das Verschieben, Löschen oder Freigeben von Dateien durchführen. Sie können die Dateien jedoch nicht öffnen oder deren Inhalte anzeigen, um die Privatsphäre der Benutzer zu wahren. Nur der Superadministrator hat die Berechtigung, diese Funktion für einzelne Administratoren zu aktivieren oder zu deaktivieren. Dadurch wird sichergestellt, dass nur vertrauenswürdige Administratoren die Möglichkeit haben, Benutzerdateien zu verwalten",
      "activeForAllTitle": "Admins-Bereich",
      "activeForAllDescription": "Steuern Sie die Möglichkeit, zu definieren, ob Administratoren Aktionen im Namen aller oder keiner Benutzer ausführen können. Mit dieser Einstellung können Sie angeben, ob Administratoren die Berechtigung haben, Dateien zu verwalten und Aufgaben im Namen anderer Benutzer innerhalb der Plattform auszuführen.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Hier ausgewählte Administratoren sind von den oben genannten „im Namen“-Berechtigungen ausgenommen."
    },
    "fileSalesPermission": {
      "title": "Erlaubnis zum Dateiverkauf",
      "description": "Ermöglichen Sie Benutzern, ihre eigenen Dateien über die Plattform zu verkaufen.",
      "internalTitle": "Aktivieren Sie den Dateiverkauf für Mitglieder",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Ermöglichen Sie Mitgliedern, ihre eigenen Dateien über die Plattform zu verkaufen. Zu den Optionen gehört die Aktivierung dieser Funktion für alle oder keine Mitglieder. Zum Verkauf angebotene Dateien werden von der Plattform verwaltet, um sichere Transaktionen und eine ordnungsgemäße Zahlungsabwicklung zu gewährleisten.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "externalUserTitle": "Externer Benutzer",
      "externalUserDescription": "Dateiverkauf durch externe Benutzer zulassen."
    },
    "resharingPermission": {
      "title": "Berechtigung zum erneuten Teilen von Dateien",
      "description": "Ermöglichen Sie Benutzern das erneute Teilen von Dateien mit anderen und erzwingen Sie gleichzeitig Regeln basierend auf vordefinierten Optionen und den auf jede Datei angewendeten Tags. Dies stellt eine kontrollierte Verteilung von Inhalten sicher und trägt zur Einhaltung der Unternehmensrichtlinien bei.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer Einschränkungen beim Teilen von Dateien mit bestimmten, vom Administrator festgelegten Optionen und Tags unterliegen. Zu den Optionen gehört die Anwendung dieser Berechtigung auf alle oder keine Benutzer. Vorhandene Dateien, die bereits freigegeben wurden, bleiben aktiv und Änderungen an Tags wirken sich nicht auf diese zuvor freigegebenen Dateien aus.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Regel ausgenommen sind.",
      "showUsers": "Zeigen Sie Benutzer an, denen bereits von anderen Zugriff gewährt wurde.",
      "allowEdit": "Ermöglicht Benutzern das Ändern, Überschreiben oder Löschen bestehender Freigabeeinstellungen.",
      "readOnly": "Ermöglichen Sie die Dateifreigabe durch Benutzer mit schreibgeschütztem Zugriff (Viewer).",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "fileVersioningRetentionPolicies": {
      "title": "Dateiversionierung",
      "description": "Konfigurieren Sie, wie Dateiversionen beibehalten werden. Der Aufbewahrungszähler ist erforderlich, während das Aufbewahrungsalter optional ist und auf 0 gesetzt werden kann.",
      "retentionByCountTitle": "Zurückbehaltung durch Graf",
      "retentionByCountDescription": "Aufbewahrung nach Anzahl festlegen – nur die letzten N Versionen jeder Datei behalten; Ältere Versionen werden automatisch gelöscht, sobald dieses Limit erreicht ist",
      "retentionByAgeTitle": "Aufbewahrung nach Alter",
      "retentionByAgeDescription": "Aufbewahrung nach Alter festlegen – Versionen löschen, die älter als N Tage sind; Jeder Snapshot, der dieses Alter überschreitet, wird automatisch gelöscht, um eine Überlastung des Speichers zu verhindern"
    },
    "retentionPolicies": {
      "title": "Aufbewahrungsrichtlinien",
      "description": "Konfigurieren Sie, wie lange Dateien auf der Plattform aufbewahrt werden. Verwalten Sie das automatische Löschen aus dem Papierkorb und definieren Sie Aufbewahrungsregeln für aktive Dateien.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "trash": {
        "title": "Müllaufbewahrung",
        "description": "In den Papierkorb verschobene Dateien werden nach der konfigurierten Anzahl von Tagen dauerhaft gelöscht.",
        "activeForAllTitle": "Aufbewahrungsbereich für den Papierkorb",
        "activeForAllDescription": "Wählen Sie aus, ob die Papierkorbaufbewahrung für alle Benutzer oder für keinen gilt. Die unten aufgeführten Richtlinienwerte können weiterhin bearbeitet werden. Verwenden Sie die Ausnahmeliste, um bestimmte Benutzer oder Gruppen auszuschließen.",
        "retentionDaysTitle": "Tage im Müll",
        "retentionDaysDescription": "Tage, die eine Datei im Papierkorb verbleibt, bevor sie endgültig gelöscht wird. Muss größer als 0 sein.",
        "exceptionHandlingDescription": "Benutzer und Gruppen in dieser Liste unterliegen nicht der Aufbewahrung im Papierkorb; Ihre Dateien bleiben auf unbestimmte Zeit im Papierkorb."
      },
      "files": {
        "title": "Aufbewahrung von Dateien",
        "description": "Wenden Sie eine Aufbewahrungsregel auf aktive Dateien an. Die Aufbewahrungsfrist beginnt mit dem Datum, das Sie unten wählen (Erstellung oder letzte Änderung).",
        "activeForAllTitle": "Dateiaufbewahrungsbereich",
        "activeForAllDescription": "Wählen Sie, ob die Dateiaufbewahrung für alle Benutzer oder für keinen gilt. Die unten aufgeführten Richtlinienwerte können weiterhin bearbeitet werden. Verwenden Sie die Ausnahmeliste, um bestimmte Benutzer oder Gruppen auszuschließen.",
        "retentionDaysTitle": "Aufbewahrungsfrist (Tage)",
        "retentionDaysDescription": "Anzahl der Tage nach dem ausgewählten Referenzdatum (Erstellung oder Änderung), nach denen die Aktion ausgelöst wird. Muss größer als 0 sein.",
        "retentionTriggerTitle": "Zählen Sie die Aufbewahrung ab",
        "retentionTriggerDescription": "Wählen Sie aus, ob der Aufbewahrungszeitraum ab dem Zeitpunkt der Dateierstellung oder der letzten Änderung berechnet wird.",
        "retentionTrigger": {
          "created_at": "Erstellungsdatum der Datei",
          "updated_at": "Letztes Änderungsdatum"
        },
        "actionOnExpiryTitle": "Aktion bei Ablauf",
        "actionOnExpiryDescription": "Was passiert mit Dateien, die die Aufbewahrungsfrist überschreiten?",
        "actionOnExpiry": {
          "MoveToTrash": "In den Papierkorb verschieben",
          "DeletePermanently": "Dauerhaft löschen",
          "RetainedTagWorkflow": "*RETAINED-Tag anwenden und dann löschen"
        },
        "retainedTag": {
          "title": "So funktioniert das *RETAINED-Tag",
          "step1": "Wenn Sie diese Richtlinie speichern, erstellt der Server ein System-Tag mit dem Namen *RETAINED (sichtbar in der Tag-Liste des Unternehmens, aber schreibgeschützt).",
          "step2": "Nach Ablauf der oben genannten Aufbewahrungsfrist wird das Tag *RETAINED automatisch auf jede Datei angewendet, die vor mehr als so vielen Tagen erstellt wurde.",
          "step3": "Sobald die Datei markiert ist, bleibt sie zugänglich, aber das Tag kann von niemandem entfernt werden: Die Benutzeroberfläche verbirgt die Trennsteuerung und der Server lehnt jeden Versuch ab, ein System-Tag zu löschen.",
          "step4": "Wenn seit der Anwendung des Tags die unten festgelegten Tage verstrichen sind, wird die Datei dauerhaft gelöscht (Datenbank + Speicher). Fügen Sie Benutzer oder Gruppen zu den Ausnahmen hinzu, um sie vom gesamten Ablauf auszuschließen."
        },
        "retainedTagDaysTitle": "Tage mit *RETAINED-Tag",
        "retainedTagDaysDescription": "Nachdem das Tag *RETAINED angewendet wurde, werden Dateien nach dieser Anzahl von Tagen endgültig gelöscht. Muss größer als 0 sein.",
        "tagsTitle": "Nur auf Dateien mit diesen Tags anwenden",
        "tagsDescription": "Lassen Sie das Feld leer, um die Richtlinie auf alle Dateien anzuwenden. Es werden nur öffentliche Tags unterstützt.",
        "exceptionHandlingDescription": "Benutzer und Gruppen in dieser Liste unterliegen nicht der Dateiaufbewahrung; Ihre Dateien werden niemals in den Papierkorb verschoben, gelöscht oder mit *RETAINED gekennzeichnet."
      },
      "deletePermanentlyConfirm": {
        "title": "Bestätigen Sie die Richtlinie zum dauerhaften Löschen",
        "description": "<DangerText>Diese Aktion löscht dauerhaft alle Unternehmensdateien, die den Aufbewahrungszeitraum überschreiten. Dieser Vorgang ist nicht rückgängig zu machen.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Bestätigen Sie die dauerhafte Löschung",
        "description": "Wenn diese Aktion ausgewählt wird, werden Dateien, die den Aufbewahrungszeitraum überschreiten, dauerhaft gelöscht. <DangerText>Dies kann nicht rückgängig gemacht werden und gelöschte Dateien können nicht wiederhergestellt werden.</DangerText><br></br>Um fortzufahren, geben Sie <DangerText>{{confirmKeyword}}</DangerText> in das Feld unten ein."
      },
      "errors": {
        "trashRetentionDays": "Tage im Papierkorb müssen größer als 0 sein.",
        "retentionDays": "Der Aufbewahrungszeitraum muss größer als 0 sein.",
        "retainedTagDays": "Tage mit dem Tag *RETAINED müssen größer als 0 sein."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Gemeinsame Datei mit obligatorischem Ablauf",
      "description": "Kontrollieren Sie den obligatorischen Ablauf freigegebener Dateien. Dadurch können Sie festlegen, welche freigegebenen Dateien ein Ablaufdatum haben müssen.",
      "descriptionInternal": "In diesem Abschnitt werden zeitliche Beschränkungen für die Dateifreigabe festgelegt, um einen unbegrenzten Zugriff zu verhindern. Administratoren können für jede freigegebene Datei ein Ablaufdatum festlegen, eine maximal zulässige Dauer festlegen und Freigaben ohne Ablaufdatum blockieren. Diese Regeln stellen sicher, dass der gemeinsame Zugriff vorübergehend ist und den Sicherheits- und Compliance-Anforderungen entspricht. <DangerText> Änderungen an diesen Einstellungen werden NICHT rückwirkend angewendet, was bedeutet, dass bestehende Freigaben, die die neuen Grenzwerte überschreiten, NICHT aktualisiert werden.</DangerText>",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "maxAllowedByAgeTitle": "Maximal zulässige Dauer",
      "maxAllowedByAgeDescription": "Legt eine maximale Dauer (z. B. 90 Tage) für jede Dateifreigabe fest.",
      "excludedDomainsTitle": "Ausgeschlossene Domänen",
      "excludedDomainsDescription": "Für Freigaben für genau diese Domains ist kein Ablaufdatum erforderlich. Geben Sie nur Domänen ein (z. B. unternehmen.com), ohne Platzhalter oder URL. Für keine Ausnahme leer lassen.",
      "excludedDomainsPlaceholder": "Keine ausgeschlossenen Domänen, klicken Sie zum Hinzufügen",
      "excludedGroupsTitle": "Ausgeschlossene Gruppen",
      "excludedGroupsDescription": "Gruppenaktien können vom Zwangsverfall ausgenommen werden. Wählen Sie „Keine“, „Alle Gruppen“ oder „Bestimmte Gruppen“ aus. Durch die Benutzermitgliedschaft in einer ausgenommenen Gruppe sind einzelne Benutzerfreigaben nicht ausgenommen.",
      "excludedGroupsModeNone": "Keine Gruppen ausgenommen",
      "excludedGroupsModeAll": "Alle Gruppen ausgenommen",
      "excludedGroupsModeSome": "Nur ausgewählte Gruppen ausgenommen",
      "excludedGroupsPlaceholder": "Wählen Sie ausgenommene Gruppen aus",
      "excludedGroupsExceptionsTitle": "Gruppen, die unterworfen bleiben",
      "excludedGroupsExceptionsPlaceholder": "Wählen Sie Gruppen aus, die noch ablaufen müssen",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wendet die maximale Freigabezeitbegrenzung nur auf Dateien mit bestimmten Tags an.",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "fileTagManagement": {
      "title": "Regeln zum Entfernen von Tags",
      "description": "Legen Sie fest, welche Tags nicht aus Dateien entfernt werden können. Benutzer, auf die sich eine Regel bezieht, können die ausgewählten Tags nicht aus Dateien entfernen; Ausnahmen von der Regel können pro Benutzer oder Gruppe gewährt werden.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen beim Entfernen von Tags unterliegen. Vorhandene Tags für Dateien bleiben unverändert und Berechtigungsaktualisierungen wirken sich nicht auf zuvor angewendete Tags aus.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Regel ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Tags, die nicht aus Dateien entfernt werden können. Leer lassen, um alle Tags zu schützen.",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich"
    },
    "fileTagAdditionRestriction": {
      "title": "Regeln zum Hinzufügen von Tags",
      "description": "Definieren Sie, welche Tags nicht zu Dateien hinzugefügt werden können. Benutzer, auf die sich eine Regel bezieht, können die ausgewählten Tags nicht zu Dateien hinzufügen; Ausnahmen von der Regel können pro Benutzer oder Gruppe gewährt werden.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Regel ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Tags, die nicht zu Dateien hinzugefügt werden können. Lassen Sie das Feld leer, um alle Tags einzuschränken.",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich"
    },
    "externalFileSharingRestriction": {
      "title": "Externe Freigabebeschränkungen",
      "description": "In diesem Abschnitt können Administratoren entscheiden, ob und unter welchen Bedingungen Mitwirkende Dateien außerhalb der Organisation teilen können. Die Freigabe kann vollständig aktiviert, deaktiviert oder auf bestimmte vertrauenswürdige Domänen beschränkt werden. Regeln können auch die externe Freigabe basierend auf Datei-Tags einschränken oder es bestimmten Absendern und Empfängern ermöglichen, DLP-Richtlinien (Data Loss Prevention) zu umgehen. Diese Kontrollen tragen dazu bei, vertrauliche Informationen zu schützen und sicherzustellen, dass externe Kooperationen nur mit genehmigten Parteien stattfinden.",
      "descriptionInternal": "In diesem Abschnitt können Administratoren entscheiden, ob und unter welchen Bedingungen Mitwirkende Dateien außerhalb der Organisation teilen können. Die Freigabe kann vollständig aktiviert, deaktiviert oder auf bestimmte vertrauenswürdige Domänen beschränkt werden. Regeln können auch die externe Freigabe basierend auf Datei-Tags einschränken oder es bestimmten Absendern und Empfängern ermöglichen, DLP-Richtlinien (Data Loss Prevention) zu umgehen. Diese Kontrollen tragen dazu bei, vertrauliche Informationen zu schützen und sicherzustellen, dass externe Kooperationen nur mit genehmigten Parteien stattfinden.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von der oben genannten Regel ausgenommen sind.",
      "approvedDomainsTitle": "Nur genehmigte Domänen",
      "approvedDomainsDescription": "Beschränkt die Freigabe auf eine Liste vorab genehmigter Domänen.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Ermöglicht die Freigabe mit externen Domänen nur für Dateien, die über bestimmte Tags verfügen.",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "approvedDomainsPlaceholder": "Keine Domains genehmigt, klicken Sie zum Hinzufügen"
    },
    "secureFileLocalAccess": {
      "title": "Sicherer lokaler Dateizugriff",
      "description": "Kontrollieren Sie den sicheren lokalen Zugriff auf Dateien. Dadurch können Sie festlegen, auf welche Dateien lokal zugegriffen werden kann.",
      "descriptionInternal": "Diese Einstellung definiert, wie Dokumente lokal (unter Windows oder macOS) über den Agent sicher und verschlüsselt geöffnet werden können. Wenn ein Benutzer über die erforderlichen Berechtigungen verfügt, kann er geschützte Dateien mit den autorisierten Anwendungen öffnen und so die Einhaltung der Data Loss Prevention-Richtlinien sicherstellen.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von der oben genannten Regel ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "restrictionsTitle": "Einschränkungen",
      "restrictionsDescription": "Legen Sie fest, welche Benutzeraktionen beim Zugriff auf geschützte Dokumente eingeschränkt sind:",
      "restrictCopyPaste": "Beschränken Sie Kopier- und Einfügevorgänge",
      "restrictCopyPasteDescription": "Beschränken Sie Kopier- und Einfügevorgänge für Dateien mit bestimmten Tags.",
      "restrictPrint": "Drucken einschränken",
      "restrictPrintDescription": "Beschränken Sie das Drucken für Dateien mit bestimmten Tags.",
      "restrictAppInternetAccess": "Beschränken Sie den Internetzugang der App",
      "restrictAppInternetAccessDescription": "Beschränken Sie den Internetzugang der App für Dateien mit bestimmten Tags.",
      "restrictScreenCapture": "Bildschirmaufnahme einschränken",
      "restrictScreenCaptureDescription": "Beschränken Sie die Bildschirmaufnahme für Dateien mit bestimmten Tags.",
      "localAccessSettingsTitle": "Lokale Zugriffseinstellungen",
      "localAccessSettingsDescription": "Konfigurieren Sie, wie Benutzer geschützte Dateien auf ihren Geräten öffnen und damit arbeiten können:",
      "defaultLocalFileOpen": "Standardmäßiges Öffnen lokaler Dateien",
      "defaultLocalFileOpenDescription": "Wählen Sie, ob geschützte Dateien mit der Standardanwendung oder mit der im Feld „Zulässige Anwendungen“ angegebenen Anwendung geöffnet werden sollen.",
      "allowedApplicationsTitle": "Zulässige Anwendungen",
      "allowedApplicationsDescription": "Wählen Sie die Anwendungen aus, die geschützte Dateien öffnen dürfen.",
      "offlineMode": "Ermöglicht den Dateizugriff, wenn keine Internetverbindung verfügbar ist",
      "offlineModeDescription": "Die lokale Speicherung des Zertifikats ermöglicht die Offline-Entschlüsselung von Dateien. Dateiinhalte können offengelegt werden, wenn der lokale Benutzer Zugriff auf das gespeicherte Zertifikat hat"
    },
    "tagBasedAccessControl": {
      "title": "Sichtbarkeit markierter Dateien",
      "description": "Verwalten Sie den Dokumentenzugriff mit Tags (z. B. Öffentlich) und gewähren Sie allen Benutzern oder externen Gästen Sichtbarkeit mit optionalen Lese-/Schreibrechten und Passwortschutz.",
      "descriptionInternal": "Steuern Sie den Zugriff auf Dokumente mithilfe von Benutzer- oder Gruppen-Tags, um die Suche und Richtlinienverwaltung zu vereinfachen. Tags (z. B. „Öffentlich“) können angewendet werden, um eine umfassendere Sichtbarkeit zu ermöglichen, entweder für alle registrierten Benutzer (Internal Public) oder für externe, nicht authentifizierte Benutzer (Every One), mit optionalen Lese- oder Lese-/Schreibberechtigungen und Passwortschutz.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von der oben genannten Regel ausgenommen sind.",
      "audienceTitle": "Publikum",
      "audienceDescription": "Legen Sie fest, wer auf getaggte Dokumente zugreifen darf.",
      "registeredUsers": "Registrierte Benutzer",
      "unregisteredUsers": "Nicht registrierte Benutzer",
      "admin": "Admin",
      "contributors": "Mitwirkende",
      "readers": "Leser",
      "external": "Extern",
      "readAndWrite": "Lesen und schreiben",
      "readOnly": "Nur lesen",
      "passwordRequired": "Für den Zugriff ist ein Passwort erforderlich",
      "setLinkExpiration": "Linkablauf festlegen (Datum/Uhrzeit)",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Ermöglicht die Freigabe mit externen Domänen nur für Dateien, die über bestimmte Tags verfügen.",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "accessPolicyTagsRequired": "Zugriffsrichtlinien-Tags sind erforderlich"
    },
    "contributorStorageLimit": {
      "title": "Speicherbeschränkungen",
      "allocationTitle": "Speicherzuweisung für Mitwirkende",
      "allocationDescription": "Definieren Sie den Speicherplatz, der Mitwirkenden zum Hochladen und Teilen von Dateien zur Verfügung steht. Mit dieser Option können Sie bestimmte Speichergrenzen für Mitwirkende festlegen oder „Lizenzbegrenzt“ für den Speicher wählen, der an den Gesamtspeicherplatz gebunden ist, den das Unternehmen im Rahmen seiner Lizenz erworben hat."
    },
    "deviceAccessLimitation": {
      "title": "Umgang mit gleichzeitigen Verbindungen",
      "browsersTitle": "Browser",
      "browsersDescription": "Stellen Sie die Anzahl der gleichzeitigen Verbindungen, die jedes Mitglied über verschiedene Browser mithilfe der Webanwendung herstellen kann, auf Filegrant Enterprise ein",
      "exceedingConnectionsTitle": "Überschreitung der Browserverbindungen",
      "exceedingConnectionsDescription": "Geben Sie die Aktion an, die ausgeführt werden soll, wenn die Anzahl der verbundenen Browser den zulässigen Grenzwert überschreitet.",
      "invalidateOldSessionsOption": "Das Sitzungstoken der ältesten Verbindungen automatisch ungültig machen.",
      "blockAccessOption": "Verweigern Sie den Zugriff, bis ältere Sitzungen manuell getrennt werden oder ablaufen."
    },
    "editorFileManagement": {
      "title": "Kontrolle der Dateiverwaltung für Mitwirkende",
      "subtitle": "Steuern Sie die Berechtigungen für Mitwirkende zum Löschen und Umbenennen von Dateien und Ordnern in ihren Konten. Zu den Optionen gehört das Zulassen aller oder keiner Mitwirkenden, wobei die Aktionen auf Dateien beschränkt sind, die sie hochgeladen oder mit Editor-Zugriff erhalten haben.",
      "deletionPermissionsTitle": "Löschberechtigungen",
      "deletionPermissionsDescription": "Steuern Sie, ob Mitwirkende Dateien löschen können. Zu den Optionen gehört es, Mitwirkenden zu erlauben oder zu verbieten, Dateien zu löschen, die sie hochgeladen oder mit Editor-Zugriff erhalten haben.",
      "userScopeTitle": "Benutzerumfang",
      "userScopeDescription": "Steuern Sie die Anwendung der oben genannten Berechtigungen auf alle oder keine Mitwirkenden.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von den oben genannten Berechtigungen ausgenommen sind. Diese Benutzer haben unabhängig von den allgemeinen Einstellungen individuellen Zugriff zum Löschen und Umbenennen von Dateien und Ordnern."
    },
    "fileSizeLimit": {
      "title": "Dateigrößenbeschränkung pro Mitglied",
      "limitTitle": "Beschränkung der Dateigröße",
      "limitDescription": "Definieren Sie die maximale Dateigröße, die Mitglieder hochladen können. Mit dieser Einstellung können Sie die größte Dateigröße steuern, die von jedem Mitglied zur Plattform hinzugefügt werden kann, um eine effiziente Nutzung des Speicherplatzes und eine optimale Leistung sicherzustellen."
    },
    "quickShareMode": {
      "title": "Schnell teilen",
      "description": "Verwalten Sie die Quick Share-Einstellungen. Kontrollieren Sie die Aktivierung, das automatische Öffnen nach der Anmeldung und die maximale Freigabedauer.",
      "isVisibleTitle": "Sichtbar",
      "isVisibleDescription": "Aktivieren oder deaktivieren Sie Quick Share für Benutzer",
      "activeForAllTitle": "Schneller Share-Zugriff",
      "activeForAllDescription": "Wählen Sie, ob Quick Share für alle oder für keine Benutzer verfügbar ist.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Mitglieder an, die von der oben genannten Regel ausgenommen sind.",
      "showQuickShareByDefaultTitle": "Standardmäßig Quick Share anzeigen",
      "showQuickShareByDefaultDescription": "Machen Sie Quick Share nach der Anmeldung zur Standard-Landingpage",
      "maxSharingDaysTitle": "Maximale Freigabedauer (Tage)",
      "maxSharingDaysDescription": "Legen Sie fest, wie viele Tage die Freigabe dauert. Aktien verfallen automatisch nach der ausgewählten Anzahl von Tagen (maximal 365)",
      "enabledTitle": "Aktivieren Sie Quick Share",
      "enabledDescription": "Wenn diese Option aktiviert ist, können Benutzer Dateien über Quick Share teilen. Wenn sie deaktiviert ist, ist die Quick Share-Funktion nicht verfügbar.",
      "daysTitle": "Maximale Freigabedauer",
      "daysDescription": "Nach dieser Anzahl von Tagen läuft der freigegebene Dateilink ab und die Freigabe wird entfernt.",
      "daysOption1": "Letzten Tag teilen",
      "daysOption3": "Teilen der letzten 3 Tage",
      "daysOption7": "Teilen der letzten 7 Tage",
      "daysOption14": "Teilen der letzten 14 Tage",
      "daysOption30": "Teilen der letzten 30 Tage",
      "daysOption90": "Teilen der letzten 90 Tage"
    },
    "totpRequired": {
      "title": "Zwei-Faktor-Authentifizierung (TOTP)",
      "description": "Unternehmensweit konfigurieren TOTP 2FA. Erfordern Sie TOTP für alle Benutzer, legen Sie eine Kulanzfrist für neue Konten fest und erlauben Sie Administratoren, Benutzer TOTP zurückzusetzen.",
      "requiredTitle": "Erfordert TOTP für alle Benutzer",
      "requiredDescription": "Wenn diese Option aktiviert ist, müssen alle Benutzer TOTP einrichten. Neue Benutzer haben nach der Kontoerstellung eine Kulanzfrist, um es zu aktivieren.",
      "gracePeriodDaysTitle": "Kulanzfrist (Tage)",
      "gracePeriodDaysDescription": "Benutzer haben von der Kontoerstellung bis zur Aktivierung TOTP so viele Tage Zeit, bevor die Anmeldung gesperrt wird.",
      "allowAdminResetTitle": "Administratoren erlauben, Benutzer TOTP zurückzusetzen",
      "allowAdminResetDescription": "Wenn diese Option aktiviert ist, können Administratoren TOTP für Benutzer deaktivieren, die den Zugriff auf ihre Authentifizierungs-App verloren haben.",
      "maxExemptionDaysTitle": "Maximale Befreiungstage",
      "maxExemptionDaysDescription": "Maximale Anzahl von Tagen (1–365) für eine vorübergehende TOTP-Befreiung, wenn ein Administrator eine gewährt. Standard 30.",
      "allowPermanentExemptionTitle": "Dauerhafte Ausnahmen zulassen",
      "allowPermanentExemptionDescription": "Wenn diese Option aktiviert ist, können Administratoren dauerhafte TOTP Ausnahmen gewähren (kein Ablaufdatum). Im Falle einer Behinderung sind nur vorübergehende Ausnahmen zulässig.",
      "gracePeriodOption0": "Keine Nachfrist (sofort)",
      "gracePeriodOption1": "1 Tag",
      "gracePeriodOption3": "3 Tage",
      "gracePeriodOption7": "7 Tage (empfohlen)",
      "gracePeriodOption14": "14 Tage",
      "gracePeriodOption30": "30 Tage"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "Wenn diese Option aktiviert ist, können Administratoren einzelne Passkeys oder alle Passkeys für einen Benutzer aus den Admin-Tools entfernen.",
      "allowAdminRemoveTitle": "Erlauben Sie Administratoren, Benutzerkennwörter zu entfernen",
      "allowAs2faDescription": "Wenn diese Option aktiviert ist, können Benutzer, die E-Mail OTP ausfüllen, die Anmeldung je nach Registrierung und anderen Richtlinien mit einem Passkey statt mit TOTP abschließen.",
      "allowAs2faTitle": "Passkeys als zweiten Faktor zulassen",
      "allowPasswordlessDescription": "Wenn diese Option aktiviert ist, können sich berechtigte Benutzer mit einem Passkey ohne E-Mail-Adresse OTP anmelden. Erfordert die Zulassung von Passkeys als zweiten Faktor.",
      "allowPasswordlessTitle": "Passwortlose Anmeldung mit Passkey zulassen",
      "attestationOptionDirect": "Direkt",
      "attestationOptionIndirect": "Indirekt",
      "attestationOptionNone": "Keine (typisch für die meisten Organisationen)",
      "attestationPreferenceDescription": "Wie stark fordert der Server bei der Registrierung eine Bescheinigung an? Höhere Stufen können die Sicherheit verbessern, aber möglicherweise die Kompatibilität des Authentifikators verringern.",
      "attestationPreferenceTitle": "Attestierungspräferenz",
      "authenticatorAttachmentAny": "Beliebig (keine Einschränkung)",
      "authenticatorAttachmentCrossPlatform": "Plattformübergreifend (z. B. Sicherheitsschlüssel)",
      "authenticatorAttachmentDescription": "Beschränken Sie die Registrierung optional auf Plattformauthentifizierer auf diesem Gerät, plattformübergreifende Sicherheitsschlüssel oder lassen Sie sie für größtmögliche Kompatibilität uneingeschränkt.",
      "authenticatorAttachmentPlatform": "Plattform (dieses Gerät)",
      "authenticatorAttachmentTitle": "Authentifikator-Anhang (optional)",
      "description": "Konfigurieren Sie organisationsweite Passkeys (WebAuthn): Aktivierung, Zweitfaktor- oder passwortlose Anmeldung, Limits pro Benutzer, Administratorentfernung und Präferenzen für Registrierungszeremonien.",
      "enabledDescription": "Wenn diese Option deaktiviert ist, sind die Passschlüssel-Registrierung und die passschlüsselbasierte Anmeldung für Benutzer im Rahmen dieser Richtlinie nicht verfügbar.",
      "enabledTitle": "Aktivieren Sie Passkeys für die Organisation",
      "maxCredentialsPerUserDescription": "Maximale Anzahl von Passkeys, die jeder Benutzer registrieren kann (1–50). Begrenzt die Ausbreitung und den Supportaufwand.",
      "maxCredentialsPerUserTitle": "Maximale Passschlüssel pro Benutzer",
      "title": "Passkeys (WebAuthn)",
      "userVerificationDescription": "Wie streng der Authentifikator den Benutzer während der Passkey-Registrierung überprüfen muss. Erforderlich ist am strengsten; entmutigt ist am schwächsten.",
      "userVerificationOptionDiscouraged": "Entmutigt",
      "userVerificationOptionPreferred": "Bevorzugt",
      "userVerificationOptionRequired": "Erforderlich",
      "userVerificationTitle": "Benutzerverifizierung für die Registrierung"
    },
    "antivirusScan": {
      "title": "Antivirus-Scan",
      "description": "Legen Sie fest, welche hochgeladenen Dateitypen vom Antivirus gescannt werden. Der Erweiterungsfilter steuert die Kosten, nicht die Sicherheitsrichtlinie.",
      "enabledTitle": "Antivirus-Scan aktivieren",
      "enabledDescription": "Wenn aktiviert, werden passende Uploads asynchron gescannt. Wenn deaktiviert, werden neue Uploads nicht gescannt; bestehende Scan-Urteile bleiben auf den Dateien.",
      "extensionsTitle": "Gescannte Dateierweiterungen",
      "extensionsDescription": "Nur Dateien mit gelisteter Erweiterung werden an den Scanner gesendet. Schränken Sie die Liste ein, um Scanvolumen und Kosten zu reduzieren.",
      "extensionsPlaceholder": "Zu scannende Erweiterungen auswählen",
      "costNoticeTitle": "Erweiterungsfilter steuert die Kosten",
      "costNoticeDescription": "Mehr Erweiterungen erhöhen die Antivirus-Nutzung. Diese Einstellung ersetzt keine anderen Sicherheitskontrollen.",
      "saveError": "Antivirus-Scan-Einstellungen ungültig. Scan nur mit mindestens einer Erweiterung aktivieren.",
      "stickyInfectedNote": "Das Deaktivieren des Scans löscht keine bestehenden Infektionsurteile und entfernt keine Dateien aus der Quarantäne."
    },
    "activityLogRetention": {
      "title": "Aufbewahrung des Aktivitätsprotokolls",
      "description": "Legen Sie fest, wie lange das Unternehmen sein Aktivitätsprotokoll aufbewahrt. Sobald der Aufbewahrungszeitraum seit der Erstellung eines Protokolleintrags abgelaufen ist, wird der Eintrag dauerhaft gelöscht.",
      "activeTitle": "Aufbewahrungsrichtlinie",
      "activeDescription": "Bei Deaktivierung wird das Aktivitätsprotokoll auf unbestimmte Zeit gespeichert und es wird nie etwas gelöscht.",
      "windowTitle": "Aufbewahrungsfrist",
      "windowDescription": "Protokolleinträge, die älter als dieser Zeitraum sind, werden dauerhaft gelöscht. Zulässiger Bereich: von {{min}} Monaten bis {{max}} Jahren.",
      "warningTitle": "Die Löschung erfolgt dauerhaft und rückwirkend",
      "warningDescription": "Durch die Aktivierung der Richtlinie werden auch Protokolleinträge gelöscht, die den Aufbewahrungszeitraum bereits überschreiten. Gelöschte Einträge können nicht wiederhergestellt werden: Exportieren Sie zuerst das Aktivitätsprotokoll, wenn Sie eine Kopie behalten müssen."
    },
    "securityAnalysis": {
      "title": "Executive Report und Sicherheitsmitteilung",
      "description": "Einzelkonfiguration für den Executive Report (interne Domänen, Schwellenwerte für Risikoindikatoren), die Schwellenwerte für die Erkennung von Sicherheitsanomalien und die E-Mail-Benachrichtigungen für erkannte Anomalien.",
      "enableTitle": "E-Mail-Benachrichtigungen aktivieren",
      "enableDescription": "Wenn diese Option aktiviert ist, wird bei neuen Sicherheitsanomalien mit dem ausgewählten Schweregrad oder höher eine E-Mail an die ausgewählten Empfänger gesendet.",
      "recipientsTitle": "Empfänger",
      "recipientsDescription": "Plattformbenutzer und -gruppen, die die Benachrichtigungen erhalten. Bei Gruppen werden alle Mitglieder benachrichtigt.",
      "recipientsPlaceholder": "Suchen Sie nach Benutzern oder Gruppen",
      "minSeverityTitle": "Minimaler Schweregrad",
      "minSeverityDescription": "Senden Sie Benachrichtigungen nur ab diesem Schweregrad. „Warnung“ umfasst „Warnung“ und „Kritisch“. Kritisch sendet nur Kritisch.",
      "severityWarning": "Warnung und höher",
      "severityCritical": "Nur kritisch",
      "domainsTitle": "Interne Domänen",
      "domainsDescription": "Durch Kommas getrennte Liste der E-Mail-Domänen, die als intern gelten, wenn im Executive Report zwischen interner und externer Freigabe unterschieden wird. Wenn leer, wird die E-Mail-Domäne des ersten Administrators verwendet.",
      "domainsPlaceholder": "Unternehmen.com, Tochtergesellschaft.com",
      "domainsError": "Eine oder mehrere Domänen haben kein gültiges Format (z. B. unternehmen.com).",
      "thresholdsTitle": "Schwellenwerte für Risikoindikatoren",
      "thresholdsDescription": "Prozentuale Schwellenwerte, die für jeden Risikoindikator des Geschäftsberichts definieren, was als Warnung und was als kritisch gilt.",
      "warningLabel": "Warnung ≥",
      "criticalLabel": "Kritisch ≥",
      "thresholdError": "Der Warnschwellenwert muss niedriger sein als der kritische Schwellenwert.",
      "detectorThresholdsTitle": "Schwellenwerte für die Anomalieerkennung",
      "detectorThresholdsDescription": "Ereigniszählungen definieren, was für jeden Sicherheitsanomaliedetektor als Warnung und was als kritisch gilt. Detektoren ohne numerische Schwellenwerte (blockierte Admin-IP, explizite Sicherheitssignale) sind nicht anpassbar.",
      "detectorThresholdError": "Der Warnschwellenwert muss niedriger sein als der kritische Schwellenwert.",
      "detectors": {
        "bruteForceLogin": "Fehlgeschlagene Anmeldungen am selben Konto (15-Minuten-Fenster)",
        "folderPassword": "Fehlgeschlagene Passwortversuche für Ordner (pro Ordner und Benutzer)",
        "publicLinkBruteForce": "Fehlgeschlagene öffentliche Linkzugriffe (pro Link und IP)",
        "massDownload": "Von einem Benutzer heruntergeladene Dateien (60-Minuten-Fenster)",
        "passwordSpray": "Passwortspray: Verschiedene Konten werden von einer IP aus versucht",
        "unauthorizedCountry": "Blockierte Zugriffe aus nicht autorisierten Ländern (pro Benutzer und Land)"
      }
    },
    "ipRegionRestriction": {
      "title": "IP-/Regionsbeschränkung",
      "description": "Beschränken Sie den Plattformzugriff basierend auf IP-Adresse, Land oder Region",
      "warningMessage": "Warnung: Diese Einstellung blockiert alle Benutzer, die die Kriterien nicht erfüllen",
      "warningDescription": "Benutzern außerhalb der zulässigen IP-Adressen, Länder oder Regionen wird der Zugriff verweigert. Konfigurieren Sie Ausnahmen für bestimmte Benutzer oder Gruppen.",
      "confirmTitle": "Bestätigen Sie die Konfiguration",
      "confirmWarning": "Diese Konfiguration schränkt den Zugriff ein. Benutzer außerhalb der zulässigen IPs, Länder oder Regionen erhalten keinen Zugriff. Sind Sie sicher?",
      "scopeTitle": "Anwendungsbereich",
      "scopeDescription": "Wann soll diese Einschränkung gelten?",
      "scopeLogin": "Nur anmelden",
      "scopeFileOps": "Nur Dateioperationen",
      "scopeBoth": "Beide (empfohlen)",
      "allowedIpsTitle": "Zulässige IP-Adressen/CIDR-Bereiche",
      "allowedIpsDescription": "Durch Kommas getrennte Liste von IPs oder CIDR-Bereichen (IPv4/IPv6)",
      "allowedCountriesTitle": "Zulässige Länder",
      "allowedCountriesDescription": "Ausgewählte Länder (ISO 3166-1 Alpha-2-Codes)",
      "allowedRegionsTitle": "Zulässige Regionen",
      "allowedRegionsDescription": "Wählen Sie Regionen aus (ISO 3166-2-Codes oder „EU“ für Europäische Union)",
      "allowPrivateNetworksTitle": "Private Netzwerke zulassen",
      "allowPrivateNetworksDescription": "Umgehungsbeschränkung für private IP-Bereiche (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Admin-Zugriff",
      "restrictAdminAccessTitle": "Beschränken Sie die Administratoreinstellungen nach IP",
      "restrictAdminAccessDescription": "Erlauben Sie den Zugriff auf Administratoreinstellungen nur von angegebenen IP-Adressen oder CIDR-Bereichen",
      "adminAllowedIpsTitle": "Zulässige Administrator-IP-Adressen",
      "adminAllowedIpsDescription": "Durch Kommas getrennte Liste der IPs oder CIDR-Bereiche, die zum Öffnen der Administratoreinstellungen zulässig sind",
      "addAdminIp": "IP hinzufügen",
      "addAllowedIp": "Fügen Sie IP oder CIDR hinzu",
      "logBlockedAttemptsTitle": "Blockierte Versuche protokollieren",
      "logBlockedAttemptsDescription": "Zeichnen Sie alle Zugriffsverweigerungsversuche im Aktivitätsprotokoll auf",
      "blockedMessageTitle": "Benutzerdefinierte blockierte Nachricht",
      "blockedMessageDescription": "Nachricht, die blockierten Benutzern angezeigt wird (maximal 200 Zeichen)",
      "blockedMessagePlaceholder": "Zugriff von Ihrem Standort aus verweigert.",
      "exceptionsTitle": "Ausnahmen",
      "exceptionsDescription": "Benutzer oder Gruppen mit zusätzlichen Zugriffskriterien",
      "validationAtLeastOne": "Es muss mindestens ein Kriterium (IP, Land oder Region) angegeben werden",
      "validationInvalidIp": "Ungültiges IP/CIDR-Format: {{entries}}",
      "validationInvalidCountry": "Ungültige Ländercodes: {{codes}}",
      "validationInvalidRegion": "Ungültige Regionalcodes: {{codes}}",
      "adminAllowedIpsHelper": "Nur IP/CIDR: keine Geolokalisierung, keine Umgehung privater Netzwerke und die oben genannten Ausnahmen gelten hier nicht."
    },
    "fileTypeRestriction": {
      "title": "Kontrolle der Dateitypbeschränkung",
      "description": "Ermöglicht Ihnen festzulegen, welche Dateitypen für den Upload gesperrt sind.",
      "blockedExtensionsTitle": "Dateierweiterungen blockiert",
      "blockedExtensionsDescription": "Geben Sie an, welche Dateierweiterungen blockiert werden. Dadurch können Sie genau definieren, welche Dateitypen den Einschränkungen unterliegen.",
      "userScopeTitle": "Benutzerumfang",
      "userScopeDescription": "Steuern Sie, ob Benutzer gemäß den oben definierten Dateitypen daran gehindert werden, Dateien auf der Plattform hochzuladen oder zu teilen. Zu den Optionen gehört das Blockieren aller oder keiner Benutzer. Vorhandene hochgeladene oder freigegebene Dateien bleiben auch dann aktiv, wenn die Berechtigung später widerrufen wird.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von den oben genannten Einschränkungen ausgenommen sind.",
      "showUsers": "Zeigen Sie Benutzer an, denen bereits von anderen Zugriff gewährt wurde.",
      "allowEdit": "Ermöglicht Benutzern das Ändern, Überschreiben oder Löschen bestehender Freigabeeinstellungen.",
      "readOnly": "Ermöglichen Sie die Dateifreigabe durch Benutzer mit schreibgeschütztem Zugriff (Viewer).",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an.",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "fileTypesTitle": "Dateitypen",
      "fileTypesDescription": "Definieren Sie die Dateitypen, die dieser Regel unterliegen.",
      "fileTypesPlaceholder": "Wählen Sie Dateitypen oder Erweiterungen aus"
    },
    "folderCreationPermission": {
      "title": "Ordnerbeschränkungen",
      "creationTitle": "Erstellung des Mitwirkenden-Ordners",
      "creationDescription": "Steuern Sie, welche Mitwirkenden Ordner auf der Plattform erstellen können. Zu den Optionen gehört es, alle oder keine Mitwirkenden zuzulassen. Bestehende Ordner bleiben auch dann zugänglich, wenn die Berechtigung später widerrufen wird.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind."
    },
    "groupCreationControl": {
      "title": "Gruppenbeschränkungen",
      "creationTitle": "Erstellung einer Mitwirkendengruppe",
      "creationDescription": "Steuern Sie, welche Mitwirkenden Gruppen auf der Plattform erstellen können. Zu den Optionen gehört es, alle oder keine Mitwirkenden zuzulassen. Erstellte Gruppen sind nur für den Benutzer sichtbar, der sie erstellt hat. Bestehende Gruppen bleiben auch dann zugänglich, wenn die Berechtigung später widerrufen wird.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind."
    },
    "publicAccessLink": {
      "title": "Öffentlicher Zugangslink",
      "description": "Steuern Sie die Möglichkeit für Mitwirkende, Links für den Zugriff auf Dateien und Ordner ohne Authentifizierung zu generieren. Zu den Optionen gehört es, allen Mitgliedern oder keinem zu erlauben, diese Links zu erstellen. Bestehende Links bleiben auch dann aktiv, wenn die Erlaubnis später widerrufen wird.",
      "activeForAllTitle": "Generierung von Mitwirkenden-Links",
      "activeForAllDescription": "Steuern Sie die Möglichkeit für Mitwirkende, Links für den Zugriff auf Dateien und Ordner ohne Authentifizierung zu generieren. Zu den Optionen gehört es, allen Mitgliedern oder keinem zu erlauben, diese Links zu erstellen. Bestehende Links bleiben auch dann aktiv, wenn die Erlaubnis später widerrufen wird.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Mitwirkende an, die von den oben genannten Berechtigungen zur Linkgenerierung ausgenommen sind.",
      "forcePasswordTitle": "Passwort erzwingen",
      "forcePasswordDescription": "Wenn diese Option aktiviert ist, muss der Benutzer beim Erstellen eines öffentlichen Links ein Passwort festlegen.",
      "mandatoryMaxAccessCountTitle": "Obligatorische maximale Zugriffsanzahl",
      "mandatoryMaxAccessCountDescription": "Wenn größer als 0, muss der Benutzer eine maximale Anzahl von Zugriffen angeben (0–10000). 0 bedeutet nicht erforderlich.",
      "maxExpirationDaysTitle": "Maximale Ablauftage",
      "maxExpirationDaysDescription": "Wenn der Wert größer als 0 ist, muss der Benutzer einen Ablauf innerhalb dieser Anzahl von Tagen (0–365) festlegen. 0 bedeutet keine Einschränkung. <br /> <DangerText> Wenn „Mandatory Expiration Shared File“ aktiviert ist, hat das in dieser Einstellung definierte Ablaufdatum Vorrang vor dem hier konfigurierten maximalen Ablaufdatum. </DangerText>",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Öffentliche Links können nur für Dateien mit diesen Tags erstellt werden."
    },
    "sessionControl": {
      "title": "Beschränkung gleichzeitiger Sitzungen",
      "description": "Begrenzen Sie die Anzahl aktiver Sitzungen pro Benutzer. Wenn ein Benutzer das Limit überschreitet, wird die älteste Sitzung automatisch beendet.",
      "maxSessionsTitle": "Maximale Anzahl an Sitzungen",
      "maxActiveSessions": "Max. aktive Sitzungen",
      "maxSessionsDescription": "Legen Sie die maximale Anzahl gleichzeitiger Sitzungen fest, die pro Benutzer zulässig sind. Wenn das Limit erreicht ist, wird die älteste Sitzung automatisch getrennt.",
      "unlimited": "Unbegrenzt",
      "exceptionsTitle": "Ausnahmen",
      "exceptionsDescription": "Überschreiben Sie das Sitzungslimit für bestimmte Benutzer oder Gruppen.",
      "pendingExceptionsTitle": "Ausstehende Ausnahmen",
      "savedExceptionsTitle": "Gespeicherte Ausnahmen",
      "selectUsersOrGroups": "Wählen Sie Benutzer oder Gruppen aus..."
    },
    "uploadWithTag": {
      "title": "Automatische Tag-Verwaltung",
      "description": "Filegrant Enterprise durchsucht die Metadaten der hochgeladenen klassifizierten Dateien nach bestimmten Schlüsselwörtern. Wenn eines der angegebenen Schlüsselwörter erkannt wird, wird der entsprechende Wert als Tag auf die Datei angewendet. Wenn ein Tag noch nicht auf der Plattform vorhanden ist, wird es automatisch erstellt. Dieser Prozess stellt sicher, dass jede Datei entsprechend ihrem Inhalt ordnungsgemäß kategorisiert und mit Tags versehen wird.",
      "keywordsTitle": "Schlüsselwörter",
      "keywordsDescription": "Geben Sie die Schlüsselwörter an, deren Werte nach dem Hochladen als Tags für die Datei verwendet werden.",
      "userScopeTitle": "Benutzerumfang",
      "userScopeDescription": "Steuern Sie, ob Mitglieder der automatischen Tag-Erkennung für Datei-Uploads auf der Plattform unterliegen. Zu den Optionen gehört die Anwendung auf alle oder keine Mitglieder. Vorhandene Dateien, die bereits hochgeladen und mit Tags versehen wurden, bleiben aktiv und Änderungen an Schlüsselwörtern wirken sich nicht auf diese zuvor mit Tags versehenen Dateien aus.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind."
    },
    "watermarkProtection": {
      "title": "Wasserzeichenschutz",
      "description": "Steuern Sie den Wasserzeichenschutz für freigegebene Dateien. Aktivieren Sie die Option für alle oder keine Mitglieder, verwalten Sie Ausnahmen und konfigurieren Sie, welche Daten auf dem Wasserzeichen angezeigt werden (z. B. Freigabedatum, Besitzer, Empfänger, Erstellungsdatum, IP).",
      "descriptionInternal": "Steuern Sie den Wasserzeichenschutz für freigegebene Dateien. Aktivieren Sie die Option für alle oder keine Mitglieder, verwalten Sie Ausnahmen und konfigurieren Sie, welche Daten auf dem Wasserzeichen angezeigt werden (z. B. Freigabedatum, Besitzer, Empfänger, Erstellungsdatum, IP). <DangerText>Derzeit werden Wasserzeichen auf PDF-Dateien und Bilder (JPEG, PNG, SVG) und nur auf Empfänger angewendet, die Office-Dateien (doc, docx, ppt, pptx, xls, xlsx) im schreibgeschützten Modus erhalten.</DangerText>",
      "enabledTitle": "Ermöglicht",
      "enabledDescription": "Schalten Sie diese Einstellung ein oder aus.",
      "userScopeTitle": "Benutzerumfang",
      "userScopeDescription": "Ermöglichen Sie Mitgliedern, ihre Dateien mit Wasserzeichen zu schützen. Zu den Optionen gehört die Aktivierung dieser Funktion für alle oder keine Mitglieder. Beim Teilen können Wasserzeichen angebracht werden. Wenn Empfänger das Dokument öffnen, zeigt das Wasserzeichen ihre E-Mail-Adresse, IP-Adresse und das Datum des Zugriffs auf das Dokument an und gewährleistet so den Schutz und die Nachverfolgung des Inhalts.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Wenden Sie den Wasserzeichenschutz auf alle oder keine Mitglieder an. Bei der Einstellung „Keine“ können Sie weiterhin bestimmte Mitglieder über Ausnahmen und Tags ansprechen.",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie den Wasserzeichenschutz nur auf Dateien mit diesen Tags an.",
      "previewTitle": "Vorschau",
      "textLabel": "Wasserzeichentext",
      "repetitionLabel": "Wiederholung",
      "repetitionSingle": "Einzel",
      "repetitionRepetitive": "Wiederholt",
      "fieldsLabel": "Felder zur Anzeige",
      "fieldsSharingDate": "Datum der Freigabe",
      "fieldsOwner": "Eigentümer",
      "fieldsRecipient": "Empfänger",
      "fieldsCreationDate": "Erstellungsdatum",
      "fieldsIp": "IP-Adresse",
      "positionXLabel": "Horizontale Position",
      "positionYLabel": "Vertikale Position",
      "positionLeft": "Links",
      "positionCenter": "Mitte",
      "positionRight": "Rechts",
      "positionTop": "Spitze",
      "positionMiddle": "Mitte",
      "positionBottom": "Unten",
      "positionsLabel": "Position",
      "positionsTopLeft": "Oben links",
      "positionsTopCenter": "Oben in der Mitte",
      "positionsTopRight": "Oben rechts",
      "positionsBottomLeft": "Unten links",
      "positionsBottomCenter": "Unten in der Mitte",
      "positionsBottomRight": "Unten rechts",
      "positionsDiagonal": "Diagonale (wiederholt)",
      "fontSizeLabel": "Schriftgröße",
      "fontSizeDescription": "1–72",
      "fontColorLabel": "Schriftfarbe",
      "opacityLabel": "Opazität",
      "opacityDescription": "0–100 %",
      "textPlaceholderHelp": "Die Schaltflächen unten fügen Platzhalter in den Text ein. Sie können \\n für Zeilenumbrüche und **bold** für fetten Text verwenden. Der Tooltip jeder Schaltfläche erklärt, was sie bewirkt.",
      "placeholderButtonOwner": "Eigentümer",
      "placeholderTooltipOwner": "Im Wasserzeichen wird {owner} durch den Namen des Dokumenteigentümers ersetzt.",
      "placeholderButtonAccessDate": "Datum/Uhrzeit anzeigen",
      "placeholderTooltipAccessDate": "Im Wasserzeichen wird {access_date} durch das Datum und die Uhrzeit der Anzeige des Dokuments ersetzt.",
      "placeholderButtonSharingDate": "Datum der Freigabe",
      "placeholderTooltipSharingDate": "Im Wasserzeichen wird {sharing_date} durch das Link-Generierungsdatum ersetzt.",
      "placeholderButtonIp": "IP-Adresse",
      "placeholderTooltipIp": "Im Wasserzeichen wird {ip} durch die IP-Adresse des Betrachters ersetzt.",
      "placeholderButtonRecipient": "Empfänger",
      "placeholderTooltipRecipient": "Im Wasserzeichen wird {recipient} durch den Namen des Empfängers ersetzt.",
      "placeholderButtonOwnerEmail": "E-Mail des Eigentümers",
      "placeholderTooltipOwnerEmail": "Im Wasserzeichen wird {owneremail} durch die E-Mail-Adresse des Dokumentbesitzers ersetzt.",
      "placeholderButtonRecipientEmail": "Empfänger-E-Mail",
      "placeholderTooltipRecipientEmail": "Im Wasserzeichen wird {recipientemail} durch die E-Mail-Adresse des Empfängers ersetzt."
    },
    "remotegrantForceEncryption": {
      "title": "Remotegrant-Verschlüsselung erzwingen (Lizenz erforderlich)",
      "description": "Verschlüsseln Sie Dateien und weisen Sie neu erstellten Mitgliedern mithilfe von Remotegrant automatisch Zugriffsberechtigungen zu."
    },
    "sharingApprovalRequirement": {
      "title": "Genehmigungsanforderungen teilen",
      "description": "Steuert, ob die Datei- und Ordnerfreigabe eine vorherige Genehmigung erfordert, um sicherzustellen, dass vertrauliche Dateien vor der Verteilung überprüft werden und die Compliance gewährleistet ist.",
      "descriptionInternal": "In diesem Abschnitt können Administratoren steuern, ob die Datei- und Ordnerfreigabe eine vorherige Genehmigung erfordert. Regeln können universell, auf bestimmte Dateieigentumstypen oder basierend auf Klassifizierungs-Tags angewendet werden. Administratoren können sicherstellen, dass vertrauliche Dateien überprüft werden, bevor sie freigegeben werden, und so dazu beitragen, die Compliance aufrechtzuerhalten, Datenlecks zu verhindern und Unternehmensrichtlinien durchzusetzen. Genehmigungsanfragen können an einen bestimmten Vorgesetzten oder ein vordefiniertes Prüfteam weitergeleitet werden.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "reviewTeamTitle": "Review-Team",
      "reviewTeamDescription": "Geben Sie das Team an, das die Genehmigungsanfragen prüft.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich",
      "exceptionHandlingTitle": "Ausnahmebehandlung",
      "exceptionHandlingDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "generalApprovalTitle": "Allgemeine Genehmigungspflicht",
      "generalApprovalDescription": "Die Weitergabe ist nur nach vorheriger Genehmigung eines in der Richtlinie festgelegten Vorgesetzten oder Teams zulässig.",
      "resharingApprovalTitle": "Genehmigung nur für erneut freigegebene Dateien",
      "resharingApprovalDescription": "Wendet die Genehmigungsanforderung nur auf Dateien an, die zuvor empfangen wurden und erneut freigegeben werden.",
      "manageReviewTeam": "Prüfteam verwalten"
    },
    "mandatoryFileClassification": {
      "title": "Obligatorische Dateiklassifizierung",
      "description": "Erfordern Sie die Klassifizierung von Dateien vor der Freigabe, um sicherzustellen, dass vertrauliche Dateien ordnungsgemäß gekennzeichnet und geschützt werden.",
      "descriptionInternal": "Dieser Abschnitt stellt sicher, dass Dateien ordnungsgemäß klassifiziert werden, bevor sie freigegeben werden können. Durch die Anforderung einer Klassifizierung wird die versehentliche oder unbefugte Weitergabe vertraulicher Inhalte verhindert und eine konsistente Datenverwaltung unterstützt.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "forcedFileInvisibility": {
      "title": "Erzwungene Unsichtbarkeit der Datei",
      "description": "Mit dieser Funktion können Administratoren bestimmte Dateitypen für Empfänger unsichtbar machen und gleichzeitig die Freigabeaktion abschließen. Beispielsweise können Office-Dokumente, die als bearbeitbare Masterdateien verwendet werden, geteilt werden, bleiben aber für den Empfänger verborgen, wodurch das Risiko der Offenlegung bearbeitbarer Quelldateien verringert wird und gleichzeitig die Freigabe genehmigter Formate wie PDFs möglich ist.",
      "descriptionInternal": "Mit dieser Funktion können Administratoren bestimmte Dateitypen für Empfänger unsichtbar machen und gleichzeitig die Freigabeaktion abschließen. Beispielsweise können Office-Dokumente, die als bearbeitbare Masterdateien verwendet werden, geteilt werden, bleiben aber für den Empfänger verborgen, wodurch das Risiko der Offenlegung bearbeitbarer Quelldateien verringert wird und gleichzeitig die Freigabe genehmigter Formate wie PDFs möglich ist.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen. Diese Einstellung kann den Umfang der Berechtigungen, die Bedingungen, unter denen sie gelten, und alle zulässigen Ausnahmen definieren. Dadurch wird sichergestellt, dass die Benutzeraktivität mit den Unternehmensrichtlinien im Einklang bleibt und gleichzeitig gegebenenfalls Flexibilität ermöglicht wird.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "fileTypesTitle": "Unsichtbar nach dem Teilen",
      "fileTypesDescription": "Macht bestimmte Dateitypen (z. B. Office-Dokumente) für Empfänger unsichtbar, während der Freigabevorgang dennoch abgeschlossen wird.",
      "fileTypesPlaceholder": "Geben Sie Dateitypen oder Erweiterungen ein (z. B. .docx, .xls, .pptx)",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "shortcutLink": {
      "title": "Einschränkung für Verknüpfungslinks",
      "description": "Beschränken Sie die Erstellung von Verknüpfungslinks für Dateien, die bestimmte Tags enthalten.",
      "descriptionInternal": "Beschränken Sie die Erstellung von Verknüpfungslinks für Dateien, die bestimmte Tags enthalten.",
      "activeForAllTitle": "Benutzerumfang",
      "activeForAllDescription": "Steuern Sie, ob Benutzer den vom Administrator festgelegten Einschränkungen unterliegen.",
      "exceptionsTitle": "Ausnahmebehandlung",
      "exceptionsDescription": "Geben Sie Benutzer an, die von der oben genannten Funktion ausgenommen sind.",
      "tagsTitle": "Schlagworte",
      "tagsDescription": "Wenden Sie diese Regeln nur auf Dateien mit bestimmten Tags an",
      "tagsRequired": "Wenn mehrere Regeln vorhanden sind, ist mindestens ein Tag erforderlich",
      "exceptionsRequiredForTags": "Für das Setzen von Tags sind Ausnahmen erforderlich"
    },
    "adminSettingsPermissions": {
      "title": "Berechtigungen für Administratoreinstellungen",
      "description": "Beschränkt den Administratorzugriff auf Plattformeinstellungen",
      "deniedSettingsUserTitle": "Administratorbereich",
      "deniedSettingsUserDescription": "Wählen Sie den Administrator aus, dem der Zugriff auf die Einstellungen verweigert werden soll.",
      "deniedSettingsTitle": "Verweigerte Einstellungen",
      "deniedSettingsDescription": "Geben Sie die Einstellungen an, auf die Administratoren keinen Zugriff haben.",
      "selectUserFirst": "Wählen Sie zunächst einen Benutzer aus"
    },
    "sharePointIntegration": {
      "title": "SharePoint-Integration",
      "description": "Verschlüsseln Sie die Dateien eines ausgewählten SharePoint-Perimeters direkt.",
      "steps": {
        "connection": "Verbindung",
        "key": "Verschlüsselungsschlüssel",
        "perimeter": "Perimeter"
      },
      "connectionDescription": "Nur-App-Anmeldeinformationen Ihrer Entra ID-App-Registrierung.",
      "tenantIdLabel": "Mieter-ID",
      "clientIdLabel": "Kunden-ID",
      "spaClientIdLabel": "SPA-Client-ID (Betrachter/Editor)",
      "spaClientIdHint": "Zweite App-Registrierung vom Typ SPA (öffentlich): Der Browser meldet sich an, um die verschlüsselten Dateien zu lesen und zu bearbeiten. Ohne sie kann niemand eine Datei aus der Web-App öffnen. Geben Sie hier niemals die reine App-Registrierung ein – das hat ein Geheimnis.",
      "guidHint": "Geben Sie eine gültige GUID ein.",
      "clientSecretLabel": "Kundengeheimnis",
      "clientSecretPlaceholder": "Fügen Sie den geheimen Clientschlüssel ein",
      "clientSecretHint": "Schreibgeschützt: Einmal gespeichert, kann es nur ersetzt werden.",
      "clientSecretStored": "Ein Client-Geheimnis wird gespeichert",
      "replaceSecret": "Ersetzen",
      "editConnection": "Bearbeiten",
      "hideConnection": "Schließen",
      "testAction": "Verifizieren",
      "testOk": "Verbindung überprüft",
      "testKo": "Verbindung abgelehnt",
      "saveCredentialsFirst": "Speichern Sie zunächst die Anmeldeinformationen.",
      "lastVerifyOk": "Verifiziert",
      "lastVerifyKo": "Prüfung fehlgeschlagen",
      "lastVerifiedAt": "Letzte Überprüfung: {{date}}",
      "perimeterDescription": "Die Websites und Ordner, die der Scan überprüft.",
      "perimeter": {
        "sitesTitle": "Websites",
        "searchSites": "Websites durchsuchen",
        "reloadSites": "Laden Sie die Sites-Liste neu",
        "foldersTitle": "{{siteName}}",
        "foldersTitleEmpty": "Ordner",
        "pickSiteFirst": "Wählen Sie links eine Website aus.",
        "noLibraries": "Hier ist keine Dokumentbibliothek sichtbar.",
        "wholeSiteTag": "Ganze Seite",
        "selectedTitle": "Im Umfang:",
        "scopeNone": "keiner",
        "folderCount": "{{count}} Ordner",
        "librariesCrumb": "Dokumentbibliotheken",
        "noSubfolders": "Kein Unterordner.",
        "levelTruncatedTitle": "Zu viele Ordner, um sie hier aufzulisten",
        "levelTruncatedBody": "Oberhalb der 2000-Ordner-Obergrenze werden einige Ordner auf keiner Seite angezeigt. Fügen Sie sie unten nach Pfad hinzu.",
        "manualPathLabel": "Fügen Sie einen Ordner nach Pfad hinzu",
        "manualPathPlaceholder": "Fügen Sie einen Ordner nach Pfad hinzu, z. B. Verträge/2026",
        "manualPathInvalid": "Pfad relativ zum Bibliotheksstamm, ohne „.“ oder „..“-Segmente (max. 400 Zeichen).",
        "browse": "Durchsuchen",
        "openFolder": "Öffnen Sie {{name}}",
        "scopeLabel": "Sehen Sie sich das auf dieser Website an",
        "scopeOff": "Nichts",
        "scopeWhole": "Die ganze Seite",
        "scopeFolders": "Nur die Ordner unten",
        "selectedFoldersTitle": "Beobachtete Ordner",
        "librariesNotSelectable": "Öffnen Sie eine Bibliothek. Ein von Ihnen ausgewählter Ordner gilt für jede Bibliothek dieser Site.",
        "addFolder": "Fügen Sie {{name}} zu den überwachten Ordnern hinzu",
        "folderAdded": "Hinzugefügt",
        "folderAlreadyAdded": "Dieser Ordner wurde bereits beobachtet",
        "noFoldersSelected": "Noch keine.",
        "parentFolderWatched": "Der übergeordnete Ordner „{{folder}}“ wird bereits überwacht, sodass seine Unterordner bereits im Gültigkeitsbereich liegen.",
        "emptyWarning": "Keine Site ausgewählt: Es wird nichts gescannt oder verschlüsselt.",
        "siteCount": "{{count}} Website(s)"
      },
      "certificateDescription": "Das RemoteGrant-Zertifikat, mit dem die Dateien verschlüsselt werden.",
      "encryption": {
        "thumbprintLabel": "Fingerabdruck",
        "unnamedCertificate": "Zertifikat #{{id}}",
        "reloadAction": "Zertifikate neu laden",
        "selectPlaceholder": "Wählen Sie ein Zertifikat",
        "optionLabel": "{{name}} – erstellt am {{date}}",
        "rotationTitle": "Durch das Ändern des Zertifikats wird nichts neu verschlüsselt",
        "rotationBody": "Bereits verschlüsselte Dateien bleiben an das vorherige Zertifikat gebunden: Behalten Sie es in RemoteGrant, sonst werden sie unlesbar.",
        "dryRunBlockedReason": "Wählen Sie ein Verschlüsselungszertifikat aus, um den Erkennungsmodus zu deaktivieren.",
        "errors": {
          "listFailed": "Die Zertifikatsliste konnte nicht geladen werden.",
          "certificateNotFound": "Das ausgewählte Zertifikat befindet sich nicht mehr in Ihrer RemoteGrant-Liste. Laden Sie die Liste neu und wählen Sie erneut eine aus.",
          "remoteGrantNotConfigured": "RemoteGrant ist nicht für Ihr Unternehmen konfiguriert. Die Schlüssel werden von CyberGrant festgelegt: Wenden Sie sich an den Support.",
          "remoteGrantUnavailable": "RemoteGrant ist vorübergehend nicht erreichbar. Versuchen Sie es gleich noch einmal.",
          "remoteGrantDenied": "RemoteGrant hat die Anmeldeinformationen Ihres Unternehmens abgelehnt. Kontaktieren Sie den Support."
        },
        "empty": "RemoteGrant hat kein Zertifikat für Ihr Unternehmen zurückgegeben."
      },
      "fileExtensionsTitle": "Dateitypfilter",
      "fileExtensionsDescription": "Nur Dateien mit diesen Erweiterungen sind im Geltungsbereich. Lassen Sie die Liste leer, um alle Dateitypen einzuschließen.",
      "addFileExtension": "Fügen Sie eine Erweiterung hinzu",
      "invalidFileExtension": "Geben Sie eine einzelne Erweiterung ein, zum Beispiel .docx",
      "allFileTypesWarning": "Kein Filter festgelegt: Jeder Dateityp im Perimeter ist im Gültigkeitsbereich.",
      "dryRunTitle": "Entdeckungsmodus",
      "dryRunDescription": "Überprüfen Sie den Perimeter, ohne etwas zu verschlüsseln. Sicherer Standard.",
      "dryRunOnTag": "Entdeckung",
      "dryRunOffTag": "Verschlüsseln",
      "confirmEncryption": {
        "confirmAction": "Verschlüsseln",
        "irreversible": "Sie werden an Ort und Stelle umgeschrieben und können von hier aus nicht entschlüsselt werden.",
        "title": "Die Dateien in dieser Auswahl verschlüsseln?"
      },
      "errors": {
        "notAvailableTitle": "Nicht in Ihrer Lizenz enthalten",
        "notAvailable": "Die SharePoint-Integration ist nicht in Ihrer Lizenz enthalten. Wenden Sie sich an den Support, um es zu aktivieren.",
        "notConfigured": "Es sind noch keine Anmeldeinformationen gespeichert. Geben Sie zunächst die Verbindungsparameter ein und speichern Sie diese.",
        "configInvalid": "Die gespeicherte Konfiguration wurde abgelehnt. Beheben Sie die unten aufgeführten Probleme und speichern Sie erneut.",
        "testFailed": "Die Verbindung konnte nicht überprüft werden.",
        "sitesFailed": "Die Seiten des Mandanten konnten nicht geladen werden.",
        "foldersFailed": "Diese Ordnerebene konnte nicht geladen werden.",
        "siteNotFound": "Diese Website ist mit diesen Anmeldeinformationen nicht mehr verfügbar. Laden Sie die Sites-Liste neu und wählen Sie sie erneut aus.",
        "graphUnauthorizedShort": "Microsoft Graph hat die Anmeldeinformationen abgelehnt.",
        "graphUnavailable": "Microsoft Graph ist vorübergehend nicht erreichbar. Versuchen Sie es gleich noch einmal.",
        "notAllowed": "Sie sind nicht berechtigt, diese Einstellung zu verwalten. Bitten Sie einen SuperAdmin, Ihnen Zugriff auf die SharePoint-Integration zu gewähren.",
        "invalidParams": "Die Anfrage wurde aufgrund eines ungültigen Parameters abgelehnt.",
        "remedyPermissions": "Für die App-Registrierung sind die Anwendungsberechtigungen Sites.Read.All und Files.ReadWrite.All mit Zustimmung des Administrators erforderlich.",
        "remedySecret": "Das Client-Geheimnis ist möglicherweise falsch oder abgelaufen. Geben Sie oben ein neues ein."
      }
    }
  },
  "auth": {
    "loginPageTitle": "Willkommen bei Filegrant Enterprise",
    "loginPageSubtitle": "Bitte geben Sie Ihre E-Mail-Adresse ein, um sicher auf das Dokument zuzugreifen.",
    "resendOtpCode": "OTP-Code erneut senden",
    "loginTermsAndConditions": "Ich stimme den [**Nutzungsbedingungen**] von Cyber ​​Grant Inc. zu (https://www.cybergrant.net/terms-of-service)",
    "loginPageEmailLabel": "E-Mail-Adresse",
    "loginPageEmailPlaceholder": "Geben Sie hier Ihre E-Mail-Adresse ein...",
    "loginPageOtpLabel": "Geben Sie hier den 6-stelligen Code ein, den Sie an Ihre E-Mail-Adresse erhalten haben. Wenn Sie ihn nicht erhalten haben, klicken Sie auf „Neuen Code anfordern“.",
    "loginButtonLabel": "Anmelden",
    "loginPageResendOtp": "Fordern Sie einen neuen Code an",
    "orContinueWith": "Oder fahren Sie fort mit",
    "loginPageTooManyAttempts": "Zu viele Versuche, versuchen Sie es noch einmal",
    "totpStepTitle": "Zwei-Faktor-Authentifizierung",
    "enterTotpCode": "Geben Sie den 6-stelligen Code aus Ihrer Authentifizierungs-App ein",
    "configure2FA": "Ich muss 2FA einrichten",
    "useBackupCode": "Verwenden Sie einen Backup-Code",
    "useOtpCode": "Verwenden Sie den OTP-Code",
    "enterBackupCode": "Geben Sie Ihren Backup-Code ein",
    "backupCodePlaceholder": "Geben Sie Ihren Backup-Code ein",
    "totpTimeRemaining": "Verbleibende Zeit bis zum Abschluss der Authentifizierung: {{time}}",
    "twoFactorChooseMethod": "Wählen Sie aus, wie Sie verifizieren möchten",
    "usePasskey": "Verwenden Sie den Passkey",
    "useTotp": "Verwenden Sie die Authentifizierungs-App",
    "passkeyWaiting": "Warten auf Ihren Passkey…",
    "orDivider": "oder",
    "signInWithPasskey": "Melden Sie sich mit dem Passwort an",
    "passkeyCancelled": "Die Passkey-Anmeldung wurde abgebrochen.",
    "passkeyNotSupported": "Ihr Browser unterstützt keine Passkeys.",
    "passwordlessNotEnabled": "Die Passkey-Anmeldung ist für Ihre Organisation nicht aktiviert.",
    "totpForcedSetupIntro": "Ihre Organisation benötigt eine Zwei-Faktor-Authentifizierung. Richten Sie es jetzt ein, um die Anmeldung als {{email}} abzuschließen.",
    "totpForcedSetupTitle": "Richten Sie die Zwei-Faktor-Authentifizierung ein",
    "totpForcedSetupDescription": "Scannen Sie den QR-Code mit Ihrer Authentifizierungs-App und geben Sie dann den 6-stelligen Code ein, um die Anmeldung abzuschließen."
  },
  "secret": {
    "createTitle": "Erstellen Sie eine geheime Datei",
    "createSecret": "Passwort oder Geheimnis",
    "newSecret": "Neues Geheimnis",
    "fileName": "Dateiname",
    "fileNameRequired": "Dateiname ist erforderlich",
    "protectWithPassword": "Mit Passwort schützen",
    "protectWithSecretKey": "Mit geheimem Schlüssel schützen",
    "secretKeyWarning": "Wenn Sie diesen Schlüssel verlieren, sind die Informationen nicht mehr zugänglich",
    "changeSecretKey": "Geheimen Schlüssel ändern",
    "currentSecretKey": "Aktueller geheimer Schlüssel",
    "wrongCurrentKey": "Der aktuelle geheime Schlüssel ist falsch",
    "hint": "Hinweis",
    "hintPlaceholder": "Optionaler Hinweis, um sich den Schlüssel zu merken",
    "newSecretKey": "Neuer geheimer Schlüssel",
    "confirmSecretKey": "Bestätigen Sie den geheimen Schlüssel",
    "secretKeyMismatch": "Geheime Schlüssel stimmen nicht überein",
    "enterPassword": "Passwort eingeben",
    "confirmPassword": "Passwort bestätigen",
    "passwordRequired": "Passwort ist erforderlich",
    "passwordMinLength": "Das Passwort muss mindestens 4 Zeichen lang sein",
    "confirmPasswordRequired": "Passwort bestätigen",
    "passwordMismatch": "Passwörter stimmen nicht überein",
    "wrongPassword": "Falsches Passwort",
    "addField": "Feld hinzufügen",
    "addFieldForGroup": "Feld zur Gruppe hinzufügen",
    "removeField": "Feld entfernen",
    "editLabel": "Etikett bearbeiten",
    "fieldType": "Typ",
    "fieldLabel": "Neues Feld",
    "fieldValue": "Wert",
    "fields": {
      "heading": "Felder",
      "username": "Benutzername",
      "password": "Passwort",
      "website": "Website",
      "cardholder": "Karteninhaber",
      "number": "Kartennummer",
      "brand": "Marke",
      "exp_month": "Ablaufmonat",
      "exp_year": "Ablaufjahr",
      "cvv": "CVV",
      "title": "Anrede",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "fiscal_code": "Steuernummer",
      "passport": "Reisepass",
      "driving_license": "Führerschein",
      "email": "E-Mail",
      "phone": "Telefon",
      "address1": "Adresszeile 1",
      "address2": "Adresszeile 2",
      "address3": "Adresszeile 3",
      "city": "Stadt",
      "state": "Bundesland / Provinz",
      "zip": "PLZ",
      "country": "Land",
      "private_key": "Privater Schlüssel",
      "public_key": "Öffentlicher Schlüssel",
      "fingerprint": "Fingerprint",
      "notes": "Notizen"
    },
    "searchFields": "Suchfelder",
    "noFieldsYet": "Noch keine Felder",
    "untitled": "Ohne Titel",
    "types": {
      "text": "Text",
      "password": "Passwort",
      "url": "URL",
      "username": "Benutzername",
      "email": "E-Mail",
      "phone": "Telefon",
      "textarea": "Textbereich",
      "number": "Zahl",
      "month": "Monat",
      "year": "Jahr"
    },
    "validation": {
      "email": "Sieht nicht wie eine gültige E-Mail aus",
      "url": "Sieht nicht wie eine gültige URL aus",
      "phone": "Sieht nicht wie eine gültige Telefonnummer aus",
      "number": "Sieht nicht wie eine gültige Zahl aus"
    },
    "password": {
      "show": "Zeigen",
      "hide": "Verstecken",
      "generate": "Passwort generieren",
      "copy": "Kopie",
      "copied": "Kopiert!",
      "length": "Länge",
      "includeSymbols": "Fügen Sie Sonderzeichen ein",
      "strength": {
        "veryWeak": "Sehr schwach",
        "weak": "Schwach",
        "fair": "Gerecht",
        "strong": "Stark",
        "veryStrong": "Sehr stark"
      }
    },
    "edit": "Bearbeiten",
    "save": "Speichern",
    "saved": "Erfolgreich gespeichert",
    "cancel": "Abbrechen",
    "protectedFile": "Geschützte Datei",
    "enterPasswordToView": "Geben Sie Ihr Passwort ein, um den Inhalt anzuzeigen",
    "unlock": "Entsperren",
    "noData": "Keine Daten verfügbar",
    "loadError": "Fehler beim Laden der Datei",
    "saveError": "Fehler beim Speichern der Datei",
    "addWebsite": "Website hinzufügen",
    "addGroup": "Gruppe hinzufügen",
    "newGroup": "Neue Gruppe",
    "renameGroup": "Gruppe umbenennen",
    "deleteGroup": "Gruppe löschen",
    "moveUp": "Nach oben",
    "moveDown": "Nach unten",
    "dragToReorderField": "{{label}} zum Neuordnen ziehen",
    "dragToReorderGroup": "Gruppe {{label}} zum Neuordnen ziehen",
    "presets": {
      "credentials": "Zugangsdaten",
      "card": "Zahlungskarte",
      "identity": "Identität",
      "ssh_key": "SSH-Schlüssel",
      "custom": "Benutzerdefiniertes Geheimnis"
    },
    "groups": {
      "credentials_main": "Zugangsdaten",
      "credentials_autofill": "Autofill-Optionen",
      "card_main": "Karte",
      "identity_personal": "Persönlich",
      "identity_ids": "Ausweise",
      "identity_contact": "Kontakt",
      "identity_address": "Adresse",
      "ssh_main": "SSH-Schlüssel",
      "custom_fields": "Benutzerdefinierte Felder",
      "additional_options": "Zusätzliche Optionen"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Andere"
      }
    },
    "identity": {
      "titles": {
        "mr": "Herr",
        "ms": "Frau",
        "mx": "Mx",
        "dr": "Dr.",
        "prof": "Prof.",
        "other": "Andere"
      }
    },
    "ssh": {
      "upload": "Schlüsseldatei hochladen",
      "uploadError": "Schlüsseldatei konnte nicht gelesen werden"
    }
  },
  "publicShare": {
    "createLink": "Öffentlicher Link",
    "revokeLink": "Öffentlichen Link widerrufen",
    "revokeLinkConfirmDescription": "Den öffentlichen Link für {{fileName}} widerrufen?",
    "badgeSection": "Öffentlicher Link",
    "badgeActive": "Öffentlicher Link aktiv",
    "revoked": "Öffentlicher Link erfolgreich widerrufen",
    "createModal": {
      "title": "Öffentlichen Link erstellen",
      "fileLabel": "Datei",
      "allowDownload": "Download zulassen",
      "expirationLabel": "Ablauf (optional)",
      "expirationPlaceholder": "Niemals",
      "maxAccessCountLabel": "Maximale Zugriffsanzahl (optional)",
      "maxAccessCountPlaceholder": "Unbegrenzt",
      "protectWithPassword": "Mit Passwort schützen",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Passwort eingeben",
      "passwordRequired": "Bei aktiviertem Schutz ist ein Passwort erforderlich",
      "createLink": "Verknüpfung erstellen"
    },
    "successModal": {
      "title": "Link erstellt!",
      "message": "Der öffentliche Link wurde erstellt.",
      "copyLink": "Link kopieren",
      "warning": "Jeder mit diesem Link kann auf die Datei zugreifen.",
      "expiresAt": "Läuft ab",
      "remainingAccesses": "Verbleibende Zugriffe",
      "password": "Passwort"
    },
    "errors": {
      "linkAlreadyExists": "Für diese Datei existiert bereits ein öffentlicher Link. Widerrufen Sie es zunächst, um ein neues zu erstellen.",
      "linkNotFound": "Für diese Datei wurde kein aktiver Link gefunden.",
      "featureDisabled": "Öffentliche Links sind für Ihre Organisation deaktiviert.",
      "notOwner": "Sie müssen der Eigentümer sein, um öffentliche Links erstellen oder widerrufen zu können."
    },
    "passwordTitle": "Geschützter Inhalt",
    "passwordMessage": "Diese Datei ist durch ein Passwort geschützt. Geben Sie das Passwort ein, um darauf zuzugreifen.",
    "passwordRequired": "Passwort ist erforderlich.",
    "errorInvalidPassword": "Das von Ihnen eingegebene Passwort ist falsch. Bitte versuchen Sie es erneut.",
    "passwordSubmit": "Zugang",
    "errorExpiredTitle": "Link abgelaufen",
    "errorExpiredMessage": "Dieser Freigabelink ist nicht mehr gültig. Das Ablaufdatum ist abgelaufen. Wenden Sie sich an die Person, die Ihnen den Link gesendet hat, um einen neuen Link anzufordern.",
    "errorMaxAccessTitle": "Zugriffslimit erreicht",
    "errorMaxAccessMessage": "Dieser Link hat die maximale Anzahl erlaubter Zugriffe erreicht. Wenden Sie sich an die Person, die Ihnen den Link gesendet hat, um einen neuen Link anzufordern.",
    "errorNotFoundTitle": "Ungültiger Link",
    "errorNotFoundMessage": "Der Link, den Sie öffnen möchten, existiert nicht oder wurde vom Eigentümer widerrufen. Bitte überprüfen Sie, ob Sie URL korrekt kopiert haben.",
    "folderContents": "Ordnerinhalt",
    "items": "Artikel",
    "fileSize": "Größe",
    "fileType": "Typ",
    "sharedAt": "Geteilt am",
    "list": {
      "title": "Meine öffentlichen Links",
      "description": "Verwalten Sie Ihre öffentlichen Freigabelinks. Widerrufen Sie einen Link, um ihn zu deaktivieren.",
      "fileName": "Name",
      "type": "Typ",
      "status": "Status",
      "statusActive": "Aktiv",
      "statusExpired": "Abgelaufen",
      "statusExhausted": "Limit erreicht",
      "expiresAt": "Läuft ab",
      "accessCount": "Zugriffe",
      "hasPassword": "Passwort",
      "empty": "Noch keine öffentlichen Links."
    }
  },
  "common": {
    "buttons": "Knöpfe",
    "change": "Ändern",
    "setting": "Einstellung",
    "background": "Hintergrund",
    "foreground": "Vordergrund",
    "edit": "Bearbeiten",
    "remove": "Entfernen",
    "settings": "Einstellungen",
    "integrations": "Integrationen",
    "customizations": "Anpassungen",
    "enable": "Aktivieren",
    "logout": "Abmelden",
    "features": "Merkmale",
    "day_one": "{{count}} Tag",
    "day_other": "{{count}} Tage",
    "files": "Dateien",
    "received": "Empfangen",
    "rename": "Umbenennen",
    "cancel": "Abbrechen",
    "cancelUpload": "Hochladen abbrechen",
    "canceled": "Abgesagt",
    "close": "Schließen",
    "open": "Offen",
    "createFolder": "Ordner erstellen",
    "openFolder": "Ordner öffnen",
    "uploadFolder": "Ordner hochladen",
    "uploadFile": "Datei hochladen",
    "downloadEncrypted": "Verschlüsselt herunterladen",
    "createdBy": "Erstellt von",
    "login": "Anmelden",
    "otpCode": "OTP-Code",
    "passkeys": "Passkeys",
    "email": "E-Mail",
    "username": "Benutzername",
    "emails": "E-Mails",
    "emailLabel": "E-Mail-Label",
    "emailPlaceholder": "E-Mail-Platzhalter",
    "labels": "Etiketten",
    "inputs": "Eingaben",
    "loginLabel": "Anmeldeetikett",
    "resendOtpLabel": "OTP-Etikett erneut senden",
    "otpCodeLabel": "OTP Codeetikett",
    "allUsers": "Alle Benutzer",
    "allGroups": "Alle Gruppen",
    "globalSearchPlaceholder": "Suchen Sie nach Dateien und Ordnern",
    "folderPickerSearchInFolder": "In diesem Ordner suchen",
    "globalSearchDescription": "Beginnen Sie mit der Eingabe, um nach Dateien und Ordnern zu suchen",
    "filterExactMatch": "Genaue Übereinstimmung (ganzes Wort)",
    "filterWholeWord": "Like-Suche (Platzhalter)",
    "loading": "Laden...",
    "loadingDescription": "Bitte warten Sie, während wir Ihre Daten laden",
    "thinking": "Denken...",
    "thinkingDescription": "AI bearbeitet Ihre Anfrage",
    "noResults": "Keine Ergebnisse gefunden",
    "noFilesFound": "Keine Dateien gefunden",
    "hidden": "Versteckt",
    "hide": "Verstecken",
    "lock": "Sperren",
    "file": "Datei",
    "fileSize": "Dateigröße",
    "tags": "Schlagworte",
    "tag": "Etikett",
    "title": "Titel",
    "users": "Benutzer",
    "user": "Benutzer",
    "systemUser": "System",
    "groups": "Gruppen",
    "overview": "Überblick",
    "mode": "Modus",
    "opacity": "Opazität",
    "includeUserEmail": "Geben Sie die E-Mail-Adresse des Benutzers an",
    "appliesToExternalUsers": "Gilt für externe Benutzer",
    "blurOnFocusLoss": "Unschärfe bei Fokusverlust",
    "maxExpirationDays": "Maximaler Ablauf (Tage)",
    "noRecipients": "Keine Empfänger",
    "createdAt": "Erstellt bei",
    "group": "Gruppe",
    "reviewTeam": "Review-Team",
    "folder": "Ordner",
    "publicLink": "Öffentlicher Link",
    "publicLinkTitle": "Öffentlicher Filegrant-Link",
    "logs": "Protokolle",
    "addUsersOrGroups": "Fügen Sie Benutzer oder Gruppen hinzu",
    "addUsers": "Benutzer hinzufügen",
    "userTagInputEmptyPlaceholder": "Beginnen Sie mit der Eingabe, um nach Benutzern oder Gruppen zu suchen",
    "member": "Mitglied",
    "member_zero": "Keine Mitglieder",
    "member_other": "Mitglieder",
    "uploaded": "Hochgeladen",
    "failed": "Fehlgeschlagen",
    "retries": "Wiederholungen",
    "preparingFilesForUpload": "Dateien für den Upload vorbereiten",
    "uploadingFilesCounter": "Dateien werden hochgeladen: {{amount}} von {{total}}",
    "uploadedFilesCounter": "Hochgeladen {{amount}} von {{total}}",
    "copyLink": "Link kopieren",
    "unhide": "Einblenden",
    "licenseLimitation": "Lizenzbeschränkung",
    "deletionDate": "Löschdatum",
    "creationDate": "Erstellungsdatum",
    "newUser": "Neuer Benutzer",
    "newGroup": "Neue Gruppe",
    "noActionsAvailable": "Keine Aktionen verfügbar",
    "author": "Autor",
    "openProtectedFile": "Geschützte Datei öffnen",
    "showFilesSharedWith": "Dateien anzeigen, die mit geteilt wurden",
    "showFilesSharedBy": "Dateien anzeigen, die von geteilt wurden",
    "upload": "Hochladen",
    "youCanRequestANewOtpIn": "Sie können ein neues OTP in anfordern",
    "otpExpired": "OTP abgelaufen",
    "otpValidFiveMinutesOnce": "Dieser Code ist 5 Minuten gültig und funktioniert einmal.",
    "generateNewOtp": "Neues OTP generieren",
    "clickHereToGenerateNewOtp": "Klicken Sie hier, um ein neues OTP zu generieren",
    "preparingFileForDownload": "Datei wird für den Download vorbereitet",
    "preparingForDownload": "Vorbereitung zum Download",
    "uploadErrors": "Fehler beim Hochladen",
    "uploadErrorsDescription": "Einige Dateien konnten nicht hochgeladen werden",
    "size": "Größe",
    "status": "Status",
    "percentage": "Prozentsatz",
    "viewer": "Zuschauer",
    "editor": "Editor",
    "shareWith": "Teilen mit",
    "retry": "Wiederholen",
    "regenerate": "Regenerieren",
    "permissions": "Berechtigungen",
    "expiration": "Ablauf",
    "message": "Nachricht",
    "uploadingFiles": "Hochladen von Dateien",
    "addFiles": "Dateien hinzufügen",
    "addFolders": "Ordner hinzufügen",
    "max": "Max.",
    "preview": "Vorschau",
    "write": "Schreiben",
    "quickShare": "Schnell teilen",
    "maxFilesAmountAndSizeEach": "Maximal {{amount}} Dateien, jeweils {{size}}MB",
    "startUploadAndShare": "Starten Sie den Upload und teilen Sie ihn",
    "processing": "Verarbeitung",
    "startNewUploadAndShare": "Neuen Upload starten und teilen",
    "continue": "Weitermachen",
    "goToFileManager": "Gehen Sie zum Dateimanager",
    "goToQuickShare": "Gehen Sie zu Quick Share",
    "viewAll": "Alle anzeigen",
    "emptyUsersList": "Hier finden Sie die von Ihnen hinzugefügten Benutzer",
    "emptyGroupsList": "Hier finden Sie die von Ihnen hinzugefügten Gruppen",
    "confirmationMessage": "Bestätigungsnachricht",
    "lastModified": "Zuletzt geändert",
    "opened": "Geöffnet",
    "lastAccess": "Letzter Zugriff",
    "accessExpiration": "Ablauf des Zugriffs",
    "description": "Beschreibung",
    "descriptionNotEditable": "Die Beschreibung kann nicht bearbeitet werden",
    "sharedItems": "Geteilte Artikel",
    "sharedItemsCount": "Geteiltes {{count}}-Element",
    "sharedItemsCount_other": "Geteilte {{count}}-Elemente",
    "itemsSharedWith": "Mit <strong>{{resource}}</strong> geteilte Elemente",
    "manageItems": "Artikel verwalten",
    "items": "Artikel",
    "visibleToAdminsOnly": "Nur für Administratoren sichtbar",
    "pleaseEnterName": "Bitte geben Sie einen Namen ein",
    "pleaseEnterFirstName": "Bitte geben Sie einen Vornamen ein",
    "pleaseEnterLastName": "Bitte geben Sie einen Nachnamen ein",
    "pleaseEnterEmail": "Bitte geben Sie eine E-Mail ein",
    "invalidEmail": "Die Eingabe ist keine gültige E-Mail",
    "nameCannotBeEmail": "Der Name darf keine E-Mail-Adresse sein",
    "publicLinkSearchHint": "Die Suche filtert diesen Ordner, nachdem alle Seiten vollständig geladen wurden",
    "companyTag": "Firmenkennzeichen",
    "replace": "Ersetzen",
    "fileName": "Dateiname",
    "enterFileName": "Geben Sie den Dateinamen ein",
    "new": "Neu",
    "organize": "Organisieren",
    "downloadFile": "Datei herunterladen",
    "expiry": "Ablauf",
    "downloadPdf": "PDF herunterladen",
    "downloadEncryptedFile": "Laden Sie die verschlüsselte Datei herunter",
    "save": "Speichern",
    "createShortcut": "Verknüpfung erstellen",
    "create": "Erstellen",
    "createShortcutFor": "Verknüpfung für {{resource}} erstellen",
    "selectFolderToCreateFileShortcut": "Wählen Sie eine Position aus, um den Ordnerpfad anzuzeigen, in dem die Datei erstellt wird",
    "editUser": "Benutzer bearbeiten",
    "unblockUser": "Benutzer entsperren",
    "blockUser": "Benutzer blockieren",
    "deleteUser": "Benutzer löschen",
    "excludeFromSso": "Von SSO ausschließen",
    "includeInSso": "SSO erneut aktivieren",
    "confirm": "Bestätigen",
    "search": "Suchen",
    "noUsersFound": "Keine Benutzer gefunden",
    "noSettingsFound": "Keine Einstellungen gefunden",
    "block": "Blockieren",
    "unblock": "Entsperren",
    "role": "Rolle",
    "addedOn": "Hinzugefügt",
    "memberOfNGroups": "Mitglied von N°-Gruppen",
    "noExpirationDate": "Kein Ablaufdatum",
    "groupsMember": "Gruppenmitglied",
    "onBehalfOf": "Im Namen von",
    "exitFromBehalfOfMode": "Verlassen Sie den Namensmodus",
    "expiryDate": "Verfallsdatum",
    "select": "Wählen",
    "nothingHasBeenSharedYet": "Es wurde noch nichts geteilt",
    "manageGroups": "Gruppen verwalten",
    "noGroupsYet": "Noch keine Gruppen",
    "addExpirationDate": "Ablaufdatum hinzufügen",
    "editExpirationDate": "Ablaufdatum bearbeiten",
    "edited": "Bearbeitet",
    "removed": "ENTFERNT",
    "removeExpirationDate": "Ablaufdatum entfernen",
    "usersWithSharedFiles": "Benutzer mit freigegebenen Dateien",
    "usersWithoutSharedFiles": "Benutzer ohne freigegebene Dateien",
    "changeRole": "Rolle wechseln",
    "yes": "Ja",
    "no": "NEIN",
    "selected": "Ausgewählt",
    "editGroup": "Gruppe bearbeiten",
    "viewGroup": "Gruppe anzeigen",
    "numberOfMembers": "Anzahl der Mitglieder",
    "numberOfMembersInline": "{{count}}-Mitglied",
    "numberOfMembersInline_one": "{{count}}-Mitglied",
    "numberOfMembersInline_other": "{{count}} Mitglieder",
    "groupMembers": "Gruppenmitglieder",
    "editGroups": "Gruppen bearbeiten",
    "noUsers": "Keine Benutzer",
    "deleteGroup": "Gruppe löschen",
    "documents": "Unterlagen",
    "images": "Bilder",
    "audio": "Audio",
    "video": "Video",
    "other": "Andere",
    "fileExtensionType": {
      "Text": "Text",
      "SourceCode": "Quellcode",
      "Markup": "Markup",
      "Data": "Daten",
      "Image": "Bild",
      "Video": "Video",
      "Audio": "Audio",
      "Document": "Dokumentieren",
      "Spreadsheet": "Kalkulationstabelle",
      "Presentation": "Präsentation",
      "Archive": "Archiv",
      "Database": "Datenbank",
      "Font": "Schriftart",
      "System": "System",
      "Executable": "Ausführbar",
      "Configuration": "Konfiguration",
      "Log": "Protokoll",
      "Backup": "Sicherung",
      "Certificate": "Zertifikat",
      "Model3D": "3D-Modell",
      "CAD": "CAD",
      "GIS": "GIS",
      "Scientific": "Wissenschaftlich",
      "EBook": "E-Book",
      "Vector": "Vektor",
      "Raw": "Roh"
    },
    "fileTypes": "Dateitypen",
    "download": "Herunterladen",
    "share": "Teilen",
    "createCopy": "Kopie erstellen",
    "markAsRead": "Als gelesen markieren",
    "markAsUnread": "Als ungelesen markieren",
    "move": "Bewegen",
    "convertToPdf": "In PDF konvertieren",
    "convert": "Konvertieren",
    "wordDocument": "Word-Dokument",
    "excelDocument": "Excel-Dokument",
    "pptDocument": "PowerPoint-Dokument",
    "hideFromList": "Aus Liste ausblenden",
    "showInList": "In Liste anzeigen",
    "editAccessAndProtections": "Zugriff und Schutz bearbeiten",
    "tagColor": "Tag-Farbe",
    "tagName": "Tag-Name",
    "addToFavorites": "Zu Favoriten hinzufügen",
    "removeFromFavorites": "Aus Favoriten entfernen",
    "deletePermanently": "Dauerhaft löschen",
    "delete": "Löschen",
    "selectedItems": "Ausgewählte Artikel",
    "deselectAll": "Alle abwählen",
    "signOut": "Abmelden",
    "tagTitle": "Tag-Titel",
    "noTagsYet": "Noch keine Tags",
    "untitledDocument": "Unbenanntes Dokument",
    "copyOf": "Kopie von",
    "restoreFromTrash": "Aus dem Papierkorb wiederherstellen",
    "shared": "Geteilt",
    "expiresOn": "Läuft am {{date}} ab",
    "shareExpiredOn": "Freigabe abgelaufen am {{date}}",
    "favourite": "Favorit",
    "favouriteAddedTo": "hinzugefügt",
    "favouriteRemovedFrom": "entfernt von",
    "publicLinkLabel": "Öffentlicher Link",
    "classificationInProgress": "Klassifizierung läuft",
    "forSale": "Zu verkaufen",
    "favorites": "Favoriten",
    "recent": "Zuletzt",
    "transferOwnership": "Eigentum übertragen",
    "trash": "Papierkorb",
    "expirationDate": "Verfallsdatum",
    "details": "Details",
    "unlock": "Entsperren",
    "activities": "Aktivitäten",
    "copyToClipboard": "In die Zwischenablage kopieren",
    "fileType": "Dateityp",
    "noTagsApplied": "Auf diese Datei wurden keine Tags angewendet",
    "notSharedYet": "Noch nicht geteilt",
    "manageAccess": "Zugriff verwalten",
    "selectItemToViewDetails": "Wählen Sie ein Element aus, um dessen Details anzuzeigen",
    "unlockFolderToViewDetails": "Entsperren Sie den Ordner, um Details anzuzeigen",
    "unlockFolderToViewSize": "Entsperren Sie den Ordner, um die Größe anzuzeigen",
    "folderContent": "Ordnerinhalt",
    "calculateFolderSize": "Größe berechnen",
    "recalculate": "Neu berechnen",
    "recalculateCooldown": "Bitte warten Sie einen Moment, bevor Sie die Neuberechnung durchführen",
    "subfolders": "Unterordner",
    "totalSize": "Gesamtgröße",
    "filters": "Filter",
    "owner": "Eigentümer",
    "linkCopied": "Link in die Zwischenablage kopiert!",
    "account": "Konto",
    "customization": "Anpassung",
    "adminRegisteredUserVisibility": "Sichtbarkeit für vom Administrator registrierte Benutzer",
    "adminRegisteredUserVisibilityDescription": "Machen Sie vom Administrator registrierte Benutzer sichtbar, sofern diese Option nicht deaktiviert ist. Sichtbarkeit nur durch Dateifreigabe.",
    "autoFileDeletion": "Automatisches Löschen von Dateien",
    "autoFileDeletionDescription": "Dateien nach einem angegebenen Erstellungsdatum und Aufbewahrungszeitraum automatisch löschen.",
    "cannotOpenFileOnBehalf": "Sie können keine Dateien im Auftrag von Mode öffnen.",
    "certifiedTimestamping": "Zertifizierter Zeitstempel",
    "certifiedTimestampingDescription": "Ermöglichen Sie Mitwirkenden, mithilfe eines digitalen Zertifikats ein zertifiziertes Datum auf Dateien anzuwenden.",
    "compressionCompleted": "Komprimierung abgeschlossen",
    "compressionFailed": "Die Komprimierung ist fehlgeschlagen",
    "compressionOfFilesInProgress": "Komprimierung von Dateien läuft",
    "verifyingFileIntegrity": "Dateiintegrität wird überprüft...",
    "fileIntegrityVerified": "Dateiintegrität überprüft",
    "downloadCompletedWithExclusions": "Der Download wurde abgeschlossen, aber einige Dateien wurden ausgeschlossen",
    "moveCompletedWithExclusions": "Die Verschiebung wurde abgeschlossen, aber einige Dateien konnten nicht verschoben werden",
    "filesExcludedForMove": "Die folgenden Dateien konnten nicht verschoben werden:",
    "excludedFilesTitle": "Ausgeschlossene Dateien",
    "viewExcludedFiles": "Ausgeschlossene Dateien anzeigen",
    "filesExcludedForRestrictions": "Einige Dateien wurden aufgrund von Einschränkungen ausgeschlossen:",
    "contributorStorageLimit": "Speicherlimit für Mitwirkende",
    "contributorStorageLimitDescription": "Legen Sie Speicherplatzbeschränkungen fest, damit Mitwirkende neue Dateien hochladen können.",
    "contents": "Inhalt",
    "deviceAccessLimitation": "Beschränkung des Gerätezugriffs",
    "deviceAccessLimitationDescription": "Beschränken Sie den Zugriff auf eine Reihe von Geräten und trennen Sie ältere Geräte.",
    "downloadPreparation": "Download wird vorbereitet",
    "downloadReady": "Download bereit",
    "editorFileManagement": "Editor-Dateiverwaltung",
    "editorFileManagementDescription": "Erlauben Sie Mitwirkenden, Dateien gemäß den Berechtigungen zu löschen und umzubenennen.",
    "fileSizeLimit": "Dateigrößenbeschränkung",
    "fileSizeLimitDescription": "Beschränken Sie die maximale Größe jeder Datei, die hochgeladen werden kann.",
    "folderCreationPermission": "Berechtigung zur Ordnererstellung",
    "folderCreationPermissionDescription": "Legen Sie fest, ob Mitwirkende berechtigt sind, neue Ordner zu erstellen.",
    "groupCreationControl": "Kontrolle der Gruppenerstellung",
    "groupCreationControlDescription": "Steuern Sie, welche Mitwirkenden Gruppen erstellen dürfen.",
    "members": "Mitglieder",
    "msOfficeEditing": "Word-, Excel- und Powerpoint-Bearbeitung",
    "msOfficeEditingDescription": "Ermöglichen Sie Mitgliedern die direkte Bearbeitung von Dokumenten mit dem Online-Editor Microsoft Office.",
    "newButton": "Neu",
    "security": "Sicherheit",
    "sessionControl": "Sitzungskontrolle",
    "sessionControlDescription": "Begrenzen Sie die Anzahl gleichzeitiger Sitzungen pro Benutzer.",
    "sessions": "Sitzungen",
    "superAdmins": "Super-Admins",
    "uploadWithTag": "Mit Tag hochladen",
    "uploadWithTagDescription": "Erfassen und setzen Sie automatisch das in Quelldateien erkannte Tag.",
    "withExpiration": "Mit Ablauf",
    "withoutExpiration": "Ohne Ablauf",
    "addTag": "Tag hinzufügen",
    "openFileLocation": "Dateispeicherort öffnen",
    "loadingTags": "Tags werden geladen...",
    "unlimited": "Unbegrenzt",
    "dropHereYourFirstFile": "Legen Sie hier Ihre erste Datei ab",
    "noFilesReceived": "Keine Dateien erhalten",
    "hereYouCanFindFavoritesFiles": "Hier finden Sie Ihre Lieblingsdateien",
    "noRecentlyOpenedFiles": "Keine kürzlich geöffneten Dateien",
    "hereYouCanFindSharedFiles": "Hier finden Sie freigegebene Dateien",
    "hereYouCanFindDeletedFiles": "Hier finden Sie gelöschte Dateien",
    "noFiles": "Keine Dateien",
    "loadingFiles": "Dateien werden geladen...",
    "filesFetchFailed": "Dateien konnten nicht geladen werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "shareDisabledNoRecipients": "Fügen Sie mindestens einen Benutzer oder eine Gruppe zum Teilen hinzu",
    "shareDisabledNoChanges": "Keine Änderungen zum Speichern",
    "editorDisabledByPolicy": "Für diese Dateien ist keine Editorberechtigung zulässig",
    "editorDisabledCannotElevate": "Sie können diese Freigabe nicht zum Editor heraufstufen",
    "hereYouCanFindHiddenFiles": "Hier finden Sie versteckte Dateien",
    "noFilesInThisFolder": "Keine Dateien in diesem Ordner",
    "noGroupsFound": "Keine Gruppen gefunden",
    "sell": "Verkaufen",
    "loadingPermissions": "Ladeberechtigungen...",
    "me": "Mich",
    "applyTags": "Wenden Sie Tags an",
    "emptyTrash": "Leeren Sie den Müll",
    "classify": "KI-Klassifizierung",
    "active": "Aktiv",
    "activeDescription": "Aktivieren oder deaktivieren Sie diese Einstellung",
    "add": "Hinzufügen",
    "rule": "Regel",
    "selectTags": "Wählen Sie Tags aus",
    "manageExceptions": "Ausnahmen verwalten",
    "selectFolders": "Wählen Sie Ordner aus",
    "selectUsers": "Wählen Sie Benutzer aus",
    "selectGroups": "Wählen Sie Gruppen aus",
    "selectDate": "Datum auswählen",
    "none": "Keiner",
    "addRule": "Regel hinzufügen",
    "addConfiguration": "Konfiguration hinzufügen",
    "aiAgents": "KI-Agenten",
    "daysLeft": "Tage übrig",
    "disabled": "Deaktiviert",
    "enabled": "Ermöglicht",
    "months": "Monate",
    "years": "Jahre",
    "totpStatus": {
      "enabled": "2FA aktiv",
      "enabledExempt": "2FA aktiv (ausgenommen)",
      "exempt": "Ausgenommen von 2FA",
      "exemptExpires": "Befreit bis {{date}}"
    },
    "clientId": "Kunden-ID",
    "clientSecret": "Client-Geheimnis",
    "tenantId": "Mieter-ID",
    "domains": "Domänen",
    "addDomain": "Domäne hinzufügen",
    "addItem": "Artikel hinzufügen",
    "artificialIntelligence": "Künstliche Intelligenz",
    "artificialIntelligenceSummary": "KI-Zusammenfassung",
    "artificialIntelligenceDocumentChat": "Chatten Sie mit Dokument",
    "generatingSummary": "Zusammenfassung erstellen",
    "startNewConversation": "Beginnen Sie ein neues Gespräch",
    "groupMembership": "Gruppenmitgliedschaft",
    "expired": "Abgelaufen",
    "sharedBy": "Geteilt von",
    "shareRequests": "Teilen Sie Anfragen",
    "fileShareRequests": "Dateifreigabeanfragen",
    "noShareRequests": "Keine Freigabeanfragen",
    "activityLog": "Aktivitätsprotokoll",
    "targetType": "Zieltyp",
    "operationType": "Operationstyp",
    "fromDate": "Ab Datum",
    "toDate": "Miteinander ausgehen",
    "classificationStatus": "IA-Klassifizierung",
    "invite": "Einladen",
    "send": "Schicken",
    "target": "Ziel",
    "operation": "Betrieb",
    "timestamp": "Zeitstempel",
    "export": "Exportieren",
    "exportActivityLogsDescription": "Exportieren Sie die sichtbaren Aktivitätsprotokolle in eine CSV-Datei",
    "clickForDetailAiClassification": "Klicken Sie hier, um Einzelheiten zur KI-Klassifizierung anzuzeigen",
    "aiClassificationStatus": "AI-Klassifizierungsstatus",
    "noActivityLogsFound": "Keine Aktivitätsprotokolle gefunden",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Löschen Sie Datums- und Typfilter",
      "downloads24h": "Dateidownloads in den letzten 24 Stunden",
      "failedLogins7d": "Fehlgeschlagene Anmeldungen in den letzten 7 Tagen",
      "last24hAllActivity": "Alle Aktivitäten in den letzten 24 Stunden",
      "last24hLogins": "Anmeldungen in den letzten 24 Stunden",
      "last7DaysAllActivity": "Alle Aktivitäten in den letzten 7 Tagen",
      "sharing7d": "Dateifreigabe in den letzten 7 Tagen",
      "title": "Schnelle Filtervoreinstellungen"
    },
    "waitingForUpload": "Warten auf Upload",
    "waitingForNetwork": "Warten auf Netzwerk",
    "uploadsPausedWaitingForNetwork": "Uploads angehalten – Warten auf Netzwerkverbindung",
    "offline": "Offline",
    "noPermissions": "Keine Berechtigungen",
    "additionalData": "Zusätzliche Daten",
    "noActivities": "Keine Aktivitäten",
    "multipleOwners": "Mehrere Eigentümer",
    "mixed": "Gemischt",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "multipleExpiryDates": "Mehrere Ablaufdaten",
    "copied": "Kopiert!",
    "copy": "Kopie",
    "editFile": "Datei bearbeiten",
    "untitled": "Ohne Titel",
    "editModeEnabled": "Bearbeitungsmodus aktiviert",
    "exitEditMode": "Bearbeitungsmodus verlassen",
    "editModeDisabled": "Bearbeitungsmodus deaktiviert",
    "reload": "Neu laden",
    "forward10Seconds": "10 Sekunden vorwärts",
    "backward10Seconds": "10 Sekunden rückwärts",
    "goToStart": "Gehen Sie zum Start",
    "goToEnd": "Gehe zum Ende",
    "playbackSpeed": "Wiedergabegeschwindigkeit",
    "error": "Fehler",
    "shareAgain": "Nochmals teilen",
    "expiringSoon": "Läuft bald ab",
    "filterByTargetOrOperation": "Filtern Sie nach Ziel oder Vorgang",
    "searchByFileName": "Suche nach Dateinamen",
    "versions": "Versionen",
    "version": "Version",
    "restore": "Wiederherstellen",
    "showMoreVersions": "Weitere Versionen anzeigen",
    "showLessVersions": "Weniger Versionen anzeigen",
    "currentVersion": "Aktuelle Version",
    "bold": "Deutlich",
    "italic": "Kursiv",
    "link": "Link",
    "unorderedList": "Ungeordnete Liste",
    "orderedList": "Geordnete Liste",
    "header1": "Kopfzeile 1",
    "header2": "Kopfzeile 2",
    "header3": "Kopfzeile 3",
    "paragraph": "Absatz",
    "secondsAgo": "vor Sekunden",
    "all": "Alle",
    "dataLossPrevention": "Verhinderung von Datenverlust",
    "uploadSuccess": "Hochladen erfolgreich",
    "uploading": "Hochladen",
    "readOnly": "Schreibgeschützt",
    "aiScrapingProtectionOn": "KI-Scraping-Schutz aktiviert",
    "openFileLocally": "Datei lokal öffnen",
    "reloadPage": "Seite neu laden",
    "reloadingPageIn": "Neuladen der Seite in <strong>{{count}}</strong>",
    "keepOffline": "Auf Gerät synchronisieren",
    "openFileOnline": "Datei online öffnen",
    "saveAndContinue": "Speichern und fortfahren",
    "cancelAndContinue": "Abbrechen und fortfahren",
    "language": "Sprache",
    "colorScheme": {
      "title": "Erscheinungsbild",
      "light": "Hell",
      "dark": "Dunkel",
      "system": "Folgen Sie dem System"
    },
    "accessibility": {
      "title": "Barrierefreiheit",
      "highContrast": "Hoher Kontrast",
      "reduceMotion": "Bewegung reduzieren",
      "none": "Aus",
      "activeCount": "{{count}} an"
    },
    "impersonateUser": "Sich als Benutzer ausgeben",
    "protect": "Schützen",
    "setPassword": "Passwort festlegen",
    "password": "Passwort",
    "stopImpersonation": "Stoppen Sie den Identitätswechsel",
    "loggedInAs": "Angemeldet als",
    "enterReason": "Grund für den Identitätswechsel eingeben...",
    "timeRemaining": "Verbleibende Zeit",
    "notifications": "Benachrichtigungen",
    "clear": "Löschen",
    "markAllRead": "Alle als gelesen markieren",
    "clearAll": "Alles löschen",
    "noNotifications": "Keine Benachrichtigungen",
    "batches": "Batches",
    "noActiveBatches": "Keine aktiven Batches",
    "refresh": "Aktualisieren",
    "refreshCooldown": "Bitte warten Sie {{seconds}}s, bevor Sie die Aktualisierung erneut durchführen",
    "minutes": "Minuten",
    "justNow": "Soeben",
    "minutesAgo": "Vor {{count}} Minute",
    "minutesAgo_other": "Vor {{count}} Minuten",
    "hoursAgo": "Vor {{count}} Stunde",
    "hoursAgo_other": "Vor {{count}} Stunden",
    "daysAgo": "Vor {{count}} Tag",
    "daysAgo_other": "Vor {{count}} Tagen",
    "monthsAgo": "Vor {{count}} Monat",
    "monthsAgo_other": "Vor {{count}} Monaten",
    "yearsAgo": "Vor {{count}} Jahr",
    "yearsAgo_other": "Vor {{count}} Jahren",
    "fileNotFound": "Datei nicht gefunden",
    "selectAll": "Alles auswählen",
    "clearSelection": "Auswahl aufheben",
    "import": "Importieren",
    "noFilesMatchingFilters": "Keine Dateien, die den Filtern entsprechen. Versuchen Sie, einige Filter zu entfernen oder die Suchkriterien zu ändern",
    "noUsersMatchingFilters": "Keine Benutzer, die mit den Filtern übereinstimmen. Versuchen Sie, einige Filter zu entfernen oder die Suchkriterien zu ändern",
    "noGroupsMatchingFilters": "Keine Gruppen, die den Filtern entsprechen. Versuchen Sie, einige Filter zu entfernen oder die Suchkriterien zu ändern",
    "AIGrant": "AIGrant",
    "emailGrant": "EmailGrant",
    "searchTags": "Suchtags",
    "expand": "Expandieren",
    "showMore": "Mehr anzeigen",
    "collapse": "Zusammenbruch",
    "manageUsersAndGroups": "Verwalten Sie Benutzer und Gruppen",
    "public": "Öffentlich",
    "private": "Privat",
    "approved": "Genehmigt",
    "rejected": "Abgelehnt",
    "pending": "Ausstehend",
    "pendingApprovalTooltip": "Warten auf Genehmigung, angefordert {{date}}",
    "approvedByTeamTooltip": "Freigabe vom Team {{date}} genehmigt",
    "rejectedByTeamTooltip": "Freigabe vom Team {{date}} abgelehnt",
    "reject": "Ablehnen",
    "rejectFileShareRequest": "Anfrage zur Dateifreigabe ablehnen",
    "rejectionReason": "Ablehnungsgrund",
    "rejectionReasonPlaceholder": "Geben Sie den Grund für die Ablehnung ein",
    "moreOwners": "Mehr Eigentümer",
    "permissionLevel": "Berechtigungsstufe",
    "name": "Name",
    "approve": "Genehmigen",
    "from": "Aus",
    "to": "Zu",
    "requester": "Anforderer",
    "shareTo": "Teilen mit",
    "limitation": "Einschränkung",
    "selectRequestToViewDetails": "Wählen Sie eine Anfrage aus, um Details anzuzeigen",
    "shareRequestApprovalTitle": "Freigabeanforderungsgenehmigung für {{fileName}}",
    "noFilesAvailable": "Keine Dateien verfügbar",
    "accessDenied": "Zugriff verweigert",
    "fileShareRequestsList": "Liste der Dateifreigabeanfragen",
    "fileShareRequestsDescription": "Dateifreigabeanfragen genehmigen oder ablehnen. Klicken Sie auf der linken Seite auf eine Anfrage, um deren Details anzuzeigen.",
    "waiting": "Warten",
    "tagIsUsedForFileVisibility": "Dateien mit diesem Tag werden für andere Benutzer freigegeben, wie in der Einstellung „Sichtbarkeit markierter Dateien“ festgelegt",
    "systemTagLocked": "Vom Server verwaltetes System-Tag: kann nicht entfernt werden.",
    "tagRemovalRestricted": "Ihr Administrator erlaubt nicht, dieses Tag aus Dateien zu entfernen.",
    "tagAdditionRestricted": "Ihr Administrator lässt das Hinzufügen dieses Tags zu Dateien nicht zu.",
    "completingLogin": "Anmeldung wird abgeschlossen...",
    "redirectingToLogin": "Weiterleitung zum Login...",
    "redirecting": "Weiterleitung...",
    "twoFactorAuthentication": "2FA",
    "debug": "Debuggen",
    "sessionExpiresIn": "Dieser Ordner wird in {{time}} wieder gesperrt",
    "protectedFolder": "Geschützter Ordner",
    "sessionsTitle": "Sitzungen für {{fileName}} freischalten",
    "folderSessions": "Ordnersitzungen",
    "publicLinks": "Öffentliche Links",
    "revoke": "Widerrufen",
    "revokeLink": "Öffentlichen Link widerrufen",
    "revokeLinkConfirmDescription": "Den öffentlichen Link für {{fileName}} widerrufen?",
    "protectedContentTitle": "Geschützter Inhalt",
    "protectedContentMessage": "Dieser Inhalt ist durch ein Passwort geschützt. Geben Sie das Passwort ein, um darauf zuzugreifen.",
    "accessCodeRequired": "Passwort ist erforderlich.",
    "accessCodeLabel": "Passwort",
    "accessCodePlaceholder": "Passwort eingeben",
    "access": "Zugang",
    "folderContents": "Ordnerinhalt",
    "sharedAt": "Geteilt am",
    "alerts": {
      "moreCount": "{{count}} weitere Benachrichtigungen",
      "manageTwoFactor": "2FA verwalten",
      "dismissMenu": "Schlummern oder entlassen",
      "snoozePreset": {
        "h24": "1 Tag",
        "h72": "3 Tage",
        "h168": "1 Woche"
      },
      "snoozeHoursGeneric": "{{count}} Stunden"
    },
    "usersFetchFailed": "Benutzer konnten nicht geladen werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "groupsFetchFailed": "Gruppen konnten nicht geladen werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "emailsFetchFailed": "E-Mails konnten nicht geladen werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "pleaseSelectRole": "Bitte wählen Sie eine Rolle aus",
    "selectColor": "Farbe auswählen",
    "color": "Farbe",
    "loadingActivities": "Aktivitäten werden geladen...",
    "quickShareMessagePlaceholder": "Eine Nachricht an ausgewählte Benutzer schreiben...",
    "signFile": "Datei signieren"
  },
  "roles": {
    "1000": "Super-Admin",
    "1001": "Admin",
    "2001": "Mitwirkender",
    "3002": "Leser",
    "4001": "Extern"
  },
  "accessMap": {
    "tagAccessTabLabel": "Zugriff und Schutz",
    "entityAccessTabLabel": "Tags und Schutzmaßnahmen",
    "visibility": "Sichtweite",
    "appliedProtections": "Angewandte Schutzmaßnahmen",
    "appliedTo": "Angewendet auf",
    "appliedToNobody": "Derzeit erhält niemand diesen Schutz durch dieses Tag.",
    "configuration": "Konfiguration",
    "exceptions": "Ausnahmen",
    "exceptionsCount": "{{count}}-Ausnahme",
    "exceptionsCount_one": "{{count}}-Ausnahme",
    "exceptionsCount_other": "{{count}} Ausnahmen",
    "hasExceptionsTooltip": "Einige Empfänger sind von diesem Schutz ausgeschlossen.",
    "openInSettings": "In den Einstellungen öffnen",
    "otherTagsInSetting": "Andere Tags, die diesen Schutz aktivieren",
    "noProtectionsForTag": "Auf dieses Tag wurden noch keine Schutzmaßnahmen angewendet.",
    "noProtectionsForThisTag": "Von diesem Tag wurden keine Schutzmaßnahmen übernommen.",
    "configureProtection": "Konfigurieren Sie einen Schutz",
    "publicTagShort": "Öffentlich",
    "privateTagShort": "Privat",
    "allUsersInCompany": "Alle Benutzer im Unternehmen",
    "tagNotShared": "Dieses Tag wurde noch mit niemandem geteilt.",
    "protectionsCount": "{{count}}-Schutz",
    "protectionsCount_one": "{{count}}-Schutz",
    "protectionsCount_other": "{{count}}-Schutz",
    "inheritedFromGroups": "Sichtbar über Gruppen: {{groups}}",
    "tagsVisibleToGroup": "Für diese Gruppe sichtbare Tags ({{count}})",
    "tagsVisibleToUser": "Für diesen Benutzer sichtbare Tags ({{count}})",
    "rulesAppliedToGroup": "Auf diese Gruppe angewendete Schutzregeln ({{count}})",
    "rulesAppliedToUser": "Auf diesen Benutzer angewendete Schutzregeln ({{count}})",
    "userSeesNoTags": "Dieser Benutzer sieht keine Tags.",
    "groupSeesNoTags": "Diese Gruppe sieht keine Tags.",
    "tagNoRulesLead": "Dateien mit diesem Tag aktivieren keine spezifische Regel für diese Gruppe.",
    "tagRulesLead": "Dateien mit diesem Tag aktivieren die folgende Regel:",
    "tagRulesLead_one": "Dateien mit diesem Tag aktivieren die folgende Regel:",
    "tagRulesLead_other": "Dateien mit diesem Tag aktivieren die folgenden {{count}}-Regeln:",
    "summary": {
      "action": "Aktion",
      "behaviour": "Verhalten",
      "readOnlyRoles": "Schreibgeschützte Rollen",
      "showRecipients": "Ursprüngliche Empfänger anzeigen",
      "allowEdit": "Bearbeiten zulassen",
      "readOnlyMode": "Nur-Lese-Modus",
      "watermarkText": "Wasserzeichentext",
      "placement": "Position",
      "appliesToExternal": "Durchsetzung externer Benutzer",
      "approvedDomains": "Zugelassene Domänen",
      "maxExpirationDays": "Maximal zulässige Dauer",
      "excludedDomains": "Ausgeschlossene Domänen",
      "excludedGroups": "Ausgeschlossene Gruppen",
      "requireApprovalOnShare": "Allgemeine Genehmigungspflicht",
      "requireApprovalOnReshare": "Genehmigung nur für erneut freigegebene Dateien",
      "reviewTeamSize": "Review-Team",
      "hiddenFileTypes": "Unsichtbar nach dem Teilen",
      "allowedApplications": "Zulässige Anwendungen",
      "rolesAllowed": "Publikum"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "Eine Zwei-Faktor-Authentifizierung ist erforderlich. Aktivieren Sie es, um Ihr Konto zu sichern."
      },
      "LICENSE_EXPIRING": {
        "message": "Ihre Lizenz läuft am {{expirationDate}} ab (verbleibende {{daysRemaining}} Tage)."
      },
      "LOW_BACKUP_CODES": {
        "message": "Sie haben nur noch wenige Backup-Codes übrig ({{remaining}}). Generieren Sie sie in Zwei-Faktor-Einstellungen neu."
      },
      "_generic": {
        "message": "Sie haben eine aktive Benachrichtigung ({{code}}). Wenden Sie sich an Ihren Administrator, wenn Sie Hilfe benötigen."
      }
    }
  },
  "errors": {
    "required": "Dieses Feld ist erforderlich",
    "minLength": "Muss mindestens {{min}} Zeichen umfassen",
    "authenticatorCodeInvalid": "Der Authentifizierungscode ist ungültig.",
    "authenticatorNotRemoved": "Beim Entfernen des Authentifikators ist ein Fehler aufgetreten.",
    "authenticationUserBlocked": "Der Benutzer ist gesperrt. Bitte wenden Sie sich an den Administrator.",
    "authenticationUserExpired": "Der Benutzer ist abgelaufen. Bitte wenden Sie sich an den Administrator.",
    "codeIncorrect": "Der von Ihnen eingegebene Code ist falsch. Bitte versuchen Sie es erneut.",
    "genericDeleteError": "Beim Löschen von {{resource}} ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "genericError": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "genericFetchError": "Beim Abrufen von {{resource}} ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "userProfileUnavailable": "Wir konnten Ihr Profil nicht laden. Sie bleiben mit eingeschränkten Berechtigungen angemeldet, bis das Problem behoben ist.",
    "userProfileStale": "Wir konnten Ihr Profil nicht aktualisieren. Sie sind immer noch mit Ihren letzten bekannten Berechtigungen angemeldet.",
    "userProfileRetry": "Wiederholen",
    "alerts": {
      "dismissFailed": "Diese Warnung konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
      "invalidSnooze": "Wählen Sie eine gültige Schlummerdauer.",
      "fetchFailed": "Warnungen konnten nicht geladen werden. Sie werden es automatisch erneut versuchen."
    },
    "sessionsFetchError": "Fehler beim Abrufen der Sitzungen.",
    "sessionsRevokeError": "Fehler beim Widerrufen der Sitzung.",
    "sessionsRevokeForbiddenError": "Sie sind nicht berechtigt, Sitzungen für diesen Benutzer zu widerrufen.",
    "sessionsRevokeOthersError": "Fehler beim Widerrufen anderer Sitzungen.",
    "sessionsRevokeAllError": "Fehler beim Widerrufen aller Sitzungen.",
    "genericUpdateError": "Beim Aktualisieren von {{resource}} ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "genericCreateError": "Beim Erstellen von {{resource}} ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "invalidCredentials": "Falsche E-Mail-Adresse oder falsches Passwort. Bitte überprüfen Sie Ihre Anmeldeinformationen und versuchen Sie es erneut.",
    "invalidUsername": "Der von Ihnen eingegebene Benutzername ist ungültig.",
    "tokenInvalid": "Das bereitgestellte Token ist ungültig oder abgelaufen.",
    "tokenExpired": "Zugriffstoken ist abgelaufen",
    "unsavedChangesMessage": "Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie die Seite verlassen und diese Änderungen verlieren möchten?",
    "unsavedChangesTitle": "Nicht gespeicherte Änderungen erkannt.",
    "licenseExpired": "Die Lizenz ist abgelaufen. Bitte erneuern Sie Ihre Lizenz.",
    "licenseMaxUsersReached": "Die maximale Benutzeranzahl für diese Lizenz wurde erreicht. Sie können keine neuen Benutzer hinzufügen oder vorhandenen Benutzern nicht externe Rollen zuweisen.",
    "mandatoryClassificationCannotRemove": "Sie können nicht alle Klassifizierungs-Tags entfernen. Mindestens ein Tag muss bestehen bleiben, da in den Einstellungen Ihrer Organisation die obligatorische Dateiklassifizierung aktiviert ist.",
    "tagRemovalDenied": "Es ist Ihnen nicht gestattet, eines oder mehrere der ausgewählten Tags aus dieser Datei zu entfernen.",
    "tagAdditionDenied": "Sie sind nicht berechtigt, einen oder mehrere der ausgewählten Tags zu dieser Datei hinzuzufügen.",
    "emailNotFound": "Die E-Mail-Adresse {{email}} ist nicht registriert. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
    "otpExpired": "Der OTP ist abgelaufen. Bitte fordern Sie ein neues OTP an.",
    "totpWrong": "Ungültiger 2FA-Code. Bitte versuchen Sie es erneut.",
    "temporaryTotpExpired": "Die Zeit zum Abschließen der Anmeldung ist abgelaufen.",
    "errorAdminTotpResetNotAllowed": "2FA kann nicht deaktiviert werden: Ihre Organisation erlaubt Administratoren nicht, den Benutzer TOTP zurückzusetzen. Ein Superadministrator kann dies in den Einstellungen der Zwei-Faktor-Authentifizierung (TOTP) zulassen.",
    "transferOwnershipFailed": "Das Eigentum konnte nicht übertragen werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.",
    "otpRequestLimitExceeded": "Sie haben das Limit zum Anfordern von OTPs überschritten. Bitte versuchen Sie es später noch einmal.",
    "requestFilePermissions": "Versuchen Sie, den Eigentümer der Datei zu kontaktieren, um Ihre Berechtigungen zu erneuern",
    "noUploadPermission": "Sie sind nicht berechtigt, Dateien an diesen Ort hochzuladen.",
    "publicLinkClassificationRequired": "Die Datei muss klassifiziert werden, bevor ein öffentlicher Link erstellt wird.",
    "publicLinkPasswordRequired": "Für öffentliche Links ist ein Passwort erforderlich.",
    "publicLinkMaxAccessCountRequired": "Es ist eine maximale Zugriffsanzahl erforderlich.",
    "publicLinkExpirationRequired": "Es ist ein Ablaufdatum erforderlich.",
    "publicLinkExpirationExceeded": "Der Ablauf überschreitet die maximal zulässigen Tage.",
    "publicLinkExpirationInPast": "Das Ablaufdatum muss in der Zukunft liegen.",
    "publicLinkFolderPasswordProtected": "Es kann kein öffentlicher Link für passwortgeschützte Ordner oder darin enthaltene Dateien erstellt werden. Um über einen öffentlichen Link zu teilen, entfernen Sie den Passwortschutz aus dem Ordner.",
    "publicLinkDownloadRestricted": "Es kann kein öffentlicher Link erstellt werden, da Download Encryption Enforcement für diese Datei oder ihre Tags aktiv ist. Um über einen öffentlichen Link zu teilen, entfernen Sie die Einschränkung aus der Einstellung „Download Encryption Enforcement“.",
    "publicLinkAnticaptureActive": "Es kann kein öffentlicher Link erstellt werden, da der Anti-Capture-Modus für diese Datei oder ihre Tags aktiv ist. Um über einen öffentlichen Link zu teilen, entfernen Sie Anti-Capture aus der Datei oder den entsprechenden Tag-Einstellungen.",
    "publicLinkExternalSharingRestricted": "Es kann kein öffentlicher Link erstellt werden, da für diese Datei oder ihre Tags externe Freigabebeschränkungen aktiv sind. Um über einen öffentlichen Link zu teilen, entfernen Sie die geltenden Beschränkungen in der Einstellung „Externe Freigabebeschränkungen“.",
    "publicLinkResharingDenied": "Es kann kein öffentlicher Link erstellt werden, da das erneute Teilen für diese Datei oder ihre Tags nicht zulässig ist. Um über einen öffentlichen Link zu teilen, überprüfen und aktualisieren Sie die Einstellung „Berechtigungen für die erneute Dateifreigabe“.",
    "publicLinkDownloadTagsRestricted": "Es kann kein öffentlicher Link erstellt werden, da Downloadbeschränkungen für diese Datei oder ihre Tags aktiv sind. Um über einen öffentlichen Link zu teilen, überprüfen Sie die Einstellung „Zugelassene Tags herunterladen“.",
    "publicLinkApprovalRequired": "Es kann kein öffentlicher Link erstellt werden, da für diese Datei oder ihre Tags eine Freigabegenehmigung erforderlich ist. Um über einen öffentlichen Link zu teilen, überprüfen Sie die Einstellung „Genehmigungsanforderungen für die Freigabe“.",
    "publicLinkMandatoryExpiration": "Es kann kein öffentlicher Link erstellt werden, da für diese Datei oder ihre Tags eine obligatorische Ablaufrichtlinie aktiv ist. Stellen Sie zum Teilen über einen öffentlichen Link sicher, dass das Ablaufdatum innerhalb des Grenzwerts liegt, der in der Einstellung „Obligatorischer Ablauf der freigegebenen Datei“ definiert ist.",
    "tagsAmountLimitReached": "Sie können nicht mehr als {{limit}}-Tags erstellen.",
    "hitASnag": "Oh-oh! Da ist ein Haken. Bitte versuchen Sie es noch einmal...",
    "noPermission": "Sie haben keine Berechtigung, diese Aktion auszuführen.",
    "errorDownloadFile": "Beim Herunterladen der Datei ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "errorDuplicateFile": "Beim Duplizieren der Datei ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "errorMoveFile": "Beim Verschieben der Datei ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "denyFileMove": "Für diese Datei ist das Verschieben nicht zulässig.",
    "pdfConversionUnsupportedFormat": "Dieses Dateiformat wird für die PDF-Konvertierung nicht unterstützt.",
    "pdfConversionFileTooLarge": "Datei zu groß für Konvertierung. Maximalgröße beträgt {{maxSizeMb}} MB.",
    "pdfConversionFailed": "PDF-Konvertierung fehlgeschlagen. Bitte erneut versuchen.",
    "pdfConversionAntivirusBlocked": "PDF-Konvertierung blockiert: Die Datei enthält eine Bedrohung.",
    "fileNotFound": "Datei nicht gefunden.",
    "errorDeleteFiles": "Beim Löschen der Dateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "errorHideFiles": "Beim Ausblenden der Dateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "errorUploadFile": "Beim Hochladen der Datei ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "cannotAddArchivedFilesToFavorites": "Archivierte Dateien können nicht zu den Favoriten hinzugefügt werden.",
    "cannotDeleteMultiplePasswordProtected": "Die ausgewählten Elemente können nicht gelöscht werden, da mehrere passwortgeschützte Ordner gesperrt sind. Bitte entsperren Sie jeden Ordner einzeln und versuchen Sie es erneut.",
    "cannotUnlockMultiplePasswordProtected": "Es können nicht mehrere passwortgeschützte Ordner gleichzeitig entsperrt werden. Bitte entsperren Sie jeden Ordner einzeln.",
    "groupNameCannotBeEmail": "Der Gruppenname darf keine E-Mail-Adresse sein.",
    "invalidFolder": "Dieser Ordner ist ungültig.",
    "invalidFolderUpload": "Der Ordner, den Sie hochladen möchten, existiert nicht oder wird nicht unterstützt.",
    "zeroByteFileNotUploaded": "Null-Byte-Dateien werden nicht hochgeladen. Bitte wählen Sie Dateien mit Inhalt aus.",
    "loginFailed": "Fehler bei der Anmeldung",
    "unauthorized": "Die Authentifizierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "forbidden": "Zugriff verweigert",
    "serverError": "Serverfehler. Bitte versuchen Sie es später noch einmal.",
    "tooManyRequests": "Zu viele Anfragen. Bitte versuchen Sie es später noch einmal.",
    "oauthAccessDenied": "Zugriff vom Benutzer verweigert",
    "oauthInvalidCallback": "Ungültiger OAuth-Rückruf",
    "oauthStateMismatch": "Die Sicherheitsüberprüfung ist fehlgeschlagen",
    "oauthContextMissing": "OAuth Kontext fehlt",
    "oauthProviderNotEnabled": "OAuth-Anbieter nicht aktiviert",
    "oauthNotEnabled": "Direct OAuth ist für diesen Mandanten nicht aktiviert",
    "oauthDomainNotAllowed": "E-Mail-Domäne nicht zulässig",
    "oauthEmailMismatch": "Sie haben sich mit einem anderen Konto als der von Ihnen eingegebenen E-Mail-Adresse angemeldet. Bitte melden Sie sich mit dem richtigen Konto an.",
    "oauthCodeExchangeFailed": "Der Austausch des Autorisierungscodes ist fehlgeschlagen",
    "oauthTokenValidationFailed": "Die Token-Validierung ist fehlgeschlagen",
    "oauthInvalidTenant": "Ungültiger Mieter",
    "oauthSessionExpired": "Sitzung abgelaufen. Bitte versuchen Sie es erneut.",
    "sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
    "filePasswordLockout": "Dieser Ordner ist aufgrund zu vieler Fehlversuche gesperrt. Versuchen Sie es in {{minutes}} Minuten erneut.",
    "getViewerData": "Beim Abrufen der Zuschauerdaten ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "protectedLinkAlreadyUsed": "Link bereits verwendet, neuen Code generieren",
    "protectedLinkAlreadyUsedOrExpired": "Link bereits verwendet oder abgelaufen, neuen Code generieren",
    "fileAccessSessionExpired": "Sitzung abgelaufen, neuen Code generieren",
    "protectedFileDownloadOnlyForWindows": "Der Download geschützter Dateien ist nur für die Windows-Plattform verfügbar.",
    "antiCaptureActivated": "Dieses Element ist durch Anti-Capture-Einstellungen geschützt.",
    "downloadRestrictionActivated": "Dieses Element ist durch Download-Beschränkungseinstellungen geschützt.",
    "watermarkProtectionDownloadDenied": "Download verweigert, da eine oder mehrere Dateien durch ein Wasserzeichen geschützt sind.",
    "antivirusFileInfected": "Diese Datei kann nicht geöffnet oder geteilt werden, da Antivirus eine Bedrohung erkannt hat.",
    "antivirusFileInfectedNamed": "Antivirus hat {{threatName}} in {{fileName}} erkannt.",
    "antivirusRescanNotAllowed": "Sie dürfen für diese Datei keinen Antivirus-Neuversuch anfordern.",
    "antivirusNotAvailable": "Antivirus-Scan ist derzeit nicht verfügbar. Bitte später erneut versuchen.",
    "fileSizeTooBigForDownload": "Die Datei kann nicht im verschlüsselten Modus heruntergeladen werden, da sie größer als 250 MB ist.",
    "fileNotAvailable": {
      "title": "Datei nicht mehr verfügbar",
      "description": "Die Datei, auf die Sie zugreifen möchten, ist nicht mehr verfügbar. Möglicherweise wurde es gelöscht oder verschoben."
    },
    "publicLinkNotFoundTitle": "Link nicht gefunden",
    "publicLinkNotFoundMessage": "Dieser Link existiert nicht oder wurde entfernt.",
    "publicLinkExpiredTitle": "Link abgelaufen",
    "publicLinkExpiredMessage": "Dieser Link ist abgelaufen und nicht mehr gültig.",
    "publicLinkMaxAccessTitle": "Zugriffslimit erreicht",
    "publicLinkMaxAccessMessage": "Die maximale Anzahl an Zugriffen für diesen Link wurde erreicht.",
    "invalidAccessCode": "Das von Ihnen eingegebene Passwort ist falsch. Bitte versuchen Sie es erneut.",
    "fileSizeUploadLimit": "Die Dateigröße überschreitet das Upload-Limit von {{value}} MB",
    "fileSizeExceedsAdminLimit": "Datei kann nicht hochgeladen werden: Die Größe überschreitet die vom Administrator festgelegte Höchstgrenze.",
    "fileSizeExceedsLicenseLimit": "Datei kann nicht hochgeladen werden: Die Größe überschreitet die in der Lizenz festgelegte Höchstgrenze.",
    "uploadingFileError": "Beim Hochladen der Datei ist ein Problem aufgetreten.",
    "uploadInterrupted": "Der Upload wurde vom Benutzer abgebrochen.",
    "fileTypeRestrictionError": "Dieser Dateityp kann aufgrund der angewendeten Einstellungen nicht hochgeladen werden.",
    "quickShareError": "Beim Teilen der Dateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "quickShareFilesNotUploaded": "{{ count }}-Datei wurde nicht erfolgreich hochgeladen. Klicken Sie auf „Weiter“, um die erfolgreich hochgeladenen Dateien trotzdem zu teilen.",
    "quickShareFilesNotUploaded_other": "{{ count }} Dateien wurden nicht erfolgreich hochgeladen. Klicken Sie auf „Weiter“, um die erfolgreich hochgeladenen Dateien trotzdem zu teilen.",
    "enterOnBehalfOfUserFailed": "Eingabe im Namen des Benutzers fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "exitOnBehalfOfUserFailed": "Das Beenden im Namen des Benutzers ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "reasonRequired": "Bitte geben Sie im Namen des Benutzers einen Grund für die Teilnahme ein",
    "reasonMinLength": "Der Grund muss mindestens 3 Zeichen lang sein",
    "impersonatedUserNotNotified": "Der Benutzer konnte nicht per E-Mail benachrichtigt werden (keine E-Mail-Adresse im Konto)",
    "quickShareFilesNotShared": "Dateien wurden nicht erfolgreich geteilt. Klicken Sie auf „Weiter“, um die erfolgreich hochgeladenen Dateien trotzdem zu teilen.",
    "filesNotShared": "Dateien wurden nicht geteilt.",
    "fileSizeExceedsLimit": "Die Dateigröße überschreitet den Grenzwert von {{value}}.",
    "otpWrong": "Der OTP-Code ist falsch. Bitte versuchen Sie es erneut.",
    "groupNameAlreadyUsed": "Der Gruppenname wird bereits verwendet.",
    "updateFileAccessError": "Beim Aktualisieren des Dateizugriffs ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "deleteFileAccessError": "Beim Löschen des Dateizugriffs ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "errorCreateFileShortcut": "Beim Erstellen der Dateiverknüpfung ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "openShortcutFileError": "Hoppla, die verknüpfte Datei scheint nicht mehr verfügbar zu sein. Möglicherweise wurde es entfernt oder der Zugriff widerrufen.",
    "confirmationMessageMatch": "Die Bestätigungsnachricht stimmt nicht überein.",
    "emailExist": "E-Mail existiert bereits.",
    "shareFiles": "Es gab ein Problem beim Teilen der Dateien. Bitte versuchen Sie es erneut.",
    "genericSellError": "Beim Anbieten der Datei zum Verkauf ist ein Fehler aufgetreten.",
    "someItemsCannotBeSelected": "Einige Elemente können nicht ausgewählt werden",
    "invalidMicrosoftEntraIdToken": "Das Token Microsoft Entra ID ist ungültig oder abgelaufen.",
    "atLeastOneOption": "Sie müssen mindestens eine Option auswählen",
    "groupNameAlreadyExists": "Der Gruppenname wird bereits verwendet.",
    "cannotAddSuperAdminToGroup": "Sie können keinen Super-Admin zu einer Gruppe hinzufügen.",
    "editSharingDenied": "Sie sind nicht berechtigt, Zugriffsrechte für bereits freigegebene Dokumente zu bearbeiten. Wenn ein Benutzer nicht in der Liste angezeigt wird, bedeutet dies, dass er bereits über eine aktive Freigabe verfügt.",
    "errorRemoveShareFiles": "Beim Entfernen der Freigabedateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "noFileClassificationAvailable": "Derzeit ist keine Dateiklassifizierung verfügbar",
    "errorPermanentlyDeleteFiles": "Beim dauerhaften Löschen der Dateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.",
    "aiDocumentChatError": "Beim Chatten mit dem Dokument ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "filesAlreadyClassified": "Dateien sind bereits klassifiziert",
    "filesBeingClassified": "Die Akten werden derzeit geheim gehalten",
    "filesBeingClassifiedDescription": "Bitte warten Sie, bis der aktuelle Klassifizierungsprozess abgeschlossen ist, bevor Sie einen neuen starten.",
    "filesTooBig": "Dateien überschreiten die Größenbeschränkung für die Klassifizierung",
    "filesTooBigDescription": "Die maximal zulässige Dateigröße für die KI-Klassifizierung beträgt 250 MB. Bitte wählen Sie kleinere Dateien aus.",
    "tooManyFiles": "Zu viele Dateien ausgewählt",
    "tooManyFilesDescription": "{{files}} Dateien ausgewählt; das Maximum ist {{limit}}. Bitte Auswahl reduzieren und erneut versuchen.",
    "rejectionReasonRequired": "Ein Ablehnungsgrund ist erforderlich",
    "rejectionReasonMinLength": "Der Ablehnungsgrund muss mindestens 3 Zeichen lang sein",
    "fileAlreadyInUseError": "Die Datei wird bereits von einem anderen Benutzer verwendet.",
    "contentHashMismatchError": "Datei beim Hochladen beschädigt (Hash-Konflikt)",
    "fileIntegrityCheckFailed": "Die Prüfung der Dateiintegrität ist fehlgeschlagen",
    "fileIntegrityCheckFailedDescription": "Die heruntergeladene Datei ist möglicherweise beschädigt. Bitte versuchen Sie es erneut.",
    "fileIntegrityCheckError": "Fehler bei der Dateiintegritätsprüfung",
    "fileIntegrityCheckErrorDescription": "Die Dateiintegrität konnte nicht überprüft werden, der Download wird jedoch fortgesetzt.",
    "storageUrlFetchFailed": "Mieter nicht gefunden oder vorübergehend nicht verfügbar",
    "storageUrlFetchFailedDescription": "Bitte überprüfen Sie die Adresse und versuchen Sie es erneut: <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "Für diesen Ordner ist eine Passwortüberprüfung erforderlich",
    "folderPassword": {
      "passwordRequired": "Passwort ist erforderlich.",
      "tooShort": "Das Passwort muss mindestens 4 Zeichen lang sein.",
      "ownerOnly": "Nur der Ordnerbesitzer kann diese Aktion ausführen.",
      "alreadyExists": "Dieser Ordner ist bereits passwortgeschützt.",
      "ancestorProtected": "Diese Aktion kann nicht ausgeführt werden, da ein übergeordneter Ordner kennwortgeschützt ist.",
      "descendantProtected": "Diese Aktion kann nicht ausgeführt werden, da ein Unterordner passwortgeschützt ist.",
      "notSet": "Für diesen Ordner ist kein Passwortschutz konfiguriert.",
      "notProtected": "Dieser Ordner ist nicht passwortgeschützt.",
      "currentRequired": "Aktuelles Passwort ist erforderlich.",
      "expired": "Der Passwortschutz des Ordners ist abgelaufen. Bitte wenden Sie sich an den Ordnereigentümer.",
      "incorrect": "Das aktuelle Ordnerkennwort ist falsch. Bitte versuchen Sie es erneut.",
      "sessionNotFound": "Sitzung nicht gefunden oder bereits widerrufen.",
      "sessionForbidden": "Sie sind nicht berechtigt, diese Sitzung zu verwalten.",
      "otpNotRequested": "OTP wurde nicht angefordert. Bitte fordern Sie einen neuen Code an."
    },
    "notAFolder": "Das ausgewählte Element ist kein Ordner",
    "ipRegionBlocked": {
      "message": "Zugriff von Ihrem Standort aus verweigert.",
      "loginTitle": "Zugriff verweigert",
      "loginMessage": "Zugriff von Ihrem Standort aus verweigert.",
      "loginGeneric": "Zugriff von Ihrem Standort aus verweigert.",
      "fileOperationTitle": "Vorgang nicht zulässig",
      "fileOperationMessage": "Zugriff von Ihrem Standort aus verweigert."
    },
    "ipRegionAdminLockout": {
      "title": "Die Administrator-IP-Einschränkung kann nicht aktiviert werden",
      "message": "Ihre aktuelle IP-Adresse muss in den erlaubten Admin-IP-Adressen enthalten sein, sonst würden Sie sich aus den Admin-Einstellungen ausschließen."
    },
    "dateMustBeFuture": "Das Datum muss in der Zukunft liegen",
    "externalSharingNotAllowed": "Die folgenden Empfänger sind nicht zum Empfang externer Freigaben berechtigt: {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Anhänge müssen vor dem Senden mit einem Klassifizierungs-Tag versehen werden",
    "fileSharingDenied": "Die Dateifreigabe ist für diesen Vorgang nicht zulässig.",
    "cannotAccessFiles": "Sie können auf eine oder mehrere der angeforderten Dateien nicht zugreifen.",
    "partialSharingDenied": "Einige Dateien können nicht für die ausgewählten Empfänger freigegeben werden.",
    "partialSharingDeniedDisabledRecipients": "Einige ausgewählte Benutzer oder Gruppen verfügen bereits über eine Freigabe für diese Dateien, diese ist jedoch derzeit deaktiviert. Aktivieren Sie es erneut, indem Sie auf die Schaltfläche {{shareAgainLabel}} neben jedem Empfänger klicken.",
    "passKeyDataRequired": "Passkey-Daten fehlen oder sind ungültig. Bitte versuchen Sie es erneut.",
    "passKeyForbidden": "Sie haben keine Berechtigung, diese Aktion auszuführen.",
    "passKeyLimitReached": "Sie haben die maximale Anzahl an Passkeys erreicht. Entfernen Sie eines, bevor Sie ein anderes hinzufügen.",
    "passKeyLockedOut": "Zu viele fehlgeschlagene Passkey-Versuche. Bitte versuchen Sie es später noch einmal oder verwenden Sie eine andere Anmeldemethode.",
    "passKeyNotAllowed": "Diese Passkey-Aktion ist nicht zulässig.",
    "passKeyNotEnabled": "Für Ihr Konto oder Ihre Organisation sind keine Passkeys aktiviert.",
    "passKeyNotFound": "Passkey nicht gefunden. Möglicherweise wurde es entfernt oder ist nicht mehr gültig.",
    "passKeySessionExpired": "Die Passkey-Sitzung ist abgelaufen. Bitte beginnen Sie erneut.",
    "passKeyVerificationFailed": "Anmeldeinformationen wurden nicht gefunden oder sind für die passwortlose Anmeldung nicht aktiviert.",
    "batchNotFound": "Batch nicht gefunden oder kein Zugriff.",
    "batchNotCancellable": "Dieser Batch kann nicht abgebrochen werden (kein Klassifizierungs-Batch).",
    "batchAlreadyFinished": "Dieser Vorgang ist bereits abgeschlossen.",
    "batchRetryNotSupported": "Erneuter Versuch wird nur für Klassifizierungs-Batches unterstützt.",
    "noFileJobsFound": "Keine der ausgewählten Dateien kann im aktuellen Status abgebrochen oder erneut versucht werden.",
    "queueUnavailable": "Die Verarbeitungswarteschlange ist vorübergehend nicht verfügbar. Bitte später erneut versuchen."
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} erfolgreich aktualisiert.",
    "genericCreateSuccess": "{{resource}} erfolgreich erstellt.",
    "linkCopiedToClipboard": "Link in die Zwischenablage kopiert!",
    "codeCopiedToClipboard": "Code in die Zwischenablage kopiert!",
    "fileProtectedWithAntiCapture": "Diese Datei ist mit Anticapture geschützt. Um den Dateiinhalt anzuzeigen, geben Sie diesen Code ein, wenn Sie im Filegrant Viewer dazu aufgefordert werden, und schon sind Sie fertig!",
    "otpCopiedToClipboard": "OTP in die Zwischenablage kopiert!",
    "fileProtectedDownloadInProgress": "Der Download läuft. Am Ende des Downloadlaufs wird die heruntergeladene Anwendung ausgeführt. Geben Sie oben ein, um die Datei anzuzeigen.",
    "quickShareSuccess": "Dateien erfolgreich freigegeben.",
    "fileLocatedInThisLocation": "Diese Datei befindet sich bereits an diesem Speicherort.",
    "fileAccessRevoked": "Zugriffsrechte erfolgreich widerrufen.",
    "fileAccessUpdated": "Zugriffsrechte erfolgreich aktualisiert.",
    "fileVersionRestored": "Dateiversion erfolgreich wiederhergestellt.",
    "folderCreated": "Ordner {{resource}} erfolgreich erstellt.",
    "fileCreated": "Datei {{resource}} erfolgreich erstellt.",
    "fileRenamed": "Datei {{resource}} wurde erfolgreich in {{newName}} umbenannt.",
    "fileDuplicated": "Datei {{resource}} erfolgreich dupliziert.",
    "fileDuplicated_other": "Dateien erfolgreich dupliziert.",
    "fileFavouriteChanged": "Datei {{resource}} {{isFavourite}} Favoriten erfolgreich.",
    "fileFavouriteChanged_other": "Dateien {{isFavourite}} Favoriten erfolgreich.",
    "fileShortcutCreated": "Dateiverknüpfung {{resource}} erfolgreich erstellt.",
    "fileMoved": "Datei {{resource}} wurde erfolgreich verschoben.",
    "fileMoved_other": "Dateien erfolgreich verschoben.",
    "pdfConversionStarted": "Konvertierung von {{resource}} in PDF gestartet.",
    "pdfConversionSuccess": "PDF-Konvertierung erfolgreich abgeschlossen.",
    "pdfConversionFailed": "PDF-Konvertierung fehlgeschlagen.",
    "pdfConversionStillRunning": "Die PDF-Konvertierung läuft noch. Sie werden benachrichtigt, wenn sie abgeschlossen ist.",
    "emptyTrash": "Der Papierkorb wurde erfolgreich geleert.",
    "operationMayTakeTime": "Dieser Vorgang kann einige Zeit in Anspruch nehmen.",
    "fileRestored": "Datei {{resource}} erfolgreich wiederhergestellt.",
    "fileRestored_other": "Dateien erfolgreich wiederhergestellt.",
    "fileHidden": "Datei {{resource}} erfolgreich ausgeblendet.",
    "fileHidden_other": "Dateien erfolgreich ausgeblendet.",
    "fileUnhidden": "Datei {{resource}} erfolgreich eingeblendet.",
    "fileUnhidden_other": "Dateien erfolgreich eingeblendet.",
    "filesMarkedAsRead_one": "Als gelesen markiert.",
    "filesMarkedAsRead_other": "{{count}} Dateien als gelesen markiert.",
    "filesMarkedAsUnread_one": "Als ungelesen markiert.",
    "filesMarkedAsUnread_other": "{{count}} Dateien als ungelesen markiert.",
    "folderLocked": "{{count}}-Ordner gesperrt.",
    "folderLocked_other": "{{count}} Ordner gesperrt.",
    "fileClassifying": "Datei wird klassifiziert",
    "filesClassifying": "Die Datei {{count}} wird klassifiziert",
    "filesClassifying_other": "{{count}}-Dateien werden klassifiziert",
    "filesClassifyingBatch": "{{count}}-Dateien werden als Stapel klassifiziert",
    "filesClassifyingBatchWithSkipped": "{{count}}-Dateien stehen zur Klassifizierung in der Warteschlange. {{skipped}} übersprungen.",
    "folderClassifyingBatch": "Ordnerinhalte werden als Stapel klassifiziert",
    "foldersClassifyingBatch": "{{count}}-Ordner werden als Stapel klassifiziert",
    "fileTagsUpdated": "Die Tags der Datei {{resource}} wurden erfolgreich aktualisiert.",
    "fileDeleted": "Datei {{resource}} erfolgreich gelöscht.",
    "fileDeleted_other": "Dateien erfolgreich gelöscht.",
    "checkingFilesExistsCounter": "Dateien prüfen: {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Ordner prüfen: {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Dateien prüfen: {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Ordner prüfen: {{done}} / {{total}}",
    "tags": {
      "title": "Datei mit Tags versehen",
      "description": "Datei #{{fileId}} wurde markiert",
      "descriptionWithFileName": "{{fileName}} wurde markiert",
      "descriptionGeneric": "Die Datei wurde markiert",
      "errorTitle": "Datei konnte nicht markiert werden",
      "error": "Die KI-Klassifizierung ist fehlgeschlagen.",
      "batchSuccessTitle": "Klassifizierungsstapel abgeschlossen",
      "batchSuccessDescription": "Klassifiziert {{processed}} von {{total}} Dateien.",
      "batchFailedTitle": "Klassifizierungsbatch ist fehlgeschlagen",
      "batchFailedDescription": "Stapel mit Fehlern beendet ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "Dateizusammenfassung",
      "description": "Zusammenfassung für Datei {{fileId}} generiert",
      "ready": "Die Dateizusammenfassung ist fertig.",
      "open": "Zusammenfassung öffnen"
    },
    "fileUnavailable": "Datei nicht verfügbar",
    "suggestGridMode": {
      "title": "Dieser Ordner enthält nur Bilder",
      "description": "Wechseln Sie zur Rasteransicht für eine bessere Vorschau.",
      "action": "Wechseln Sie zum Raster"
    },
    "documentClassification": {
      "title": "Dokument klassifiziert",
      "description": "Dokumentklassifizierung für Datei {{fileId}} abgeschlossen"
    },
    "default": {
      "title": "Benachrichtigung",
      "description": "Neue Benachrichtigung erhalten"
    },
    "sharing": {
      "title": "Datei geteilt",
      "sharing_operation_download": "{{actorName}} heruntergeladen {{fileName}}",
      "sharing_operation_open": "{{actorName}} geöffnet {{fileName}}",
      "sharing_operation_edit": "{{actorName}} bearbeitet {{fileName}}",
      "sharing_operation_delete": "{{actorName}} gelöscht {{fileName}}",
      "sharing_operation_rename": "{{actorName}} umbenannt in {{fileName}}",
      "sharing_operation_add": "{{actorName}} hinzugefügt {{fileName}}",
      "sharing_operation_move": "{{actorName}} verschoben {{fileName}}",
      "sharing_operation_copy": "{{actorName}} kopiert {{fileName}}",
      "sharing_operation_unknown": "{{actorName}} hat eine Operation an {{fileName}} ausgeführt"
    },
    "folderPasswordSet": "Passwortschutz aktiviert",
    "folderPasswordUpdated": "Passwortschutz aktualisiert",
    "folderPasswordRemoved": "Passwortschutz entfernt",
    "unlockingFolder": "Ordner entsperren…",
    "folderUnlocked": "Ordner erfolgreich entsperrt"
  },
  "files": {
    "downloadPreparation": "Download wird vorbereitet",
    "downloadReady": "Download bereit",
    "compressionOfFilesInProgress": "Komprimierung von Dateien läuft",
    "compressionCompleted": "Komprimierung abgeschlossen",
    "compressionFailed": "Die Komprimierung ist fehlgeschlagen"
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Aktivieren Sie Aktivitätsbenachrichtigungen",
    "includeSubfolders": "Unterordner einschließen",
    "notifyOwner": "Besitzer benachrichtigen",
    "notifyRecipients": "Benachrichtigen Sie die Empfänger",
    "whoCanTrigger": "Wer kann Benachrichtigungen auslösen?",
    "trigger": {
      "ownerOnly": "Nur Eigentümer",
      "anyone": "Irgendjemand"
    },
    "operation": {
      "download": "Herunterladen",
      "open": "Offen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "rename": "Umbenennen",
      "add": "Hinzufügen",
      "move": "Bewegen",
      "copy": "Kopie"
    },
    "configureNotifications": "Konfigurieren Sie Benachrichtigungen",
    "customizeFor": "Anpassen für",
    "discardChangesTitle": "Änderungen verwerfen?",
    "discardChangesDescription": "Sie haben nicht gespeicherte Änderungen. Entsorgen und schließen?",
    "discardConfirm": "Verwerfen",
    "notificationsDisabled": "Benachrichtigungen deaktiviert",
    "notificationsEnabled": "Benachrichtigungen aktiviert",
    "modalTitle": "Aktivitätsbenachrichtigungen"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "Tag-Änderungen speichern?",
      "description": "Sie haben nicht gespeicherte Änderungen an Tags. Vor dem Schließen speichern?"
    },
    "userGroupSelectorForm": {
      "title": "Prüfteam verwalten",
      "description": "Wählen Sie Benutzer und Gruppen für das Prüfteam aus",
      "currentMembers": "Aktuelle Mitglieder",
      "unsavedReviewTeam": "Nicht gespeichertes Review-Team"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Verwalten Sie Benutzer und Gruppen",
      "description": "Wählen Sie Benutzer und Gruppen aus, die auf dieses Tag zugreifen können",
      "usersAndGroups": "Benutzer und Gruppen",
      "unsavedUsersAndGroups": "Nicht gespeicherte Benutzer und Gruppen"
    },
    "changeUserRole": {
      "title": "Benutzerrolle ändern",
      "description": "Sind Sie sicher, dass Sie die Rolle {{name}} von {{initialRole}} in {{newRole}} ändern möchten?"
    },
    "deleteUsersForm": {
      "title": "Benutzer löschen",
      "title_other": "Benutzer löschen",
      "roleAdminOrContributor": "Der Benutzer, den Sie löschen möchten, ist ein Mitwirkender oder Administrator und hat möglicherweise Dateien in das System hochgeladen. Durch das Löschen dieses Benutzers werden auch alle seine hochgeladenen Dateien und alle zugehörigen Freigaben gelöscht und er kann nicht mehr auf die Plattform zugreifen. Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>",
      "roleReader": "Der Benutzer, den Sie löschen möchten, ist ein Leser und verfügt möglicherweise über Dateien, die von anderen Benutzern für ihn freigegeben wurden. Das Löschen dieses Benutzers verhindert, dass er auf das System und alle mit ihm geteilten Dateien zugreifen kann. Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>",
      "roleExternal": "Der Benutzer, den Sie löschen möchten, wird auch von anderen Benutzern auf der Plattform referenziert, die Dateien oder Ordner direkt mit ihnen geteilt haben. Durch das Entfernen dieses Benutzers wird ihm der Zugriff auf alle freigegebenen Inhalte entzogen und andere Benutzer, die mit ihm geteilt haben, sehen diesen Benutzer nicht mehr in ihren eigenen Benutzerlisten. Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>",
      "multiple": "Sie sind dabei, mehrere Benutzer zu löschen. Einige dieser Benutzer haben möglicherweise Dateien auf das System hochgeladen. Durch das Löschen werden alle hochgeladenen Dateien und alle zugehörigen Freigaben entfernt und sie können nicht mehr auf die Plattform zugreifen. Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>",
      "transferDestinationLabel": "Persönliche Dateien an einen anderen Benutzer übertragen (optional)",
      "transferDestinationPlaceholder": "Nach einem Benutzer suchen…",
      "transferOptionalHint": "Wenn Sie einen Empfänger auswählen, werden die persönlichen Dateien der Konten, die Sie löschen, vor dem Entfernen dorthin übertragen. Lassen Sie das Feld leer, um Dateien gemäß der oben beschriebenen Richtlinie zu entfernen.",
      "userReferencedInSettings": {
        "title": "Benutzer kann nicht gelöscht werden",
        "title_other": "Benutzer können nicht gelöscht werden",
        "description": "Der ausgewählte Benutzer kann nicht gelöscht werden. Auf diesen Benutzer wird in den folgenden Einstellungen verwiesen: <settingsList/>. Entfernen Sie diesen Benutzer aus diesen Einstellungen, bevor Sie es erneut versuchen.",
        "description_other": "Die ausgewählten Benutzer können nicht gelöscht werden. Sie werden in den folgenden Einstellungen referenziert: <settingsList/>. Entfernen Sie sie aus diesen Einstellungen, bevor Sie es erneut versuchen.",
        "unknownSettings": "Eine oder mehrere Einstellungen"
      }
    },
    "changeUsersStatus": {
      "title": "Benutzerstatus ändern",
      "description": "Sind Sie sicher, dass Sie {{status}} <strong>{{resource}}</strong> möchten?",
      "description_other": "Sind Sie sicher, dass Sie {{status}} <strong>diese Benutzer</strong> möchten?"
    },
    "excludeFromSso": {
      "titleExclude": "Benutzer von SSO ausschließen",
      "titleInclude": "SSO für Benutzer erneut aktivieren",
      "descriptionExclude": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> von SSO ausschließen möchten? Sie können sich nicht mehr über den konfigurierten Identitätsanbieter anmelden und müssen sich über OTP anmelden.",
      "descriptionInclude": "Sind Sie sicher, dass Sie SSO für <strong>{{resource}}</strong> wieder aktivieren möchten? Sie können sich wieder über den konfigurierten Identitätsanbieter anmelden."
    },
    "enterOnBehalfOf": {
      "title": "Rufen Sie den Modus „Im Auftrag von“ auf",
      "description": "Sie starten eine Sitzung, in der Sie im Namen von <strong>{{resource}}</strong>.<br /><br />Daten sehen und Vorgänge ausführen. Bestätigen Sie?"
    },
    "impersonateUser": {
      "title": "Sich als Benutzer ausgeben",
      "description": "Sind Sie sicher, dass Sie sich als {{userName}} anmelden möchten? Als dieser Benutzer können Sie Vorgänge sehen und ausführen.",
      "emailNotice": "Der Benutzer erhält eine E-Mail über diese Identitätsübernahme mit Ihrem Namen, Datum und Uhrzeit sowie dem unten eingegebenen Grund.",
      "reasonLabel": "Grund — wird dem Benutzer in der Benachrichtigungs-E-Mail angezeigt",
      "reasonTruncateHint": "Gründe über 500 Zeichen werden in der E-Mail mit \"…\" gekürzt (der vollständige Text wird trotzdem gespeichert).",
      "reasonEmptyHint": "Wenn leer gelassen, zeigt die E-Mail \"Not specified\"."
    },
    "userForm": {
      "editTitle": "Benutzer bearbeiten",
      "newTitle": "Neuer Benutzer",
      "editDescription": "Benutzerdetails bearbeiten",
      "newDescription": "Fügen Sie einen neuen Benutzer hinzu"
    },
    "userGroups": {
      "title": "Gruppenmitgliedschaft",
      "description": "Gruppen listen auf, welche <strong>{{resource}}</strong> Mitglieder sind"
    },
    "userFiles": {
      "title": "Geteilte Elemente",
      "description": "Mit <strong>{{resource}}</strong> geteilte Elemente"
    },
    "groupFiles": {
      "title": "Geteilte Elemente",
      "description": "Mit <strong>{{resource}}</strong> geteilte Elemente"
    },
    "fileSizeTooBigForOpen": {
      "title": "Dateigröße zu groß",
      "description": "Die Dateigröße überschreitet den Grenzwert von {{value}}. Wenn Sie die Datei öffnen möchten, können Sie sie herunterladen und lokal öffnen."
    },
    "deleteGroups": {
      "title": "Gruppe löschen",
      "title_other": "Gruppen löschen",
      "description": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> löschen möchten? Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>",
      "description_other": "Sind Sie sicher, dass Sie <strong>diese Gruppen</strong> löschen möchten? Sind Sie sicher, dass Sie fortfahren möchten? <i>(Geben Sie zur Bestätigung „{{keyword}}“ ein.)</i>"
    },
    "groupForm": {
      "editTitle": "Gruppe bearbeiten",
      "newTitle": "Neue Gruppe",
      "viewTitle": "Gruppe anzeigen",
      "editDescription": "Gruppendetails bearbeiten",
      "viewDescription": "Gruppendetails anzeigen",
      "newDescription": "Fügen Sie eine neue Gruppe hinzu",
      "allUsers": "Alle Benutzer",
      "selectedUsersOrGroups": "Ausgewählte Benutzer oder Gruppen"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Von Entra ID importieren",
      "title": "Importieren Sie Gruppen aus der Microsoft Entra ID",
      "searchGroups": "Gruppen durchsuchen...",
      "selectNew": "Wählen Sie nur „Neu“ aus",
      "existing": "Vorhanden",
      "new": "Neu",
      "importMembers": "Importieren Sie auch Gruppenmitglieder",
      "importSelected": "Importieren ({{count}})",
      "importSuccess": "Import abgeschlossen: {{created}} erstellt, {{updated}} aktualisiert",
      "importError": "Fehler beim Import",
      "errorLoadingGroups": "Fehler beim Laden der Gruppen von Entra ID",
      "noGroupsFound": "Keine Gruppen gefunden",
      "resultSummary": "Erstellt: {{created}}, Aktualisiert: {{updated}}, Übersprungen: {{skipped}}, Fehlgeschlagen: {{failed}}",
      "usersImported": "{{count}} Mitglieder wurden ebenfalls importiert",
      "permissionDeniedFallback": "Zugriff verweigert",
      "permissionErrorTitle": "Unzureichende Azure AD-Berechtigungen",
      "permissionErrorDescription": "Die Azure AD-Anwendung verfügt nicht über ausreichende Berechtigungen, um auf die Microsoft Graph-API zuzugreifen.",
      "permissionErrorSteps": "So beheben Sie dieses Problem:",
      "permissionErrorStep1": "Gehen Sie zu Azure-Portal > App-Registrierungen > Ihre App",
      "permissionErrorStep2": "Navigieren Sie zu API-Berechtigungen",
      "permissionErrorStep3": "Fügen Sie die erforderlichen Anwendungsberechtigungen hinzu (nicht delegiert).",
      "permissionErrorStep4": "Klicken Sie auf „Administratoreinwilligung erteilen“, um die Berechtigungen zu autorisieren",
      "requiredPermissions": "Erforderliche Berechtigungen",
      "defaultRole": "Standardrolle"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Import from CSV",
      "title": "Import users from CSV",
      "description": "Create new users only. Rows whose email already exists are skipped (not treated as failures). Roles: SuperAdmin, Admin, Contributor, Reader (or numeric codes).",
      "browserStayOpenWarning": "Do not close or refresh this browser tab until the import finishes. Progress exists only in this session.",
      "confirmSkipErrors": "Es gibt {{count}} Elemente mit Fehlern; diese werden nicht importiert.",
      "downloadTemplate": "Download CSV template",
      "sendInvites": "Send invitation emails to newly created users",
      "dropzone": "Drop a CSV file here or click to browse",
      "fileSelected": "Selected: {{name}}",
      "invalidFileType": "Please select a .csv file",
      "readError": "Could not read the CSV file",
      "noValidRows": "No valid rows found in this file",
      "colLine": "Line",
      "confirmImport": "Import {{count}} users",
      "emptyFile": "The CSV file is empty",
      "invalidHeader": "Invalid header. Expected: {{expected}}",
      "tooManyColumns": "Too many columns on this row",
      "missingFirstName": "First name is required",
      "missingLastName": "Last name is required",
      "missingEmail": "Email is required",
      "invalidEmail": "Invalid email address",
      "missingRole": "Role is required",
      "invalidRole": "Invalid role: {{value}}",
      "superAdminRoleNotAllowed": "Only a SuperAdmin can assign the SuperAdmin role",
      "invalidExpirationDate": "Invalid expiration date: {{value}}",
      "invalidBoolean": "Invalid boolean for {{field}}: {{value}}",
      "duplicateInFile": "Duplicate email in file (first seen on line {{firstLine}})",
      "genericCreateError": "Could not create user",
      "drawerAria": "User import progress",
      "drawerRunning": "Importing users…",
      "drawerCompleted": "User import complete",
      "drawerCancelled": "User import cancelled",
      "importingUsersCounter": "Importing users {{amount}} of {{total}}",
      "importedUsersCounter": "Imported {{amount}} of {{total}}",
      "waitingForImport": "Waiting",
      "importingRow": "Importing…",
      "alreadyExists": "Already exist",
      "summary": "Created: {{created}} · Already exist: {{skipped}} · Failed: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Failed",
      "alreadyExistList": "Already exist ({{count}})",
      "cancelImport": "Cancel import",
      "cancelConfirmTitle": "Cancel import?",
      "cancelConfirmContent": "In-flight creates will finish; remaining rows will not start.",
      "continueImport": "Keep importing",
      "minimizeDrawer": "Minimize",
      "expandDrawer": "Expand",
      "previewHeading": "{{total}} Benutzer · {{errors}} Fehler",
      "searchPlaceholder": "Benutzer suchen…",
      "colStatus": "Status",
      "filterWithErrors": "Mit Fehlern",
      "filterValid": "Gültig",
      "statusError": "Fehler",
      "statusOk": "OK"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Von Entra ID importieren",
      "title": "Benutzer importieren von Microsoft Entra ID",
      "searchUsers": "Benutzer suchen...",
      "selectNew": "Wählen Sie nur „Neu“ aus",
      "existing": "Vorhanden",
      "new": "Neu",
      "importSelected": "Importieren ({{count}})",
      "importSuccess": "Import abgeschlossen: {{created}} erstellt, {{updated}} aktualisiert",
      "importError": "Fehler beim Import",
      "errorLoadingUsers": "Fehler beim Laden von Benutzern von Entra ID",
      "noUsersFound": "Keine Benutzer gefunden",
      "resultSummary": "Erstellt: {{created}}, Aktualisiert: {{updated}}, Übersprungen: {{skipped}}, Fehlgeschlagen: {{failed}}",
      "permissionDeniedFallback": "Zugriff verweigert",
      "permissionErrorTitle": "Unzureichende Azure AD-Berechtigungen",
      "permissionErrorDescription": "Die Azure AD-Anwendung verfügt nicht über ausreichende Berechtigungen, um auf die Microsoft Graph-API zuzugreifen.",
      "permissionErrorSteps": "So beheben Sie dieses Problem:",
      "permissionErrorStep1": "Gehen Sie zu Azure-Portal > App-Registrierungen > Ihre App",
      "permissionErrorStep2": "Navigieren Sie zu API-Berechtigungen",
      "permissionErrorStep3": "Fügen Sie die erforderlichen Anwendungsberechtigungen hinzu (nicht delegiert).",
      "permissionErrorStep4": "Klicken Sie auf „Administratoreinwilligung erteilen“, um die Berechtigungen zu autorisieren",
      "requiredPermissions": "Erforderliche Berechtigungen",
      "defaultRole": "Standardrolle"
    },
    "batchDetailForm": {
      "title": "Batch-Details",
      "noFailedFiles": "Keine fehlgeschlagenen Dateien",
      "noFiles": "Keine Dateien in diesem Status",
      "fileCancelled": "Abbruch für diese Datei angefordert.",
      "fileCancelError": "Fehler beim Anfordern des Dateiabbruchs.",
      "fileRetried": "Datei für erneuten Versuch eingereiht",
      "fileRetryError": "Fehler beim erneuten Versuch der Datei",
      "truncatedHint": "Die Vorschau fehlgeschlagener Dateien wurde gekürzt. Nutzen Sie die Registerkarte Fehlgeschlagen für die vollständige Liste.",
      "attempt": "Versuch {{count}}",
      "tabs": {
        "pending": "Wartend",
        "processing": "In Bearbeitung",
        "success": "Abgeschlossen",
        "failed": "Fehlgeschlagen",
        "canceled": "Abgebrochen"
      },
      "status": {
        "pending": "Wartend",
        "processing": "In Bearbeitung",
        "success": "Abgeschlossen",
        "failed": "Fehlgeschlagen",
        "canceled": "Abgebrochen"
      }
    },
    "batchesList": {
      "panelTitle": "Batches",
      "noActiveBatches": "Keine aktiven Batches",
      "cancelAllFailed": "Alle fehlgeschlagenen Batches abbrechen (nicht Verarbeitung)",
      "cancelAllFailedConfirmTitle": "Alle fehlgeschlagenen Batches abbrechen?",
      "cancelAllFailedConfirmContent": "Es werden nur Batches mit Status Fehlgeschlagen gelöscht. Batches in Verarbeitung oder in der Warteschlange laufen weiter und sind nicht betroffen. Dieser Vorgang kann nicht rückgängig gemacht werden.",
      "cancelBatch": "Batch abbrechen",
      "cancelBatchConfirmTitle": "Diesen Stapel abbrechen?",
      "cancelBatchConfirmContent": "Dadurch wird die Anfrage abgebrochen. Die Verarbeitung kann am nächsten Checkpoint stoppen. Diese Aktion kann nicht rückgängig gemacht werden.",
      "failedFiles": "Datei {{count}} fehlgeschlagen",
      "failedFiles_other": "{{count}}-Dateien sind fehlgeschlagen",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "Alle",
        "queued": "In der Warteschlange",
        "processing": "Verarbeitung",
        "completed": "Vollendet",
        "failed": "Fehlgeschlagen",
        "partiallycompleted": "Teilweise abgeschlossen",
        "cancelled": "Abgesagt"
      },
      "operation": {
        "all": "Alle Operationen",
        "classification": "KI-Klassifizierung",
        "folderexpansion": "Ordnererweiterung",
        "delete": "Löschen",
        "zip": "Die ZIP-Erstellung ist fehlgeschlagen"
      },
      "pendingFiles": "{{count}} wartend",
      "pendingFiles_other": "{{count}} wartend",
      "processingFiles": "{{count}} in Bearbeitung",
      "processingFiles_other": "{{count}} in Bearbeitung",
      "processedFiles": "{{count}} abgeschlossen",
      "processedFiles_other": "{{count}} abgeschlossen",
      "canceledFiles": "{{count}} abgebrochen",
      "canceledFiles_other": "{{count}} abgebrochen",
      "viewDetail": "Details anzeigen"
    },
    "tagForm": {
      "editTitle": "Tag bearbeiten",
      "newTitle": "Neuer Tag",
      "editDescription": "Tag-Details bearbeiten",
      "newDescription": "Fügen Sie ein neues Tag hinzu",
      "visibility": "Sichtweite",
      "selectUserRoles": "Wählen Sie Benutzerrollen aus",
      "visibilityDescription": "Machen Sie dieses Tag für die folgenden Rollen sichtbar und geben Sie an, ob das Tag für alle oder nur für bestimmte Gruppen oder Benutzer sichtbar sein soll.",
      "usedInSettings": "Verwendet in:",
      "usedInSettingsNone": "Dieses Tag wird in keiner Einstellung verwendet."
    },
    "deleteTag": {
      "title": "Tag löschen",
      "description": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> löschen möchten? Sind Sie sicher, dass Sie fortfahren möchten?",
      "descriptionWithPublicTag": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> löschen möchten? Durch das Löschen dieses Tags werden alle damit verbundenen Freigaben in der Einstellung „Sichtbarkeit markierter Dateien“ entfernt.",
      "errorInUse": "Tag kann nicht gelöscht werden",
      "errorInUseDescription": "Dieses Tag wird derzeit in folgenden Bereichen verwendet:",
      "errorInUseAction": "Entfernen Sie das Tag von diesen Stellen, bevor Sie es löschen.",
      "usedInSettings": "Einstellungen",
      "usedInClassificationAgent": "Klassifizierungsagent"
    },
    "fileTitleForm": {
      "newFolderTitle": "Neuer Ordner",
      "editFolderTitle": "Ordner umbenennen",
      "editFileTitle": "Datei umbenennen"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "Neues Word-Dokument",
      "newExcelDocumentTitle": "Neues Excel-Dokument",
      "newPowerpointDocumentTitle": "Neues PowerPoint-Dokument",
      "newGenericDocumentTitle": "Neues Dokument"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Passwort",
      "required": "Passwort ist erforderlich",
      "cancel": "Abbrechen",
      "confirm": "Entsperren",
      "error": "Falsches Passwort",
      "lockout": "Zu viele gescheiterte Versuche. Versuchen Sie es in {{minutes}} Minuten erneut.",
      "genericError": "Es ist ein Fehler aufgetreten",
      "resetPassword": "Passwort zurücksetzen",
      "forgotPassword": "Passwort vergessen?",
      "title": "Geschützter Ordner",
      "description": "Für den Ordner „{{folderName}}“ ist ein Passwort erforderlich."
    },
    "filePasswordForm": {
      "title": "Ordner-Passwortschutz",
      "createTitle": "Passwortschutz festlegen",
      "editTitle": "Passwortschutz bearbeiten",
      "password": "Passwort",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "newPasswordHelp": "Lassen Sie das Feld leer, um das aktuelle Passwort beizubehalten",
      "ownerBypass": "Eigentümerumgehung",
      "ownerBypassDescription": "Der Besitzer kann ohne Passwort auf den Ordner zugreifen",
      "adminBypass": "Admin-Bypass",
      "adminBypassDescription": "Der Administrator kann ohne Passwort auf den Ordner zugreifen",
      "maxFailedAttempts": "Max. fehlgeschlagene Versuche",
      "lockoutDuration": "Sperrdauer (Minuten)",
      "sessionDuration": "Sitzungsdauer (Minuten)",
      "expirationDate": "Verfallsdatum",
      "expirationDatePlaceholder": "Datum auswählen (optional)",
      "remove": "Passwort entfernen",
      "removeConfirm": "Sind Sie sicher, dass Sie das Passwort entfernen möchten?",
      "validation": {
        "required": "Dieses Feld ist erforderlich",
        "minLength": "Muss mindestens {{min}} Zeichen umfassen",
        "expirationDateExpired": "Das Ablaufdatum darf nicht in der Vergangenheit liegen"
      }
    },
    "fileSessionsForm": {
      "title": "Ordnersitzungen",
      "revokeAllSessionsDescription": "Alle Entsperrsitzungen für „{{fileName}}“ werden widerrufen. Benutzer müssen das Passwort erneut eingeben, um auf diesen Ordner zuzugreifen.",
      "revokeAllFolderSessionsDescription": "Alle Sitzungen zum Entsperren von Ordnern werden widerrufen. Benutzer müssen das Passwort erneut eingeben, um auf einen geschützten Ordner zuzugreifen.",
      "noSessions": "Keine aktiven Sitzungen",
      "unknownDevice": "Unbekanntes Gerät",
      "createdAt": "Erstellt",
      "expiresAt": "Läuft ab",
      "revokeSession": "Widerrufen",
      "sessionRevoked": "Sitzung erfolgreich widerrufen",
      "sessionRevoked_other": "{{count}} Sitzungen wurden erfolgreich widerrufen",
      "allSessionsRevoked": "Alle Sitzungen wurden widerrufen",
      "fetchError": "Fehler beim Abrufen der Sitzungen",
      "revokeError": "Fehler beim Widerrufen der Sitzung",
      "revokeAllError": "Fehler beim Widerrufen aller Sitzungen",
      "revokeSessionConfirmTitle": "Diese Sitzung widerrufen?",
      "revokeSessionConfirmDescription": "Diese Sitzung zum Entsperren des Ordners wird sofort widerrufen. Der Benutzer muss das Passwort erneut eingeben, um auf diesen Ordner zuzugreifen.",
      "revokeAllConfirmTitle": "Alle Ordnersitzungen widerrufen?",
      "revokeAllConfirmDescription": "Alle Sitzungen zum Entsperren von Ordnern werden widerrufen. Benutzer müssen das Passwort erneut eingeben, um auf geschützte Ordner zuzugreifen.",
      "logoutAll": "Alles widerrufen"
    },
    "userSessionsForm": {
      "activeSessions": "Aktive Sitzungen",
      "manageSessions": "Sitzungen verwalten",
      "manageUserSessions": "Sitzungen von {{userName}}",
      "noSessions": "Keine aktiven Sitzungen",
      "unknownBrowser": "Unbekannter Browser",
      "unknownDevice": "Unbekanntes Gerät",
      "lastActivity": "Letzte Aktivität",
      "expiresAt": "Läuft ab",
      "currentSession": "Aktuelle Sitzung",
      "revokeSession": "Widerrufen",
      "sessionRevoked": "Sitzung erfolgreich widerrufen",
      "sessionRevoked_other": "{{count}} Sitzungen wurden erfolgreich widerrufen",
      "otherSessionsRevoked": "{{count}} Sitzung erfolgreich widerrufen",
      "otherSessionsRevoked_other": "{{count}} Sitzungen wurden erfolgreich widerrufen",
      "allSessionsRevoked": "Alle Sitzungen wurden widerrufen",
      "revokeSessionConfirmTitle": "Diese Sitzung widerrufen?",
      "revokeSessionConfirmDescription": "Das Gerät wird sofort abgemeldet.",
      "revokeGroupedSessionConfirmDescription": "Dadurch werden {{count}} Sitzungen von diesem Gerät widerrufen.",
      "revokeOthersConfirmTitle": "Alle anderen Geräte abmelden?",
      "revokeOthersConfirmDescription": "Alle Geräte außer dem aktuellen werden abgemeldet.",
      "revokeAllConfirmTitle": "Alle Geräte abmelden?",
      "revokeAllConfirmDescription": "Alle Geräte werden abgemeldet, auch das aktuelle. Sie müssen sich erneut anmelden.",
      "adminRevokeAllConfirmTitle": "Alle Benutzersitzungen abmelden?",
      "adminRevokeAllConfirmDescription": "Alle Sitzungen von {{userName}} werden widerrufen. Der Benutzer muss sich erneut anmelden.",
      "logoutOthers": "Melden Sie andere Geräte ab",
      "logoutAll": "Alle abmelden",
      "revokeAllUserSessions": "Alles widerrufen"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "Passwort vergessen?",
      "otpSentToEmail": "OTP an Ihre E-Mail-Adresse gesendet.",
      "resetPassword": "Passwort zurücksetzen",
      "otpCodeLabel": "OTP-Code",
      "newPasswordLabel": "Neues Passwort",
      "wrongOtpCode": "Falscher OTP-Code.",
      "tooManyAttemptsRequestNewOtp": "Zu viele Versuche. Fordern Sie ein neues OTP an.",
      "codeExpiredRequestNewOtp": "Code abgelaufen. Fordern Sie ein neues OTP an.",
      "otpRequired": "OTP ist erforderlich",
      "otpMustBe6": "OTP muss 6 Ziffern sein",
      "newPasswordRequired": "Neues Passwort ist erforderlich",
      "newPasswordMin": "Das Passwort muss mindestens 4 Zeichen lang sein",
      "passwordResetSuccess": "Das Passwort wurde erfolgreich zurückgesetzt.",
      "tooManyOtpRequests": "Zu viele OTP-Anfragen. Bitte versuchen Sie es später noch einmal."
    },
    "fileMoveForm": {
      "title": "Verschieben Sie {{resource}}",
      "title_other": "{{count}}-Dateien verschieben",
      "currentPosition": "Aktuelle Position",
      "folderIsEmpty": "Der Ordner ist leer",
      "selectFolderToMoveInto": "Wählen Sie eine Position aus, um den Ordnerpfad anzuzeigen, in den Sie die Datei verschieben möchten"
    },
    "convertToPdf": {
      "title": "In PDF konvertieren",
      "selectDestination": "Zielordner auswählen"
    },
    "fileShortcutForm": {
      "title": "Erstellen Sie eine Verknüpfung für {{resource}}",
      "currentPosition": "Aktuelle Position",
      "folderIsEmpty": "Der Ordner ist leer",
      "selectFolderToCreateShortcutInto": "Wählen Sie eine Position aus, um den Ordnerpfad anzuzeigen, in dem Sie die Verknüpfung erstellen möchten",
      "goBack": "Zurück"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Aktuelle Position",
      "folderIsEmpty": "Der Ordner ist leer",
      "selectFolderHint": "Wählen Sie den Ordner, in dem die Datei gespeichert werden soll",
      "goBack": "Zurück"
    },
    "fileShareForm": {
      "title": "Teilen {{resource}}",
      "title_other": "Teilen Sie {{count}}-Dateien",
      "message": "Geben Sie diese Datei für einen oder mehrere Benutzer oder Gruppen frei.",
      "message_other": "Teilen Sie {{count}}-Dateien mit einem oder mehreren Benutzern oder Gruppen.",
      "currentPosition": "Aktuelle Position",
      "folderIsEmpty": "Der Ordner ist leer",
      "selectFolderToShareInto": "Wählen Sie eine Position aus, um den Ordnerpfad anzuzeigen, in dem Sie die Datei freigeben möchten",
      "peopleWithAccess": "Menschen mit Zugang",
      "sendMessage": "Benachrichtigen Sie die Empfänger per E-Mail",
      "sendMessagePlaceholder": "Fügen Sie eine benutzerdefinierte Nachricht hinzu (optional)",
      "existingAccessesChanged": "Bestehende Zugänge geändert",
      "existingAccessesChangedDescription": "Speichern wendet Ihre Änderungen auf bestehende Zugriffe an und fügt dann die neuen Benutzer oder Gruppen hinzu. Abbrechen lässt das Formular unverändert und fügt sie nicht hinzu.",
      "existingAccessesExpirationRequired": "Um diese vorhandenen Zugriffe zu aktualisieren, müssen Sie ein gemäß den Unternehmensrichtlinien zulässiges Ablaufdatum festlegen.",
      "applyAllExpirationDates": "Alles anwenden"
    },
    "filePublicLinkForm": {
      "title": "Öffentlicher Link",
      "createTitle": "Öffentlichen Link erstellen",
      "expirationLabel": "Ablauf (optional)",
      "expirationLabelRequired": "Ablauf",
      "expirationPlaceholder": "Niemals",
      "maxAccessCountLabel": "Maximale Zugriffsanzahl (optional)",
      "maxAccessCountLabelRequired": "Maximale Zugriffsanzahl",
      "maxAccessCountPlaceholder": "Unbegrenzt",
      "allowDownload": "Download zulassen",
      "protectWithPassword": "Mit Passwort schützen",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Passwort eingeben",
      "passwordRequired": "Bei aktiviertem Schutz ist ein Passwort erforderlich",
      "createLink": "Verknüpfung erstellen",
      "linkCreatedTitle": "Link erstellt!",
      "linkCreatedMessage": "Der öffentliche Link wurde erstellt.",
      "copyLink": "Link kopieren",
      "warning": "Durch das Erstellen eines öffentlichen Links werden die Standardschutzmaßnahmen für diese Datei umgangen. Jeder, der über den Link verfügt, kann auf den Dokumentinhalt zugreifen – verwenden Sie ihn mit Vorsicht.",
      "expiresAt": "Läuft ab",
      "remainingAccesses": "Verbleibende Zugriffe",
      "password": "Passwort",
      "revoke": "Link widerrufen",
      "revoked": "Öffentlicher Link erfolgreich widerrufen.",
      "publicUrl": "Öffentlich URL",
      "status": "Status",
      "statusActive": "Aktiv",
      "statusExpired": "Abgelaufen",
      "statusExhausted": "Limit erreicht",
      "accessCount": "Zugriffe",
      "hasPassword": "Passwortgeschützt",
      "createdAt": "Erstellt",
      "errors": {
        "linkAlreadyExists": "Für diese Datei existiert bereits ein öffentlicher Link. Widerrufen Sie es zunächst, um ein neues zu erstellen.",
        "linkNotFound": "Für diese Datei wurde kein aktiver Link gefunden.",
        "featureDisabled": "Öffentliche Links sind für Ihre Organisation deaktiviert.",
        "notOwner": "Sie müssen der Eigentümer sein, um öffentliche Links erstellen oder widerrufen zu können."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Abgelaufen",
      "statusExhausted": "Limit erreicht",
      "statusActive": "Aktiv",
      "expiresAt": "Läuft ab",
      "accessCount": "Zugriffe",
      "hasPassword": "Passwort",
      "empty": "Noch keine öffentlichen Links."
    },
    "userTransferOwnershipForm": {
      "title": "Eigentum übertragen – {{sourceName}}",
      "destinationLabel": "Zielbenutzer",
      "destinationPlaceholder": "Suchen Sie einen Benutzer und wählen Sie ihn aus",
      "destinationRequired": "Wählen Sie einen Zielbenutzer aus.",
      "infoMessage": "Dateien werden in einen Ordner „Übertragen von {{email}}“ im Stammverzeichnis des Empfängers verschoben. Auf dem Marktplatz zum Verkauf angebotene Dateien werden nicht übertragen.",
      "submit": "Eigentum übertragen",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "successTitle": "Übertragung abgeschlossen",
      "resultFilesTransferred": "Dateien übertragen",
      "resultFoldersTransferred": "Ordner übertragen",
      "resultSharesUpdated": "Anteile aktualisiert",
      "resultSelfSharesRemoved": "Eigenanteile entfernt",
      "resultTagAssignmentsRemoved": "Tag-Zuweisungen entfernt",
      "resultTagAssignmentsTransferred": "Tagzuweisungen übertragen",
      "resultFilesForSaleExcluded": "Ausgenommen sind Dateien zum Verkauf",
      "resultWrapperFolderName": "Name des Wrapper-Ordners"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "2FA-Status",
      "totpEnabled": "TOTP aktiviert",
      "enabledAt": "Aktiviert am",
      "backupCodesRemaining": "Es verbleiben noch Backup-Codes",
      "requiredByPolicy": "Gemäß den Richtlinien erforderlich",
      "lockoutStatus": "Sperrstatus",
      "failedAttempts": "Fehlgeschlagene Versuche",
      "exemptionTitle": "TOTP-Ausnahme",
      "grantExemption": "Befreiung gewähren",
      "revokeExemption": "Befreiung widerrufen",
      "revoke": "Widerrufen",
      "exemptionTypeTemporary": "Vorübergehend",
      "exemptionTypePermanent": "Dauerhaft",
      "exemptionTypeLabel": "Typ",
      "exemptionExpires": "Läuft ab am",
      "exemptionReason": "Grund",
      "grantedBy": "Gewährt von",
      "grantedAt": "Zugegeben am",
      "grantDialogTitle": "Befreiung gewähren",
      "grantDialogTemporary": "Vorübergehend",
      "grantDialogPermanent": "Dauerhaft",
      "grantDialogDays": "Tage",
      "grantDialogReason": "Grund (mindestens 5 Zeichen)",
      "grantSubmit": "Freigabe",
      "revokeConfirmTitle": "Befreiung widerrufen",
      "revokeConfirmDescription": "Der Benutzer muss die 2FA-Richtlinie erneut einhalten.",
      "disableConfirmTitle": "2FA für diesen Benutzer deaktivieren?",
      "disableConfirmDescription": "Dadurch wird die Zwei-Faktor-Authentifizierung für den Benutzer entfernt. Sie müssen es erneut einrichten, wenn dies aufgrund der Richtlinien erforderlich ist.",
      "statusLoading": "Laden…",
      "statusError": "Der Status „2FA“ konnte nicht geladen werden.",
      "grantSuccess": "Befreiung gewährt.",
      "revokeSuccess": "Befreiung widerrufen.",
      "disableSuccess": "2FA deaktiviert.",
      "cancel": "Abbrechen",
      "disableTotp": "Deaktivieren Sie 2FA",
      "retry": "Wiederholen",
      "errorGeneric": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut."
    },
    "userPasskeyForm": {
      "cancel": "Abbrechen",
      "retry": "Wiederholen",
      "errorGeneric": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      "passkeyRemove": "Entfernen",
      "passkeyRemoveAll": "Entfernen Sie alle Passkeys",
      "passkeyRemoveAllConfirm": "Dadurch werden alle {{count}}-Passkeys für diesen Benutzer entfernt. Sie müssen neue registrieren.",
      "passkeyRemoveAllSuccess": "Alle Passkeys entfernt.",
      "passkeyRemoveAllTitle": "Alle Passkeys entfernen?",
      "passkeyRemoveConfirm": "Passkey „{{name}}“ entfernen? Der Benutzer kann es nicht mehr für die Anmeldung verwenden.",
      "passkeyRemoveSuccess": "Passkey entfernt.",
      "passkeyRemoveTitle": "Passkey entfernen?",
      "passkeysBlocked": "Passkey-Sperre",
      "passkeysCount": "Passkeys registriert",
      "passkeysEnabled": "Passkeys aktiviert",
      "passkeysFailedAttempts": "Passkey-Versuche sind fehlgeschlagen",
      "passkeysLoadError": "Der Administratorstatus des Passkeys konnte nicht geladen werden.",
      "passkeysTitle": "Passkeys"
    },
    "loginTokensForm": {
      "title": "Zugriffstoken – {{userName}}",
      "manageTokens": "Zugriffstoken verwalten",
      "noTokens": "Für diesen Benutzer sind keine Zugriffstoken konfiguriert.",
      "createToken": "Neues Token erstellen",
      "label": "Etikett",
      "labelRequired": "Etikett ist erforderlich",
      "labelPlaceholder": "z.B. CRM-Integration, CI/CD-Pipeline",
      "expirationDays": "Ablauf (Tage)",
      "create": "Erstellen",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "delete": "Löschen",
      "retry": "Wiederholen",
      "enabled": "Ermöglicht",
      "disabled": "Deaktiviert",
      "expired": "Abgelaufen",
      "enable": "Aktivieren",
      "disable": "Deaktivieren",
      "createdAt": "Erstellt",
      "expiresAt": "Läuft ab",
      "lastUsed": "Zuletzt verwendet",
      "lastUsedIp": "Letzte IP",
      "neverUsed": "Nie benutzt",
      "maxTokensReached": "Maximale Anzahl an Token erreicht (2). Löschen Sie ein vorhandenes Token, um ein neues zu erstellen.",
      "tokenCreatedTitle": "Token erfolgreich erstellt",
      "tokenCreatedWarning": "Kopieren Sie dieses Token jetzt. Es wird nicht erneut angezeigt.",
      "copyToken": "Token kopieren",
      "copied": "Kopiert!",
      "deleteConfirmTitle": "Zugriffstoken löschen?",
      "deleteConfirmDescription": "Der Token „{{label}}“ wird endgültig gelöscht und kann nicht mehr zur Authentifizierung verwendet werden.",
      "deleteSuccess": "Token erfolgreich gelöscht.",
      "errorCannotCreateTokenForSuperAdmin": "Für Superadministratoren können keine Zugriffstoken erstellt werden.",
      "errorGeneric": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      "errorLoad": "Zugriffstoken konnten nicht geladen werden.",
      "errorMaxReached": "Dieser Benutzer verfügt bereits über die maximale Anzahl an Token.",
      "errorTokenAlreadyUsed": "Dieses Token wurde bereits verwendet und kann nicht erneut aktiviert werden."
    },
    "alertDismiss": {
      "title": "Alarm verwerfen oder in den Schlummermodus versetzen",
      "chooseAction": "Wie möchten Sie weitermachen?",
      "permanent": "Nicht mehr anzeigen",
      "snooze": "Erinnere mich später daran",
      "snoozeDuration": "Erinnere mich danach daran",
      "confirm": "Anwenden",
      "success": "Präferenz gespeichert."
    },
    "alertsList": {
      "title": "Alle aktiven Warnungen",
      "dismiss": "Schlummern oder entlassen"
    },
    "totpForm": {
      "title": "Zwei-Faktor-Authentifizierung",
      "statusActive": "Aktiv",
      "statusInactive": "Inaktiv",
      "activatedOn": "Aktiviert am {{date}}",
      "backupCodesRemaining": "Es verbleiben noch {{count}} / {{total}} Backup-Codes",
      "requiredByPolicy": "Ihre Organisation benötigt eine Zwei-Faktor-Authentifizierung.",
      "gracePeriodEnds": "Sie haben bis {{date}} Zeit, es zu aktivieren.",
      "activate": "2FA aktivieren",
      "setupTitle": "Richten Sie die Zwei-Faktor-Authentifizierung ein",
      "scanQR": "Scannen Sie diesen QR-Code mit Ihrer Authentifizierungs-App (Google Authenticator, Microsoft Authenticator, Authy usw.).",
      "manualEntry": "Kann nicht scannen? Geben Sie manuell ein",
      "hideManual": "Manuelle Eingabe ausblenden",
      "enterSecretManually": "Geben Sie diesen Code manuell in Ihre App ein:",
      "copySecret": "Kopie",
      "copied": "In die Zwischenablage kopiert",
      "verifyCodeLabel": "Geben Sie den 6-stelligen Code aus Ihrer App ein",
      "verifyAndActivate": "Überprüfen und aktivieren",
      "backupCodesTitle": "Zwei-Faktor-Authentifizierung aktiviert!",
      "regenerateSuccess": "Sicherungscodes neu generiert",
      "backupCodesWarning": "Bewahren Sie diese Backup-Codes an einem sicheren Ort auf. Sie können für den Zugriff auf Ihr Konto verwendet werden, wenn Sie den Zugriff auf Ihre Authentifizierungs-App verlieren. Jeder Code kann nur einmal verwendet werden.",
      "copyAll": "Alles kopieren",
      "download": "Herunterladen",
      "print": "Drucken",
      "savedConfirm": "Ich habe diese Codes an einem sicheren Ort gespeichert",
      "continue": "Weitermachen",
      "regenerateBackupCodes": "Backup-Codes neu generieren",
      "disableTotp": "Deaktivieren Sie 2FA",
      "disableConfirm": "Zwei-Faktor-Authentifizierung deaktivieren?",
      "disableConfirmDescription": "Durch das Entfernen von 2FA wird Ihr Konto weniger sicher. Sie müssen Ihre Authentifizierungs-App neu konfigurieren, wenn Sie 2FA erneut aktivieren möchten.",
      "enterCodeToConfirm": "Geben Sie zur Bestätigung den Code TOTP ein",
      "cancel": "Abbrechen",
      "disable": "Deaktivieren",
      "disabledSuccess": "Die Zwei-Faktor-Authentifizierung wurde deaktiviert.",
      "invalidCode": "Ungültiger Code. Bitte versuchen Sie es erneut.",
      "errorGeneric": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      "retry": "Wiederholen"
    },
    "passkeyCreateForm": {
      "addDescription": "Wenn Sie fortfahren, werden Sie von Ihrem Browser aufgefordert, sich mit Touch ID, Face ID, Windows Hello oder Ihrem Sicherheitsschlüssel zu verifizieren.",
      "continueAuthenticator": "Weitermachen",
      "deviceNameInvalid": "Geben Sie einen Gerätenamen mit 1 bis 100 Zeichen ein.",
      "deviceNameLabel": "Gerätename",
      "deviceNamePlaceholder": "z.B. MacBook Touch ID",
      "passkeyCancelled": "Die Passkey-Anmeldung wurde abgebrochen.",
      "registerErrorDeviceAlreadyRegistered": "Für dieses Gerät ist bereits ein Passkey registriert. Verwenden Sie einen anderen Authentifikator oder entfernen Sie zuerst den vorhandenen Passkey.",
      "registerErrorGeneric": "Die Passkey-Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
      "registerErrorNotSupported": "Ihr Browser oder Gerät unterstützt diese Art der Passkey-Registrierung nicht.",
      "registerSuccess": "Passschlüssel gespeichert.",
      "title": "Fügen Sie einen Passkey hinzu"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "Geben Sie einen Gerätenamen mit 1 bis 100 Zeichen ein.",
      "deviceNameLabel": "Gerätename",
      "renameError": "Der Passkey konnte nicht umbenannt werden.",
      "renameSuccess": "Passkey umbenannt.",
      "saveLabel": "Speichern",
      "title": "Passkey umbenennen"
    },
    "passkeysForm": {
      "addPasskey": "Passschlüssel hinzufügen",
      "browserUnsupported": "Ihr Browser unterstützt keine Passkeys. Verwenden Sie eine aktuelle Version von Chrome, Safari, Edge oder Firefox.",
      "empty": "Noch keine Passkeys. Fügen Sie einen hinzu, um sich schneller anzumelden, und verwenden Sie ihn als zweiten Faktor.",
      "lastUsed": "Zuletzt verwendet",
      "loadError": "Der Passkey-Status konnte nicht geladen werden.",
      "maxReached": "Sie können bis zu {{max}} Passkeys registrieren.",
      "never": "Niemals",
      "passwordless": "Ohne Passwort",
      "passwordlessDisabled": "Passwortlos deaktiviert.",
      "passwordlessEnabled": "Passwortlos aktiviert.",
      "passwordlessUnavailable": "Für dieses Gerät nicht verfügbar",
      "policyDisabled": "Passkeys werden von Ihrer Organisation deaktiviert.",
      "registered": "Eingetragen",
      "remove": "Entfernen",
      "removeConfirm": "Passkey „{{name}}“ entfernen? Sie können es nicht mehr für die Anmeldung verwenden.",
      "removeError": "Der Passkey konnte nicht entfernt werden.",
      "removeLastWarning": "Dies ist Ihr einziger Hauptschlüssel. Durch das Entfernen wird die Anmeldung mit dem Kennwort deaktiviert, bis Sie ein neues hinzufügen.",
      "removeSuccess": "Passkey entfernt.",
      "removeTitle": "Passkey entfernen?",
      "rename": "Umbenennen",
      "title": "Passkeys",
      "toggleError": "Die passwortlose Einstellung konnte nicht aktualisiert werden.",
      "transport": "Gerätetyp",
      "transportBle": "Bluetooth-Sicherheitsschlüssel",
      "transportHybrid": "Telefon",
      "transportHybridInternal": "Synchronisierter Passkey (Telefon)",
      "transportInternal": "Dieses Gerät (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Sicherheitsschlüssel (NFC)",
      "transportUsb": "Sicherheitsschlüssel (USB)",
      "transportUsbNfc": "Sicherheitsschlüssel (USB + NFC)",
      "transportUnknown": "Nicht gemeldet"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "Übergeordneten Ordner abwählen?",
      "confirmDeselectParentDescription": "Wenn Sie diesen Ordner auswählen, wird die Auswahl des übergeordneten Ordners und aller Ordner auf derselben Ebene aufgehoben. Möchten Sie fortfahren?",
      "ariaLabel": "Formular zur Dateifreigabe",
      "selectUsersOrGroups": "Wählen Sie Benutzer oder Gruppen aus",
      "userMultiSelectAria": "Benutzer- und Gruppenauswahl",
      "actions": "Aktionen"
    },
    "fileTagsForm": {
      "title": "Tags bearbeiten – {{resource}}",
      "availableTags": "Verfügbare Tags",
      "assignedTags": "Zugewiesene Tags",
      "searchAvailableTags": "Verfügbare Tags suchen",
      "searchAssignedTags": "Zugewiesene Tags suchen",
      "noAssignedTags": "Keine Tags zugewiesen",
      "clickHintAdd": "Klicken Sie auf einen Tag, um ihn hinzuzufügen.",
      "clickHintRemove": "Klicken Sie auf einen Tag, um ihn zu entfernen. Ziehen Sie den Griff zum Neuordnen.",
      "clickToAdd": "Tag {{title}} hinzufügen",
      "clickToRemove": "Tag {{title}} entfernen",
      "dragToReorder": "Ziehen zum Neuordnen von {{title}}",
      "aiScrapingOnlyPdfOffice": "AI Scraping ist nur für PDF- und Office-Dateien aktiv.",
      "watermarkOnlyPdfOffice": "Der Wasserzeichenschutz ist nur für PDF- und Office-Dateien aktiv."
    },
    "openFileFromTrash": {
      "title": "Diese Datei befindet sich in Ihrem Papierkorb",
      "description": "Um <strong>{{resource}}</strong> anzuzeigen, müssen Sie es aus dem Papierkorb wiederherstellen."
    },
    "fileUploadOptionsForm": {
      "title": "Upload-Optionen",
      "description": "<strong>{{resource}}</strong> existiert bereits an diesem Ort. Möchten Sie die vorhandene Datei durch eine neue Version ersetzen oder beide Dateien behalten? Durch das Ersetzen von Dateien werden die Freigabeoptionen nicht geändert",
      "description_other": "An diesem Speicherort sind bereits ein oder mehrere Elemente vorhanden. Möchten Sie die vorhandenen Dateien durch eine neue Version ersetzen oder beide Dateien behalten? Durch das Ersetzen von Dateien werden die Freigabeoptionen nicht geändert",
      "replaceExistingFile": "Vorhandene Datei ersetzen",
      "replaceExistingFile_other": "Ersetzen Sie vorhandene Dateien",
      "keepBothFiles": "Behalten Sie beide Dateien",
      "keepBothFiles_other": "Behalten Sie beide Dateien",
      "newOnly": "Nur neu"
    },
    "filePermanentlyDeleteForm": {
      "title": "{{resource}} dauerhaft löschen",
      "title_other": "{{count}}-Dateien dauerhaft löschen",
      "description": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "description_other": "Sind Sie sicher, dass Sie <strong>diese Dateien</strong> dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "fileSellForm": {
      "title": "Datei verkaufen",
      "message": "Verkaufen Sie die Datei mit FileGrant",
      "uploadPreview": "Klicken oder ziehen Sie, um die Bildvorschau hochzuladen",
      "uploadPreviewHint": "Quadratisches Bild – max. 5 MB",
      "removeImage": "Bild entfernen",
      "pleaseEnterPrice": "Bitte geben Sie einen Preis ein",
      "invalidNumber": "Ungültige Nummer",
      "priceMin": "Der Preis muss mindestens €{{amount}} betragen.",
      "allowDownload": "Datei-Download zulassen",
      "removeFromStore": "Aus dem Laden entfernen",
      "listedSuccess": "Datei erfolgreich zum Verkauf angeboten!",
      "purchaseLink": "Kauflink",
      "previewUploadError": "Fehler beim Hochladen der Vorschau",
      "imageTooLarge": "Das Bild muss kleiner als 5 MB sein",
      "unableToReadImage": "Das Bild kann nicht gelesen werden",
      "previewAlt": "Vorschau",
      "mustBeImage": "Die Datei muss ein Bild sein",
      "previewImage": "Vorschaubild"
    },
    "emptyFilesTrash": {
      "title": "Leeren Sie den Müll",
      "description": "Möchten Sie den Papierkorb wirklich leeren? Geben Sie zur Bestätigung <strong>{{keyword}}</strong> ein. Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "settingExceptionsForm": {
      "title": "Ausnahmen bearbeiten",
      "description": "Bearbeiten Sie die Ausnahmen für die Einstellung.",
      "unsavedExceptions": "Nicht gespeicherte Ausnahmen",
      "currentExceptions": "Aktuelle Ausnahmen"
    },
    "aiSummary": {
      "title": "KI-Zusammenfassung"
    },
    "aiDocumentChat": {
      "title": "Chatten Sie mit Dokument"
    },
    "sendInvitationToGroupUsers": {
      "title": "Einladung senden",
      "description": "Sie können eine benutzerdefinierte Nachricht an die neuen Benutzer der Gruppe senden oder diesen Dialog ohne weitere Aktion schließen.",
      "success": "Einladung erfolgreich gesendet",
      "error": "Fehler beim Senden der Einladung",
      "customMessagePlaceholder": "Optional: Benutzerdefinierte Nachricht"
    },
    "sendInvitationToUsers": {
      "title": "Einladung senden",
      "description": "Sie können eine benutzerdefinierte Nachricht an {{resource}} senden oder diesen Dialog ohne weitere Aktion schließen.",
      "description_other": "Sie können eine benutzerdefinierte Nachricht an {{count}}-Benutzer senden oder diesen Dialog ohne weitere Aktion schließen.",
      "success": "Einladung erfolgreich gesendet",
      "error": "Fehler beim Senden der Einladung",
      "customMessagePlaceholder": "Optional: Benutzerdefinierte Nachricht"
    },
    "restoreFileVersion": {
      "title": "Dateiversion wiederherstellen",
      "description": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> auf Version <strong>{{version}}</strong> wiederherstellen möchten?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Unbefugte Benutzer",
      "descriptionForAllUsers": "Aufgrund der aktuellen Einstellungen können Sie keine Dateien für diese Benutzer freigeben",
      "descriptionForSomeUsers": "Sie können Dateien nicht mit diesen Benutzern teilen: <strong> {{users}} </strong> Möchten Sie aufgrund der aktuellen Einstellungen Dateien mit anderen Benutzern teilen, die nicht durch die Einstellung blockiert sind?"
    },
    "sessionExpired": {
      "title": "Sitzung abgelaufen",
      "description": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
      "redirectMessage": "Sie werden in <strong>{{seconds}}</strong> Sekunden zum Login weitergeleitet…",
      "goToLoginNow": "Gehen Sie jetzt zum Anmelden"
    },
    "appUpdated": {
      "title": "Neue Version verfügbar",
      "description": "Eine neue Version der Anwendung ist verfügbar. Bitte laden Sie die Seite neu, um fortzufahren.",
      "reloadButton": "Neu laden"
    },
    "tooManyRequestsOverlay": {
      "title": "Zu viele Anfragen",
      "description": "Sie haben in kurzer Zeit zu viele Anfragen gestellt. Bitte warten Sie einen Moment, bevor Sie es erneut versuchen.",
      "redirectMessage": "Sie können es in <strong>{{seconds}}</strong> Sekunden erneut versuchen…"
    },
    "activateTotpOverlay": {
      "badge": "Kontoschutz",
      "title": "Ihre Dateien verdienen eine zusätzliche Schutzebene",
      "description1": "Bei CyberGrant wissen wir, dass vertrauliche Daten von unschätzbarem Wert sind – oder besser gesagt, sie haben einen Preis, und dieser ist für jeden, der sie Ihnen wegnehmen möchte, sehr hoch.",
      "description2": "Die Zwei-Faktor-Authentifizierung (2FA) fügt eine zweite Verifizierungsebene hinzu, die unbefugten Zugriff blockiert, selbst wenn die Anmeldeinformationen gefährdet sind.",
      "stat1Value": "99,9 %",
      "stat1Label": "der automatisierten Angriffe, die mit 2FA blockiert wurden",
      "stat2Value": "< 30s",
      "stat2Label": "um die Ersteinrichtung abzuschließen",
      "featuresTitle": "Mit aktiviertem 2FA",
      "feature1": "Kein Zugriff ohne Ihr Telefon",
      "feature2": "Sofortige Benachrichtigung bei jedem verdächtigen Versuch",
      "feature3": "Stärkere Angleichung an NIS2 und DSGVO",
      "actionActivate": "Aktivieren Sie jetzt 2FA",
      "actionRemind": "Erinnere mich am {{count}} Tag daran",
      "actionRemind_other": "Erinnere mich in {{count}} Tagen daran",
      "actionSkipForever": "Ich akzeptiere das Risiko und möchte 2FA nicht aktivieren",
      "skipForever": "Für immer überspringen",
      "skipForeverConfirmTitle": "Bestätigen Sie Ihre Auswahl",
      "skipForeverConfirmBody1": "Sie entscheiden sich dafür, die Zwei-Faktor-Authentifizierung (2FA) nicht zu aktivieren. 2FA ist die einfachste und effektivste Sicherheitsmaßnahme, die Sie anwenden können. Die Nichtaktivierung stellt ein unnötiges und leicht vermeidbares Risiko dar.",
      "skipForeverConfirmBody2": "Sind Sie sicher, dass Sie fortfahren möchten, ohne die Zwei-Faktor-Authentifizierung (2FA) zu aktivieren?",
      "skipForeverConfirmEnableNow": "Aktivieren Sie es jetzt",
      "skipForeverConfirmDecline": "Ich möchte es nicht aktivieren",
      "footer": "Sie können 2FA jederzeit über die Sicherheitseinstellungen in Ihrem Konto verwalten.",
      "badgeMandatory": "Aktion erforderlich",
      "titleMandatory": "Ab sofort ist eine Zwei-Faktor-Authentifizierung erforderlich",
      "description1Mandatory": "Ihre Organisation benötigt für Ihr Konto eine Zwei-Faktor-Authentifizierung (2FA) und die Kulanzfrist für die Einrichtung ist abgelaufen. Sie müssen es jetzt aktivieren, um Filegrant weiterhin verwenden zu können.",
      "footerMandatory": "Dieser Schritt ist gemäß der Sicherheitsrichtlinie Ihrer Organisation erforderlich und kann nicht verschoben werden."
    },
    "openFileLocallyError": {
      "title": "Kunde nicht gefunden",
      "description": "Um Dokumente lokal öffnen zu können, muss Remotegrant installiert sein. Wenden Sie sich an den Administrator, um es zu installieren."
    },
    "offline": {
      "title": "Offline",
      "description": "Sie bist offline. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
      "message": "Warten auf Internetverbindung..."
    },
    "webAppUpdateAvailable": {
      "title": "Web-App-Update verfügbar",
      "description": "Eine neue Version der Web-App ist verfügbar. Bitte aktualisieren Sie die Seite, um sie zu aktualisieren.",
      "okText": "Aktualisieren",
      "cancelText": "Später"
    },
    "keepFilesOfflineError": {
      "title": "Kunde nicht gefunden",
      "description": "Um Dateien auf Ihrem PC zu behalten, muss der RemoteGrant-Agent installiert sein. Wenden Sie sich an Ihren Administrator, um es zu installieren."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "Prüfteam verwalten",
      "description": "Verwalten Sie das Prüfteam für die Freigabegenehmigungsanforderung."
    },
    "tagsRequiredForShare": {
      "title": "Zum Teilen erforderliche Tags",
      "description": "Die Datei <strong>{{resource}}</strong> erfordert die Freigabe von Tags. Bitte fügen Sie der Datei Tags hinzu und versuchen Sie es erneut.",
      "description_other": "Für einige dieser Dateien müssen Tags freigegeben werden. Bitte fügen Sie Tags zu den Dateien hinzu und versuchen Sie es erneut."
    },
    "tagsRequiredForDownload": {
      "title": "Für den Download erforderliche Tags",
      "description": "Für die Datei <strong>{{resource}}</strong> müssen Tags heruntergeladen werden. Bitte fügen Sie der Datei Tags hinzu und versuchen Sie es erneut.",
      "description_other": "Für einige dieser Dateien müssen Tags heruntergeladen werden. Bitte fügen Sie Tags zu den Dateien hinzu und versuchen Sie es erneut."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "Dateien löschen?",
      "description": "Sind Sie sicher, dass Sie <strong>{{resource}}</strong> löschen möchten? Verknüpfungen der ausgewählten Dateien wurden gefunden. Wenn Sie diese Datei löschen, funktionieren diese Verknüpfungen nicht mehr. <br /><br />Möchten Sie fortfahren?",
      "description_other": "Sind Sie sicher, dass Sie <strong>diese Dateien</strong> löschen möchten? Verknüpfungen der ausgewählten Dateien wurden gefunden. Wenn Sie diese Dateien löschen, funktionieren diese Verknüpfungen nicht mehr. <br /><br />Möchten Sie fortfahren?"
    },
    "officeTokenExpired": {
      "title": "Sitzung abgelaufen",
      "description": "Aktualisieren Sie die Seite, um fortzufahren"
    },
    "officeEditorBeta": {
      "title": "Probieren Sie das neue FileGrant Office aus?",
      "description": "FileGrant Office ist in der Betaversion verfügbar. Sie können weiterhin den klassischen Editor verwenden oder die neue Erfahrung für diese Sitzung ausprobieren.",
      "tryNew": "Probieren Sie den neuen Editor aus",
      "useClassic": "Verwenden Sie den klassischen Editor"
    },
    "officeEditorDelete": {
      "title": "In den Papierkorb verschieben und Editor schließen?",
      "description": "Die Datei wird in den Papierkorb verschoben und der Editor wird geschlossen. Nicht gespeicherte Änderungen werden durch die automatische Speicherung verarbeitet."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Wenden Sie Tags auf Dateien an",
      "description": "Durch Anwenden der ausgewählten Tags werden diese Dateien entsprechend den Sichtbarkeitseinstellungen für markierte Dateien automatisch mit anderen Benutzern geteilt.<br /><br />Betroffene Tags:<br /><strong>{{resource}}</strong><br /><br />Möchten Sie fortfahren?",
      "description_other": "Durch Anwenden einiger der ausgewählten Tags werden diese Dateien entsprechend den Sichtbarkeitseinstellungen für markierte Dateien automatisch für andere Benutzer freigegeben.<br /><br />Betroffene Tags:<br /><strong>{{resource}}</strong><br /><br />Möchten Sie fortfahren?"
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Schnell teilen"
  },
  "viewer": {
    "eml": {
      "attachments": "Anhänge",
      "cc": "CC",
      "date": "Datum",
      "downloadAttachment": "{{name}} herunterladen",
      "emptyBody": "Diese Nachricht hat keinen Textinhalt.",
      "from": "Aus",
      "parseError": "Diese E-Mail-Datei konnte nicht analysiert werden.",
      "showRawSource": "Rohquelle anzeigen",
      "subject": "Thema",
      "to": "Zu"
    },
    "ics": {
      "description": "Beschreibung",
      "empty": "In dieser Datei wurden keine Kalenderereignisse gefunden.",
      "end": "Ende",
      "location": "Standort",
      "organizer": "Veranstalter",
      "parseError": "Diese Kalenderdatei konnte nicht analysiert werden.",
      "showRaw": "Rohquelle anzeigen",
      "start": "Beginn",
      "untitled": "Veranstaltung ohne Titel"
    },
    "msg": {
      "attachments": "Anhänge",
      "cc": "CC",
      "date": "Datum",
      "downloadAttachment": "{{name}} herunterladen",
      "emptyBody": "Diese Nachricht hat keinen Textinhalt.",
      "from": "Aus",
      "parseError": "Diese Outlook-Nachricht konnte nicht analysiert werden.",
      "showRawSource": "Rohquelle anzeigen",
      "subject": "Thema",
      "to": "Zu"
    },
    "vcf": {
      "email": "E-Mail",
      "empty": "In dieser Datei wurden keine Kontakte gefunden.",
      "note": "Notiz",
      "organization": "Organisation",
      "parseError": "Diese Kontaktdatei konnte nicht analysiert werden.",
      "phone": "Telefon",
      "showRaw": "Rohquelle anzeigen",
      "title": "Titel",
      "unnamed": "Unbenannter Kontakt"
    },
    "htmlPreview": {
      "title": "Öffnen Sie die HTML-Vorschau",
      "description": "Diese HTML-Datei enthält möglicherweise JavaScript-Code, der potenziell gefährlich sein könnte. Aus Sicherheitsgründen wird die Vorschau in einer Sandbox-Umgebung angezeigt. Möchten Sie fortfahren?",
      "button": "Vorschau HTML",
      "hideButton": "Vorschau ausblenden"
    },
    "error": {
      "decryptFailed": {
        "title": "Entschlüsselung fehlgeschlagen",
        "description": "Die Datei kann nicht entschlüsselt werden. Bitte versuchen Sie es erneut."
      },
      "officeNoPreview": {
        "title": "Keine Vorschau verfügbar",
        "description": "Achtung: Überprüfen Sie noch einmal die Vertrauenswürdigkeit der Quelle, bevor Sie diese Originaldatei herunterladen."
      },
      "blobFetchFailed": {
        "title": "Datei nicht gefunden",
        "description": "Die Datei wurde nicht gefunden. Bitte versuchen Sie es erneut."
      },
      "fetchFilePermissionsFailed": {
        "title": "Das Abrufen der Dateiberechtigungen ist fehlgeschlagen",
        "description": "Die Dateiberechtigungen konnten nicht abgerufen werden. Bitte versuchen Sie es erneut."
      },
      "isFolder": {
        "title": "Datei ist ein Ordner",
        "description": "Die Datei ist ein Ordner. Kann nicht im Viewer geöffnet werden."
      },
      "fetchFileFailed": {
        "title": "Der Dateiabruf ist fehlgeschlagen",
        "description": "Die Datei konnte nicht abgerufen werden. Bitte versuchen Sie es erneut."
      },
      "noPreviewAvailable": {
        "title": "Keine Vorschau verfügbar",
        "description": "Achtung: Überprüfen Sie noch einmal die Vertrauenswürdigkeit der Quelle, bevor Sie diese Originaldatei herunterladen."
      },
      "noPermissions": {
        "title": "Keine Berechtigungen",
        "description": "Sie haben keine Berechtigung, diese Datei zu öffnen."
      }
    },
    "sign": {
      "title": "Signatur hinzufügen",
      "add": "Signatur hinzufügen",
      "delete": "Signatur entfernen",
      "pickFolder": "Zielordner wählen",
      "saveSignature": "Diese Signatur auch in Dateien speichern",
      "selectFolderHint": "Wählen Sie eine Position, um den Ordnerpfad anzuzeigen, in dem Sie die Signatur speichern möchten",
      "unavailable": "PDF-Signatur ist mit der aktuellen Viewer-Lizenz nicht verfügbar.",
      "success": "Signiertes PDF gespeichert",
      "error": "Signiertes PDF konnte nicht gespeichert werden",
      "flattenWarning": "Die Signatur kann nach dem Speichern nicht entfernt werden. Bitte vorher prüfen.",
      "modeEnabled": "Signaturmodus aktiviert",
      "modeDisabled": "Signaturmodus deaktiviert",
      "tab": {
        "draw": "Zeichnen",
        "upload": "Hochladen",
        "drive": "Aus Dateien"
      },
      "draw": {
        "hint": "Zeichnen Sie Ihre Signatur in das Feld",
        "clear": "Löschen"
      },
      "upload": {
        "dropHint": "Bild hierher ziehen oder klicken zum Durchsuchen"
      },
      "replaceOrCopy": {
        "title": "Signiertes PDF speichern",
        "replace": "Original ersetzen",
        "replaceHint": "Aktuelles PDF durch die signierte Version überschreiben",
        "copy": "Als Kopie speichern",
        "copyHint": "Original behalten und signiertes PDF in einem Ordner Ihrer Wahl speichern"
      }
    }
  },
  "store": {
    "fileSalesOverview": "Übersicht über den Dateiverkauf",
    "totalSales": "Verkaufte Einheiten",
    "fileRevenue": "Dateieinnahmen",
    "unitRevenue": "Stückpreis",
    "stock": "Aktie",
    "openStoreLink": "Store-Link öffnen",
    "salesDashboard": "Vertriebs-Dashboard",
    "confirmEmail": "E-Mail bestätigen",
    "confirmEmailPlaceholder": "Bestätigen Sie Ihre E-Mail",
    "emailPlaceholder": "name@beispiel.de",
    "pleaseEnterEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "pleaseConfirmEmail": "Bitte bestätigen Sie Ihre E-Mail",
    "emailsDoNotMatch": "Die beiden E-Mails stimmen nicht überein!",
    "invalidEmail": "Die Eingabe ist keine gültige E-Mail!",
    "payNow": "Bezahlen Sie jetzt",
    "paymentSuccessful": "Zahlung erfolgreich!",
    "fileAlreadySold": "Die Datei wurde bereits an diese E-Mail-Adresse verkauft",
    "emailsMismatch": "E-Mail und Bestätigungs-E-Mail stimmen nicht überein.",
    "invalidEmailFormat": "Ungültiges E-Mail-Format",
    "fileNotFound": "Datei nicht gefunden",
    "filePreview": "Dateivorschau",
    "filePreviewAlt": "Dateivorschau",
    "fileFullPreviewAlt": "Vollständige Vorschau der Datei",
    "byOwner": "Von {{name}}",
    "purchase": "Kaufen"
  },
  "dashboard": {
    "title": "Geschäftsbericht",
    "tabs": {
      "overview": "Übersicht"
    },
    "riskIndicators": {
      "title": "Risikoindikatoren",
      "untaggedFiles": {
        "label": "Dateien ohne Tags",
        "description": "Prozentsatz der Dateien, die nicht mit Tags klassifiziert sind. Ein hoher Wert weist auf das Risiko einer Nichteinhaltung der Datenklassifizierungsrichtlinien hin."
      },
      "sharingWithoutExpiration": {
        "label": "Teilen ohne Ablauf",
        "description": "Prozentsatz der Anteile ohne Verfallsdatum. Perpetual Shares erhöhen im Laufe der Zeit das Risiko eines unbefugten Zugriffs."
      },
      "editorSharing": {
        "label": "Freigabe von Editor-Berechtigungen",
        "description": "Prozentsatz der Freigaben mit Bearbeitungsberechtigungen. Hohe Werte erhöhen das Risiko einer unbefugten Datenänderung."
      },
      "externalSharing": {
        "label": "Externes Teilen",
        "description": "Prozentsatz der Freigaben für externe Domains. Hohe Werte können auf das Risiko eines Verlusts vertraulicher Daten hinweisen."
      },
      "excessiveExpiration": {
        "label": "Übermäßiger Ablauf",
        "description": "Prozentsatz der aktiven Aktien mit einer Verfallszeit von mehr als 90 Tagen. Längerer Zugriff erhöht das Risiko einer Kompromittierung."
      },
      "userConcentration": {
        "label": "Benutzerkonzentration",
        "description": "Maximaler Prozentsatz der von einem einzelnen Benutzer vorgenommenen Freigaben. Eine hohe Konzentration weist auf das Risiko einer Insider-Bedrohung oder eines kompromittierten Kontos hin."
      },
      "thresholds": "Schwellenwerte"
    },
    "ssoCoverage": {
      "label": "Interne Benutzer ohne SSO",
      "asOfNow": "Aktueller Stand",
      "excluded": "Von SSO ausgeschlossen",
      "outsideDomains": "E-Mail-Domäne nicht von SSO abgedeckt",
      "description": "Aktueller Stand aktivierter interner Benutzer (jede Rolle außer External, nicht abgelaufen), die sich per E-Mail-OTP statt SSO anmelden. Ausschluss von SSO hat Vorrang vor nicht abgedeckter Domäne. Folgt nicht dem Datumsbereich des Berichts."
    },
    "riskDetail": {
      "viewDetails": "Details",
      "user": "Benutzer",
      "domain": "Domäne",
      "domains": "Domänen",
      "shares": "Aktien",
      "noData": "Für diesen Indikator sind keine Daten verfügbar",
      "totalUsers": "{{count}} Benutzer betroffen",
      "countLabel": {
        "editorSharing": "Editor-Freigaben",
        "untaggedFiles": "Dateien ohne Tags",
        "sharingWithoutExpiration": "Ohne Ablauf",
        "externalSharing": "Externe Freigaben",
        "excessiveExpiration": "Übermäßige Anteile",
        "userConcentration": "Gesamtanteile"
      }
    },
    "volumeData": {
      "volume": "Volumen",
      "files": "Dateien",
      "folders": "Ordner",
      "total": "Gesamtzahl der Artikel"
    },
    "classification": {
      "title": "TAG-Klassifizierung",
      "withTag": "Mit TAG",
      "withoutTag": "Ohne TAG"
    },
    "sharing": {
      "internal": "Teilen mit Internen",
      "external": "Teilen mit Externen",
      "readOnly": "Teilen mit schreibgeschütztem Zugriff",
      "editor": "Mit dem Herausgeber teilen"
    },
    "expiration": {
      "title": "Ablauf der Freigabe",
      "withExpiration": "mit Ablauf",
      "withoutExpiration": "ohne Ablauf"
    },
    "expirationAnalysis": {
      "title": "Detaillierte Ablaufanalyse",
      "count": "Zählen",
      "average": "Durchschnittliche Dauer",
      "active": "Aktiv",
      "expired": "Abgelaufen",
      "min": "Mindestdauer",
      "max": "Maximale Dauer",
      "days": "Tage",
      "distribution": {
        "expired": "Abgelaufen",
        "expiringSoon": "0-7 Tage",
        "shortTerm": "7-30 Tage",
        "mediumTerm": "30-90 Tage",
        "longTerm": "90-365 Tage",
        "excessive": ">365 Tage"
      }
    },
    "domains": {
      "title": "Empfängerdomänen",
      "domain": "Domäne",
      "type": "Typ",
      "count": "Zählen",
      "distribution": "Verteilung",
      "internal": "Intern",
      "external": "Extern",
      "openRecipients": "Freigabeempfänger für {{domain}} öffnen"
    },
    "users": {
      "title": "Benutzerstatistiken",
      "user": "Benutzer",
      "files": "Dateien",
      "folders": "Ordner",
      "total": "Gesamt",
      "sharing": "Teilen",
      "withSharing": "Mit Teilen",
      "withoutSharing": "Ohne Teilen"
    },
    "refresh": "Bericht aktualisieren",
    "retry": "Wiederholen",
    "period": "Zeitraum",
    "apply": "Anwenden",
    "lastMonth": "Letzten Monat",
    "last3Months": "Letzte 3 Monate",
    "year": "Jahr",
    "all": "Alle",
    "cachedData": "Daten aktualisiert am: {{date}}",
    "internalDomains": "Interne Domänen",
    "critical": "kritisch",
    "warnings": "Warnungen",
    "criticalAlert": "Kritische Risikoindikatoren erkannt. Sofortiges Handeln erforderlich.",
    "warningAlert": "Warnrisikoindikatoren erkannt. Rezension empfohlen.",
    "securityIncidents": {
      "title": "Sicherheitsvorfälle und Warnungen",
      "noData": "In diesem Zeitraum gab es keine Sicherheitsvorfälle oder Warnungen",
      "dateTime": "Datum und Uhrzeit",
      "severityColumn": "Schwere",
      "category": "Typ",
      "description": "Beschreibung",
      "user": "Benutzer",
      "ipAddress": "IP-Adresse",
      "country": "Land",
      "viewInActivityLog": "Im Aktivitätsprotokoll anzeigen",
      "severityLevels": {
        "critical": "Kritisch",
        "error": "Fehler",
        "warning": "Warnung",
        "info": "Info"
      },
      "categories": {
        "loginFailed": "Anmeldung fehlgeschlagen",
        "suspiciousAccess": "Verdächtiger Zugriff",
        "policyViolation": "Richtlinienverstoß",
        "permissionDenied": "Zugriff verweigert",
        "rateLimitExceeded": "Ratenlimit überschritten",
        "configurationAlert": "Konfigurationsänderung",
        "sharingViolation": "Verstoß gegen das Teilen",
        "dataExportAlert": "Datenexport"
      }
    },
    "securityAnomalies": {
      "title": "Sicherheitsanomalien",
      "noData": "In diesem Zeitraum gab es keine offenen Sicherheitsanomalien",
      "criticalAlert": "Die kritische Sicherheitsanomalie {{count}} erfordert Aufmerksamkeit",
      "criticalAlert_other": "{{count}} Kritische Sicherheitsanomalien erfordern Aufmerksamkeit",
      "byDetectorTitle": "Anomalien nach Typ",
      "summary": {
        "totalOpen": "Offene Anomalien",
        "critical": "Kritisch",
        "warning": "Warnung",
        "info": "Info"
      },
      "severityColumn": "Schwere",
      "type": "Typ",
      "anomaly": "Anomalie",
      "events": "Veranstaltungen",
      "lastSeen": "Zuletzt gesehen",
      "actionsColumn": "Aktionen",
      "handledAt": "Behandelt weiter",
      "tabs": {
        "open": "Offen",
        "managed": "Verwaltet"
      },
      "actions": {
        "hide": "Als bearbeitet markieren",
        "restore": "Wiederherstellen"
      },
      "hideConfirmTitle": "Diese Anomalie als behoben markieren?",
      "hideNotePlaceholder": "Optionaler Hinweis (Grund)…",
      "restoreConfirmTitle": "Diese Anomalie wiederherstellen?",
      "hideSuccess": "Anomalie als behandelt markiert",
      "hideError": "Die Anomalie konnte nicht als behandelt markiert werden",
      "restoreSuccess": "Anomalie wiederhergestellt",
      "restoreError": "Die Anomalie konnte nicht wiederhergestellt werden",
      "managedLoadError": "Verwaltete Anomalien konnten nicht geladen werden",
      "managedNoData": "Keine verwalteten Anomalien",
      "severityLevels": {
        "critical": "Kritisch",
        "warning": "Warnung",
        "info": "Info"
      },
      "detectors": {
        "admin_ip_blocked": "Admin-Zugriff über blockierte IP",
        "unauthorized_country": "Zugriff aus einem nicht autorisierten Land",
        "brute_force_login": "Melden Sie sich mit Brute-Force an",
        "password_spray": "Passwortspray",
        "folder_password_brute_force": "Ordnerpasswort Brute-Force",
        "public_link_brute_force": "Öffentlicher Link Brute-Force",
        "security_signal": "Sicherheitssignal"
      }
    },
    "activityMap": {
      "title": "Aktivität nach Ländern",
      "noData": "In diesem Zeitraum liegen keine Aktivitätsstandortdaten vor",
      "activities": "{{count}} Aktivitäten",
      "failedLogins": "{{count}} fehlgeschlagene Anmeldungen",
      "legendLow": "Niedrig",
      "legendHigh": "Hoch",
      "selectedCountry": "{{country}}",
      "hint": "Klicken Sie auf der Karte auf ein Land, um Details anzuzeigen.",
      "viewDetails": "Zugangsdetails anzeigen",
      "periodNote": "Die Kartendaten decken die letzten 90 Tage ab.",
      "periodRange": "Kartendaten von {{from}} bis {{to}}."
    },
    "geoDetail": {
      "title": "Zugangsdaten – {{country}}",
      "totalUsers": "{{count}} Benutzer",
      "user": "Benutzer",
      "activities": "Aktivitäten",
      "failedLogins": "Fehlgeschlagene Anmeldungen",
      "distinctIps": "IPs",
      "lastAccess": "Letzter Zugriff",
      "anonymous": "Anonym",
      "noData": "Für dieses Land liegen im ausgewählten Zeitraum keine Zugangsdaten vor",
      "geoUnavailable": "Geolokalisierung nicht verfügbar"
    },
    "recipients": {
      "title": "Freigabeempfänger",
      "domainSubtitle": "Domain: {{domain}}",
      "refreshHint": "Daten neu berechnen (höchstens einmal alle 30 Sekunden)",
      "topTitle": "Top 10 Empfänger nach freigegebenen Elementen",
      "noData": "Keine Empfänger im ausgewählten Zeitraum",
      "countingRulesTitle": "Wie Empfänger gezählt werden",
      "countingRules": {
        "active": "Nur aktive Freigaben zählen: abgelaufene, ausstehende, abgelehnte, widerrufene oder ausgeschöpfte Freigaben sowie Dateien im Papierkorb sind ausgeschlossen.",
        "direct": "Nur direkte Freigaben zählen: Ein freigegebener Ordner ist ein Element, sein Inhalt wird nicht aufgeschlüsselt.",
        "group": "Eine Gruppe ist ein Empfänger (Mitglieder werden zur Information angezeigt); alle öffentlichen Links bilden eine Zeile.",
        "domainCount": "Diese Summen können niedriger sein als die Werte unter Empfängerdomains, die jede Freigabe des Zeitraums enthalten."
      },
      "summary": {
        "internalUsers": "Interne Benutzer",
        "externalUsers": "Externe Benutzer",
        "groups": "Gruppen",
        "publicLinks": "Öffentliche Links",
        "totalShares": "Freigaben gesamt"
      },
      "types": {
        "all": "Alle Typen",
        "internal": "Intern",
        "external": "Extern",
        "group": "Gruppe",
        "public": "Öffentlich"
      },
      "type": "Typ",
      "domain": "Domain",
      "domainPlaceholder": "Nach Domain filtern",
      "searchPlaceholder": "Name oder E-Mail suchen",
      "editorOnly": "Nur Bearbeiter-Freigaben",
      "withoutExpirationOnly": "Nur ohne Ablaufdatum",
      "sortBy": "Sortieren nach",
      "sortByValue": "Sortieren nach: {{field}}",
      "sort": {
        "items": "Elemente",
        "editor": "Bearbeiter-Freigaben",
        "withoutExpiration": "Ohne Ablaufdatum",
        "lastShared": "Letzte Freigabe",
        "owners": "Eigentümer",
        "name": "Name"
      },
      "totalRecipients": "{{count}} Empfänger",
      "name": "Name",
      "email": "E-Mail",
      "members": "Mitglieder",
      "items": "Elemente",
      "filesFolders": "{{files}} Dateien / {{folders}} Ordner",
      "editorShares": "Bearbeiter",
      "withoutExpiration": "Ohne Ablauf",
      "withoutPassword": "Ohne Passwort",
      "owners": "Eigentümer",
      "lastShared": "Letzte Freigabe",
      "highestRisk": "Höchstes Risiko",
      "publicLinks": "Öffentliche Links",
      "unknown": "Unbekannt",
      "itemsTitle": "Freigegeben für {{name}}",
      "totalItems": "{{count}} freigegebene Elemente",
      "noItems": "Keine aktiven Freigaben im ausgewählten Zeitraum",
      "itemName": "Name",
      "file": "Datei",
      "folder": "Ordner",
      "size": "Größe",
      "owner": "Eigentümer",
      "permission": "Berechtigung",
      "editor": "Bearbeiter",
      "viewer": "Betrachter",
      "expiration": "Ablauf",
      "never": "Nie",
      "createdAt": "Freigegeben am",
      "canDownload": "Download",
      "passwordProtected": "Passwort",
      "accesses": "Zugriffe",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Unbegrenzt",
      "yes": "Ja",
      "no": "Nein"
    },
    "errors": {
      "accessDenied": "Zugriff verweigert",
      "accessDeniedDescription": "Sie sind nicht berechtigt, den Executive Report anzuzeigen. Nur Administratoren können auf diesen Abschnitt zugreifen.",
      "serverError": "Systemfehler",
      "serverErrorDescription": "Der Bericht kann nicht erstellt werden. Bitte versuchen Sie es später noch einmal.",
      "noData": "Keine Daten verfügbar",
      "pdfExportFailed": "Das Dashboard konnte nicht als PDF exportiert werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.",
      "folderPasswordForm": {
        "title": "Ordner-Passwortschutz"
      },
      "invalidFilter": "Ungültiger Filter: Er wurde zurückgesetzt.",
      "recipientNotFound": "Empfänger nicht gefunden. Die Liste wurde aktualisiert."
    }
  },
  "aiClassificationStatus": {
    "none": "Keiner",
    "queued": "In der Warteschlange...",
    "classifying": "Klassifizierung...",
    "done": "Vollendet",
    "error": "Fehler",
    "unknown": "Unbekannt"
  },
  "webSocketStatus": {
    "idle": "Leerlauf",
    "connecting": "Verbinden",
    "open": "Offen",
    "closing": "Schließen",
    "closed": "Geschlossen",
    "error": "Fehler"
  },
  "fileOfflineStatus": {
    "Pending": "In der Warteschlange zur Gerätesynchronisierung",
    "Downloading": "Herunterladen auf das Gerät",
    "Downloaded": "Auf dem Gerät synchronisiert"
  },
  "file": {
    "antivirus": {
      "pending": "Antivirus-Scan läuft",
      "rescanPending": "Neuversuch in Warteschlange — Datei bleibt blockiert ({{threatName}})",
      "infected": "Bedrohung erkannt: {{threatName}}",
      "error": "Antivirus konnte diese Datei nicht prüfen",
      "errors": {
        "STREAM_TOO_LARGE": "Nicht vom Antivirus geprüft — Datei zu groß für den Scan",
        "ENGINE_UNREACHABLE": "Antivirus-Engine nicht erreichbar",
        "SCAN_TIMEOUT": "Antivirus-Scan zeitüberschritten",
        "MAX_RETRIES": "Antivirus-Scan nach mehreren Versuchen fehlgeschlagen"
      },
      "rescanFailed": "Neuversuch fehlgeschlagen — Datei bleibt blockiert ({{threatName}})",
      "retry": "Scan wiederholen",
      "contactAdmin": "Wenden Sie sich an Ihren Administrator, wenn Sie eine Fehlalarm vermuten.",
      "stickyNote": "Erneutes Hochladen, Wiederherstellen einer Version oder Bearbeiten in Office entfernt diese Bedrohung nicht.",
      "tooLarge": "Nicht vom Antivirus geprüft — Datei zu groß für den Scan"
    }
  },
  "batch": {
    "status": {
      "all": "Alle",
      "queued": "In der Warteschlange",
      "processing": "Verarbeitung",
      "completed": "Vollendet",
      "failed": "Fehlgeschlagen",
      "partiallycompleted": "Teilweise abgeschlossen",
      "cancelled": "Abgesagt"
    },
    "operation": {
      "all": "Alle Operationen",
      "classification": "KI-Klassifizierung",
      "folderexpansion": "Ordnererweiterung",
      "delete": "Löschen"
    },
    "failedFiles": "Datei {{count}} fehlgeschlagen",
    "failedFiles_other": "{{count}}-Dateien sind fehlgeschlagen",
    "eta": "voraussichtliche Ankunftszeit",
    "failedFilesDetail": "Details zu fehlgeschlagenen Dateien",
    "noFailedFiles": "Keine fehlgeschlagenen Dateien",
    "fileCancelled": "Abbruch für diese Datei angefordert.",
    "fileCancelError": "Fehler beim Anfordern des Dateiabbruchs.",
    "fileRetried": "Die Datei steht für einen erneuten Versuch in der Warteschlange",
    "fileRetryError": "Fehler beim erneuten Versuch der Datei",
    "cancelAllFailed": "Alle fehlgeschlagenen Batches abbrechen (nicht Verarbeitung)",
    "cancelAllFailedConfirmTitle": "Alle fehlgeschlagenen Batches abbrechen?",
    "cancelAllFailedConfirmContent": "Es werden nur Batches mit Status Fehlgeschlagen gelöscht. Batches in Verarbeitung oder in der Warteschlange laufen weiter und sind nicht betroffen. Dieser Vorgang kann nicht rückgängig gemacht werden."
  },
  "entraId": {
    "importFromEntraId": "Von Entra ID importieren",
    "importGroupsTitle": "Importieren Sie Gruppen aus der Microsoft Entra ID",
    "importUsersTitle": "Benutzer importieren von Microsoft Entra ID",
    "searchGroups": "Gruppen durchsuchen...",
    "selectNew": "Wählen Sie nur „Neu“ aus",
    "existing": "Vorhanden",
    "new": "Neu",
    "importMembers": "Importieren Sie auch Gruppenmitglieder",
    "importSelected": "Importieren ({{count}})",
    "importSuccess": "Import abgeschlossen: {{created}} erstellt, {{updated}} aktualisiert",
    "importError": "Fehler beim Import",
    "errorLoadingGroups": "Fehler beim Laden der Gruppen von Entra ID",
    "errorLoadingUsers": "Fehler beim Laden von Benutzern von Entra ID",
    "noGroupsFound": "Keine Gruppen gefunden",
    "noUsersFound": "Keine Benutzer gefunden",
    "resultSummary": "Erstellt: {{created}}, Aktualisiert: {{updated}}, Übersprungen: {{skipped}}, Fehlgeschlagen: {{failed}}",
    "usersImported": "{{count}} Mitglieder wurden ebenfalls importiert",
    "permissionErrorTitle": "Unzureichende Azure AD-Berechtigungen",
    "permissionErrorDescription": "Die Azure AD-Anwendung verfügt nicht über ausreichende Berechtigungen, um auf die Microsoft Graph-API zuzugreifen.",
    "permissionErrorSteps": "So beheben Sie dieses Problem:",
    "permissionErrorStep1": "Gehen Sie zu Azure-Portal > App-Registrierungen > Ihre App",
    "permissionErrorStep2": "Navigieren Sie zu API-Berechtigungen",
    "permissionErrorStep3": "Fügen Sie die erforderlichen Anwendungsberechtigungen hinzu (nicht delegiert).",
    "permissionErrorStep4": "Klicken Sie auf „Administratoreinwilligung erteilen“, um die Berechtigungen zu autorisieren",
    "requiredPermissions": "Erforderliche Berechtigungen",
    "filterBySync": "Nach Synchronisierung filtern",
    "syncedWithEntraId": "Synchronisiert mit Entra ID",
    "syncedTooltip": "Synchronisiert mit Microsoft Entra ID",
    "searchUsers": "Benutzer suchen...",
    "importUsersSuccess": "Import abgeschlossen: {{created}} erstellt, {{updated}} aktualisiert",
    "usersResultSummary": "Erstellt: {{created}}, Aktualisiert: {{updated}}, Übersprungen: {{skipped}}, Fehlgeschlagen: {{failed}}",
    "defaultRole": "Standardrolle"
  },
  "continents": {
    "europe": "Europa",
    "asia": "Asien",
    "africa": "Afrika",
    "northAmerica": "Nordamerika",
    "southAmerica": "Südamerika",
    "oceania": "Ozeanien",
    "antarctica": "Antarktis"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Länder auswählen...",
      "euOption": "Europäische Union (Alle 27 Länder)",
      "searchPlaceholder": "Länder suchen..."
    },
    "regionSelect": {
      "placeholder": "Wählen Sie Regionen aus oder geben Sie ISO-Codes ein...",
      "euOption": "europäische Union",
      "searchPlaceholder": "Regionen durchsuchen..."
    },
    "ipCidrInput": {
      "placeholder": "Geben Sie IP-Adressen oder CIDR-Bereiche ein, getrennt durch Kommas",
      "helperText": "Beispiele: 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Geben Sie eine gültige IP-Adresse oder einen gültigen CIDR-Bereich ein",
      "invalidEntries": "Ungültige Einträge: {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "IP-/Regionsausnahmen verwalten",
      "description": "Gewähren Sie bestimmten Benutzern oder Gruppen zusätzliche Zugriffskriterien",
      "typeLabel": "Ausnahmetyp",
      "additionalIpsTitle": "Zusätzliche erlaubte IPs",
      "addAllowedIp": "Fügen Sie IP oder CIDR hinzu",
      "additionalCountriesTitle": "Zusätzliche zulässige Länder",
      "additionalRegionsTitle": "Zusätzliche zulässige Regionen",
      "expirationTitle": "Verfallsdatum",
      "expirationNone": "Kein Ablauf",
      "expirationCustom": "Läuft ab am:",
      "reasonTitle": "Grund (für Prüfung)",
      "reasonPlaceholder": "z. B. Geschäftsreise nach London – Februar 2026",
      "addException": "Ausnahme hinzufügen",
      "existingExceptions": "Bestehende Ausnahmen",
      "fetchError": "Beim Abrufen der Ausnahmen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "selectAtLeastOne": "Wählen Sie mindestens einen Benutzer oder eine Gruppe aus",
      "atLeastOneCriterion": "Fügen Sie mindestens eine IP-Adresse, ein Land oder eine Region hinzu: Eine Ausnahme ohne Kriterien gewährt nichts",
      "alreadyPresent": "Für die ausgewählten Benutzer oder Gruppen gilt bereits eine Ausnahme von dieser Einschränkung"
    }
  },
  "email": {
    "inbox": "Posteingang",
    "sent": "Gesendet",
    "favorites": "Favoriten",
    "trash": "Papierkorb",
    "drafts": "Entwürfe",
    "noEmails": "Keine E-Mails in diesem Ordner",
    "noEmailsFound": "Keine E-Mails gefunden",
    "noSubject": "(Kein Thema)",
    "searchPlaceholder": "E-Mails durchsuchen",
    "newMessage": "Neue Nachricht",
    "newEmail": "E-Mail",
    "folders": "Ordner",
    "to": "Zu",
    "from": "Aus",
    "cc": "CC",
    "bcc": "Bcc",
    "subject": "Thema",
    "date": "Datum",
    "body": "Körper",
    "send": "Schicken",
    "sending": "Senden...",
    "cancel": "Abbrechen",
    "draftIdle": "Warten auf Änderungen",
    "draftSaveError": "Speichern fehlgeschlagen",
    "draftSaved": "Entwurf gespeichert",
    "draftSaving": "Sparen...",
    "editDraft": "Entwurf bearbeiten",
    "saveDraft": "Entwurf speichern",
    "sendError": "E-Mail konnte nicht gesendet werden",
    "errorExternalSharingNotAllowed": "Die folgenden Empfänger sind nicht autorisiert",
    "errorSharingDenied": "Sie sind nicht berechtigt, diese Dateien freizugeben",
    "errorPartialSharingDenied": "Einige Anhänge können nicht mit den ausgewählten Empfängern geteilt werden",
    "errorCannotAccessFiles": "Sie haben keinen Zugriff auf die angehängten Dateien",
    "attachmentReadOnly": "Nur ansehen",
    "attachmentEditor": "Kann bearbeiten",
    "attachmentExpirationWarning": "Die Freigabe läuft in {{days}} Tagen ab",
    "attachmentPermission": "Erlaubnis",
    "writeMessage": "Schreiben Sie Ihre Nachricht...",
    "attachFiles": "Dateien anhängen",
    "attachments": "Anhänge",
    "hasAttachments": "Hat Anhänge",
    "addFavorite": "Zu Favoriten hinzufügen",
    "removeFavorite": "Aus Favoriten entfernen",
    "moveToTrash": "In den Papierkorb verschieben",
    "archive": "Archiv",
    "archiveAction": "Archiv",
    "unarchiveAction": "In den Posteingang verschieben",
    "restore": "Wiederherstellen",
    "deleteDraft": "Entwurf löschen",
    "deleteDraftConfirm": "Diesen Entwurf in den Papierkorb verschieben? Sie können es später aus dem Papierkorb wiederherstellen.",
    "deletePermanently": "Dauerhaft löschen",
    "bold": "Deutlich",
    "italic": "Kursiv",
    "underline": "Unterstreichen",
    "bulletList": "Bullet-Liste",
    "fontSmall": "Klein",
    "fontNormal": "Normal",
    "fontLarge": "Groß",
    "fontHuge": "Riesig",
    "sendingInProgress": "Der Versand läuft",
    "stepPreparing": "Nachricht wird für die Zustellung vorbereitet",
    "stepValidating": "Empfänger validieren",
    "stepArchiving": "Archivierung zur sicheren Aufbewahrung",
    "stepDelivering": "Zustellung an Empfänger...",
    "secureDelivery": "Sichere Lieferung – geschützt für Unternehmen",
    "protect": "Mit Passwort schützen",
    "protectionTitle": "Passwortschutz",
    "protectionPassword": "Passwort",
    "protectionConfirm": "Passwort bestätigen",
    "protectionHint": "Hinweis (optional)",
    "protectionMismatch": "Passwörter stimmen nicht überein",
    "protectionWarning": "Der E-Mail-Inhalt wird lokal verschlüsselt. Wenn Sie dieses Passwort verlieren, kann die Nachricht nicht wiederhergestellt werden.",
    "protectedMessage": "Diese Nachricht ist durch ein Passwort geschützt.",
    "protectedSnippet": "Geschützte Nachricht",
    "protectedHintLabel": "Hinweis",
    "enterPassword": "Geben Sie das Passwort ein, um die Nachricht zu lesen",
    "unlock": "Entsperren",
    "wrongPassword": "Falsches Passwort. Bitte versuchen Sie es erneut.",
    "reply": "Antwort",
    "forward": "Nach vorne",
    "forwardedMessage": "Weitergeleitete Nachricht",
    "forwardExpired": "Die ursprüngliche Nachricht ist abgelaufen, die Weiterleitung wurde abgebrochen.",
    "forwardAttachmentsTitle": "Anhänge weiterleiten",
    "forwardAttachmentsMessage": "Diese Nachricht enthält Anhänge. Möchten Sie sie in die weitergeleitete Nachricht einschließen?",
    "forwardWithAttachments": "Mit Anhängen",
    "forwardWithoutAttachments": "Ohne Anhänge",
    "selectFromFileGrant": "Wählen Sie aus FileGrant",
    "uploadFromDevice": "Vom Gerät hochladen",
    "selectFiles": "Wählen Sie Dateien aus",
    "selectFolderForUpload": "Wählen Sie den Upload-Ordner aus",
    "filesSelected": "{{count}} Datei(en) ausgewählt",
    "confirm": "Bestätigen",
    "expiration": "Ablauf",
    "expirationTitle": "Verfallsdatum",
    "expirationDescription": "Nach dem ausgewählten Datum ist die E-Mail nicht mehr zugänglich.",
    "expirationPlaceholder": "Wählen Sie Ablaufdatum und -uhrzeit aus",
    "expiresOn": "Läuft am {{date}} ab",
    "expired": "Abgelaufen am {{date}}",
    "selected": "{{count}} ausgewählt",
    "markAsRead": "Als gelesen markieren",
    "markAsUnread": "Als ungelesen markieren",
    "deletePermanentlyConfirm": "Sind Sie sicher, dass Sie {{count}}-E-Mails dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "selectAll": "Alles auswählen",
    "deselectAll": "Alle abwählen",
    "removeAttachment": "Anhang entfernen",
    "removeAttachmentConfirm": "Möchten Sie diesen Anhang entfernen? Der Zugriff wird allen Empfängern entzogen.",
    "attachmentNotFound": "Anhang nicht gefunden",
    "featureNotAvailable": "Funktion nicht verfügbar",
    "removeRecipient": "Empfänger entfernen",
    "removeRecipientsConfirm": "Möchten Sie {{count}} Empfänger entfernen? Sie können diese E-Mail nicht mehr sehen und der Zugriff auf Anhänge wird widerrufen.",
    "emailNotFound": "E-Mail nicht gefunden",
    "recipientNotFound": "Empfänger nicht gefunden",
    "mustKeepOneRecipient": "Es muss mindestens ein Empfänger übrig bleiben",
    "replyAll": "Allen antworten",
    "activity": "Aktivität",
    "cannotCreateEmail": "Sie sind nicht berechtigt, neue E-Mails zu erstellen",
    "blockForward": "Vorwärts blocken",
    "blockForwardDescription": "Empfänger können diese E-Mail nicht weiterleiten",
    "advancedProtection": "Erweiterter Schutz",
    "protectDescription": "Um diese E-Mail lesen zu können, benötigen die Empfänger ein Passwort"
  },
  "note": {
    "createNote": "Notiz",
    "createTitle": "Notiz erstellen",
    "newNote": "Neuer Hinweis",
    "fileName": "Dateiname",
    "fileNameRequired": "Dateiname ist erforderlich",
    "placeholder": "Schreiben Sie Ihre Notiz...",
    "loadError": "Die Notiz konnte nicht geladen werden",
    "sidebarTitle": "Notizen",
    "editing": "Bearbeitung",
    "reading": "Lektüre",
    "codeBlock": "Codeblock",
    "rename": "Umbenennen",
    "renamed": "Datei umbenannt",
    "renameError": "Die Datei kann nicht umbenannt werden",
    "saved": "Notiz gespeichert",
    "saveError": "Die Notiz kann nicht gespeichert werden",
    "checklist": "Checkliste",
    "linkUrl": "Link-URL",
    "linkText": "Linktext",
    "insertLink": "Link einfügen",
    "saving": "Sparen…",
    "savedShort": "Gespeichert",
    "delete": "Notiz löschen",
    "deleteTitle": "Notiz löschen",
    "deleteConfirm": "Notiz „{{name}}“ löschen? Es wird in den Papierkorb verschoben.",
    "deleted": "Notiz gelöscht",
    "deleteError": "Die Notiz kann nicht gelöscht werden",
    "expandSidebar": "Seitenleiste erweitern",
    "collapseSidebar": "Seitenleiste einklappen"
  },
  "aiSummary": {
    "generationInProgress": "Das Erstellen der Zusammenfassung kann eine Weile dauern. Sie können dieses Fenster schließen. Wir benachrichtigen Sie dann, wenn es fertig ist.",
    "closeAndNotify": "Schließen, wir benachrichtigen Sie"
  },
  "imagePreview": {
    "loadFullQuality": "Volle Qualität laden",
    "loadFullQualityTooltip": "Laden Sie das Originalbild in voller Auflösung (große Datei)",
    "loadingFullQuality": "Vollständige Qualität wird geladen…",
    "openInViewer": "Im Viewer öffnen"
  },
  "shortcuts": {
    "title": "Tastaturkürzel",
    "then": "Dann",
    "searchLabel": "Suchen Sie nach Tastaturkürzeln",
    "searchPlaceholder": "Suchverknüpfungen…",
    "listLabel": "Liste der Tastaturkürzel",
    "noResults": "Zu Ihrer Suche passen keine Verknüpfungen.",
    "categories": {
      "app": "Anwendung",
      "create": "Erstellen",
      "file": "Dateien",
      "navigation": "Navigation",
      "selection": "Auswahl",
      "view": "Sicht"
    },
    "app": {
      "focusSearch": "Fokussuche",
      "openShortcutsHelp": "Öffnen Sie Tastaturkürzel"
    },
    "create": {
      "openMenu": "Öffnen Sie das Erstellungsmenü",
      "folder": "Neuer Ordner",
      "uploadFile": "Datei hochladen",
      "uploadFolder": "Ordner hochladen",
      "word": "Neues Word-Dokument",
      "excel": "Neue Excel-Tabelle",
      "powerpoint": "Neue PowerPoint-Präsentation",
      "note": "Neuer Hinweis",
      "secret": "Neue Anmeldedaten",
      "secretCard": "Neue Zahlungskarte",
      "secretIdentity": "Neue Identität",
      "secretSshKey": "Neuer SSH-Schlüssel",
      "secretCustom": "Neues benutzerdefiniertes Geheimnis"
    },
    "file": {
      "open": "Offen",
      "openNewTab": "In neuem Tab öffnen",
      "rename": "Umbenennen",
      "share": "Teilen",
      "move": "Bewegen",
      "favorite": "Zu Favoriten hinzufügen",
      "delete": "Entfernen",
      "copyLink": "Link kopieren",
      "createShortcut": "Verknüpfung erstellen",
      "details": "Details",
      "download": "Herunterladen",
      "publicLink": "Öffentlicher Link",
      "setPassword": "Passwort festlegen",
      "aiSummary": "KI-Zusammenfassung",
      "tags": "Tags bearbeiten"
    },
    "view": {
      "toggleGridList": "Raster- oder Listenansicht umschalten"
    },
    "nav": {
      "focusSidebar": "Fokusnavigation",
      "focusMain": "Fokusdateiliste",
      "focusDetails": "Bereich „Fokusdetails“.",
      "focusUploadDrawer": "Fokus-Upload-Fortschritt"
    },
    "selection": {
      "selectAll": "Alles auswählen",
      "clear": "Auswahl aufheben",
      "toggle": "Auswahl umschalten",
      "moveFocusUp": "Fokus nach oben verschieben",
      "moveFocusDown": "Fokus nach unten verschieben",
      "moveFocusLeft": "Fokus nach links verschieben",
      "moveFocusRight": "Fokus nach rechts verschieben",
      "extendUp": "Auswahl nach oben erweitern",
      "extendDown": "Auswahl nach unten erweitern",
      "extendLeft": "Auswahl nach links erweitern",
      "extendRight": "Auswahl nach rechts erweitern"
    }
  },
  "chat": {
    "thinking": {
      "working": "Wir arbeiten an Ihrer Anfrage. Dies kann einige Sekunden dauern."
    },
    "stream": {
      "tools": {
        "routing": "Klassifizierungsanfrage",
        "rag_search": "Suche nach Dokumenten",
        "filename_search": "Suche nach Dateinamen",
        "metadata_search": "Suche nach Metadaten",
        "open_file": "Datei öffnen",
        "relevance_assessment": "Relevanz einschätzen",
        "search_refinement": "Suche verfeinern",
        "activity_log_search": "Durchsuchen des Aktivitätsprotokolls",
        "calculator": "Berechnen",
        "chart_generation": "Diagramm wird erstellt",
        "aggregation": "Ergebnisse aggregieren",
        "answer_generation": "Antwort schreiben",
        "paused": "Warten in der Warteschlange",
        "unknown": "Arbeiten"
      },
      "descriptions": {
        "routing": {
          "start": "Finden Sie heraus, was Sie brauchen ...",
          "done": "Anfrage klassifiziert{{intentDetail}}."
        },
        "rag_search": {
          "start": "Durchsicht Ihrer Dokumente{{queryDetail}}…",
          "done": "Passende Passagen in Ihrer Bibliothek{{countDetail}} gefunden."
        },
        "filename_search": {
          "start": "Durchsuchen Sie Ihre Dateien nach Namen{{patternDetail}}…",
          "done": "Übereinstimmende Dateien nach Namen{{countDetail}}."
        },
        "metadata_search": {
          "start": "Scannen von Tags, Daten und anderen Eigenschaften…",
          "done": "Überprüfung der Dokumenteigenschaften abgeschlossen{{countDetail}}."
        },
        "open_file": {
          "start": "Lesen des ausgewählten Dokuments{{filenameDetail}}…",
          "done": "Der Inhalt des Dokuments ist gebrauchsfertig{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Abwägen, welche Ergebnisse am besten zu Ihrer Frage passen{{candidateCountDetail}}…",
          "done": "Behielt die stärksten Übereinstimmungen{{countDetail}}."
        },
        "search_refinement": {
          "start": "Verschärfung der Abfrage nach besseren Treffern{{queryDetail}}…",
          "done": "Die Suchkriterien wurden aktualisiert."
        },
        "activity_log_search": {
          "start": "Überprüfen, wer was wann getan hat{{queryDetail}}…",
          "done": "Die passenden Aktivitätseinträge wurden abgerufen{{countDetail}}."
        },
        "calculator": {
          "start": "Die Zahlen knacken{{expressionDetail}}…",
          "done": "Nummern sind fertig{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Daten in ein visuelles Bild verwandeln…",
          "done": "Das Diagramm kann angezeigt werden."
        },
        "aggregation": {
          "start": "Streichhölzer zu einem Satz zusammenfassen…",
          "done": "Die kombinierten Ergebnisse sind fertig{{countDetail}}."
        },
        "answer_generation": {
          "start": "Ich stelle Ihre Antwort zusammen ...",
          "done": "Die Antwort ist fertig."
        },
        "paused": {
          "start": "GPU ausgelastet – Sie sind in der Warteschlange{{reasonDetail}}…",
          "done": "Fortgesetzt – Fortsetzung Ihrer Anfrage."
        },
        "unknown": {
          "start": "An diesem Schritt arbeiten…",
          "done": "Dieser Schritt ist abgeschlossen."
        }
      },
      "param": {
        "query": "für „{{query}}“",
        "pattern": "für „{{pattern}}“",
        "filename": "„{{filename}}“",
        "expression": "({{expression}})",
        "count": "({{count}})",
        "candidateCount": "({{count}} Kandidaten)",
        "reason": "— {{reason}}",
        "intent": "als „{{intent}}“"
      },
      "reasons": {
        "gpu_overload": "GPU-Überlastung"
      },
      "toolsUsed": "Verwendete Werkzeuge ({{count}})"
    },
    "disclaimer": "AIGrant kann Fehler machen. Überprüfen Sie wichtige Informationen.",
    "offlineHint": "Echtzeitverbindung getrennt. Chats jederzeit durchsuchen; senden, wenn Sie wieder online sind.",
    "offlineDisclaimer": "Offline: Sie können Nachrichten senden, sobald die Verbindung wiederhergestellt ist.",
    "connectingHint": "Aufbau einer Echtzeitverbindung. Sie können es versenden, sobald es fertig ist.",
    "connectingDisclaimer": "Verbindung herstellen: Sie können Nachrichten senden, sobald die Verbindung hergestellt ist.",
    "placeholder": "Geben Sie Ihre Nachricht ein... (Eingabetaste zum Senden, Umschalt+Eingabetaste für neue Zeile)",
    "dictate": "Diktieren",
    "stopDictation": "Stoppen Sie das Diktat",
    "speechUnsupported": "Die Spracherkennung wird in diesem Browser nicht unterstützt",
    "dictationFailed": "Das Diktat konnte nicht gestartet werden",
    "regenerate": "Regenerieren",
    "readAloud": "Vorlesen",
    "stopReading": "Hör auf zu lesen",
    "speechUnavailable": "Sprachsynthese nicht verfügbar",
    "requestCancelled": "Anfrage abgebrochen",
    "genericError": "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.",
    "gpuBusyBody": "Das System ist vorübergehend überlastet. Bitte versuchen Sie es in ein paar Augenblicken noch einmal.",
    "gpuBusyRetrying": "Das System ist ausgelastet – es wird einmal erneut versucht …",
    "responseTimeout": "Die Anfrage konnte nicht innerhalb der maximalen Zeit (10 Minuten) abgeschlossen werden. Bitte versuchen Sie es später noch einmal oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "jumpToLatest": "Zum Neuesten springen"
  },
  "sharePointStatus": {
    "menuLabel": "SharePoint",
    "title": "SharePoint-Status",
    "openConfiguration": "Konfigurieren",
    "refreshHint": "Liest den Status live von Ihrem Mieter. Gehen Sie sparsam damit um.",
    "never": "Niemals",
    "notAvailableTitle": "Nicht in Ihrer Lizenz enthalten",
    "notAvailable": "Die SharePoint-Integration ist nicht in Ihrer Lizenz enthalten. Wenden Sie sich an den Support, um es zu aktivieren.",
    "loadFailedTitle": "Der Status konnte nicht geladen werden",
    "loadFailed": "Beim Lesen des Status der Integration ist ein Fehler aufgetreten.",
    "verdict": {
      "encrypting": "Dateien im Perimeter werden verschlüsselt",
      "notEncrypting": "Es wird nichts verschlüsselt"
    },
    "unmatched": {
      "title": "Einige Perimeterstandorte sind in Ihrem Mandanten nicht vorhanden",
      "body": "Die Übereinstimmung ist exakt, sodass eine umbenannte oder gelöschte Website nicht mehr zugeordnet wird. Die Dateien dieser Seiten werden weder überprüft noch verschlüsselt:",
      "allMissingTitle": "In Ihrem Mandanten ist kein Standort des Perimeters vorhanden",
      "allMissingBody": "Es wird überhaupt nichts geguckt. Keine dieser Seiten konnte gefunden werden:",
      "repickAction": "Wählen Sie diese Websites erneut aus"
    },
    "blocking": {
      "notConfiguredTitle": "Die Integration ist nicht konfiguriert",
      "notConfigured": "Es werden keine Anmeldeinformationen gespeichert, es passiert also überhaupt nichts.",
      "configInvalid": "Die gespeicherte Konfiguration wurde von der gleichen Validierung abgelehnt, die der Scan durchführt, sodass überhaupt nichts passiert.",
      "workerDisabledTitle": "Der Scan ist bei dieser Installation nicht aktiv",
      "workerDisabled": "Der Scan-Worker ist bei dieser Bereitstellung nicht registriert, daher wird nichts überprüft. Das können Sie nicht ändern: Wenden Sie sich an den Support.",
      "noCertificateTitle": "Es ist kein Verschlüsselungszertifikat ausgewählt",
      "noCertificate": "Da kein RemoteGrant-Zertifikat ausgewählt ist, gibt es keinen Schlüssel und es wird nichts verschlüsselt.",
      "certificateUnusableTitle": "Das Verschlüsselungszertifikat kann nicht mehr verwendet werden",
      "certificateUnusable": "Wählen Sie das Zertifikat erneut aus und speichern Sie es, um die Verschlüsselung fortzusetzen. Möglicherweise wurde es in RemoteGrant gelöscht, sein Schlüssel wurde möglicherweise ersetzt oder RemoteGrant ist möglicherweise nicht erreichbar.",
      "noKeyWhileArmed": "Der Erkennungsmodus ist deaktiviert, daher scheint diese Konfiguration aktiv zu sein, während nichts verschlüsselt wird.",
      "emptyPerimeterTitle": "Der Umkreis ist leer",
      "emptyPerimeter": "Kein Standort des Perimeters wird gegen Ihren Mieter aufgelöst, daher wird nichts überwacht."
    },
    "certificate": {
      "label": "Verschlüsselungszertifikat",
      "none": "Keine ausgewählt",
      "unnamed": "Zertifikat #{{id}}",
      "repickAction": "Wählen Sie das Zertifikat erneut aus"
    },
    "perimeterUnresolvedTitle": "Der Umfang konnte nicht mit Ihrem Mieter verglichen werden",
    "perimeterUnresolvedBody": "Die folgenden Zähler sind immer noch korrekt, aber die beobachteten Websites und Ordner konnten derzeit nicht gelesen werden. Dies bedeutet nicht, dass der Umkreis leer ist.",
    "perimeterError": {
      "unauthorized": "Microsoft Graph hat die Anmeldeinformationen abgelehnt: Das Client-Geheimnis ist möglicherweise abgelaufen oder den Anwendungsberechtigungen fehlt möglicherweise die Zustimmung des Administrators.",
      "unavailable": "Microsoft Graph ist vorübergehend nicht erreichbar.",
      "siteNotFound": "Mit diesen Zugangsdaten ist ein Standort des Perimeters nicht mehr sichtbar.",
      "generic": "Der Mieter war nicht erreichbar."
    },
    "countersTitle": "Scan-Aktivität",
    "pendingInQueue": "Dateien warten auf Verarbeitung",
    "totalFilesEncrypted": "Bisher verschlüsselte Dateien",
    "scanInterval": "Umfang überprüft",
    "everyNMinutes": "Alle {{minutes}} Minuten",
    "lastEncryptedAt": "Letzte Datei verschlüsselt",
    "lastDeltaAdvancedAt": "Letzter Scanzyklus",
    "lastVerifiedAt": "Zuletzt überprüfte Anmeldeinformationen",
    "verifyOk": "Bestanden",
    "verifyKo": "Abgelehnt",
    "perimeterTitle": "Beobachteter Umfang",
    "perimeterUnknown": "Der Umkreis konnte derzeit nicht von Ihrem Mandanten ausgelesen werden.",
    "perimeterEmpty": "Es wird keine Seite beobachtet.",
    "crossLibraryCaveat": "Jeder Ordner unten wird mit dem Stammverzeichnis jeder Dokumentbibliothek seiner Site abgeglichen, nicht nur mit der Bibliothek, aus der er ausgewählt wurde.",
    "wholeSiteTag": "Ganze Seite",
    "wholeSiteBody": "Kein Ordnerfilter: Jede Datei dieser Site ist im Gültigkeitsbereich.",
    "allFileTypes": "Alle Dateitypen",
    "filteredFileTypes": "Nur: {{extensions}}",
    "notAllowedTitle": "Sie dürfen dies nicht sehen",
    "notAllowed": "Sie sind nicht berechtigt, die SharePoint-Integration zu verwalten. Bitten Sie einen SuperAdmin, Ihnen Zugriff auf diese Einstellung zu gewähren.",
    "box": {
      "active": "Aktiv",
      "dryRunDiscovery": "Entdeckung",
      "dryRunEncryption": "Verschlüsselung",
      "dryRunLabel": "Modus",
      "dryRunOffCaption": "Übereinstimmende Dateien werden an Ort und Stelle verschlüsselt, es gibt keinen Weg zurück.",
      "dryRunOnCaption": "Der Umfang wird nur inspiziert, es wird nichts zurückgeschrieben.",
      "inactive": "Inaktiv",
      "off": "Aus",
      "on": "An",
      "scanLabel": "Scan"
    },
    "issuesTitle": "Bedingungen, die Ihre Aufmerksamkeit erfordern"
  },
  "sharePoint": {
    "editor": {
      "error": {
        "disabled": {
          "description": "Die SharePoint-Integration ist in dieser Installation nicht aktiviert.",
          "title": "Integration nicht verfügbar"
        },
        "forbidden": {
          "description": "Sie sind nicht berechtigt, diese Datei auf SharePoint zu öffnen.",
          "title": "Zugriff verweigert"
        },
        "generic": {
          "description": "Die Datei konnte nicht im Editor geöffnet werden. Versuchen Sie es erneut oder öffnen Sie es im Viewer.",
          "title": "Der Editor kann nicht geöffnet werden"
        },
        "notProtected": {
          "description": "Diese Datei wird von FileGrant nicht verschlüsselt und wird daher direkt in SharePoint mit Office geöffnet.",
          "title": "Hier gibt es nichts zu öffnen"
        },
        "tooLarge": {
          "description": "Diese Datei überschreitet die Größenbeschränkung für die Bearbeitung. Sie können es weiterhin im Viewer öffnen.",
          "title": "Datei zu groß zum Bearbeiten"
        },
        "unsupported": {
          "description": "Dieses Format kann nicht online bearbeitet werden. Sie können es weiterhin im Viewer öffnen.",
          "title": "Format nicht editierbar"
        }
      },
      "loading": "Öffnen der Datei im Editor…",
      "readOnly": {
        "description": "SharePoint hat Ihnen keine Berechtigung zum Ändern dieser Datei erteilt, oder es ist kein Zertifikat zum Verschlüsseln eines Speichervorgangs verfügbar. Sie können es lesen, aber nicht speichern.",
        "title": "Schreibgeschütztes Dokument"
      },
      "signIn": {
        "button": "Melden Sie sich an, um die Datei zu bearbeiten",
        "description": "Melden Sie sich mit Ihrem Microsoft-Konto an, um diese Datei zu bearbeiten. Für die Bearbeitung ist die Berechtigung zum Ändern von Dateien auf SharePoint erforderlich, die möglicherweise von einem Administrator genehmigt werden muss.",
        "failed": "Die Anmeldung wurde nicht abgeschlossen. Stellen Sie sicher, dass der Browser keine Popups blockiert, und versuchen Sie es dann erneut.",
        "title": "Anmeldung erforderlich"
      }
    },
    "signIn": {
      "failed": {
        "description": "Die Microsoft-Anmeldekonfiguration konnte nicht geladen werden. Laden Sie die Seite neu oder versuchen Sie es in ein paar Augenblicken noch einmal.",
        "title": "Anmeldung nicht möglich"
      },
      "loading": "Die Microsoft-Anmeldung wird vorbereitet…",
      "notConfigured": {
        "description": "Diese Datei kann nicht geöffnet werden: Ein Administrator hat die Microsoft-App-Registrierung, bei der sich der Browser anmeldet, nicht konfiguriert. Bitten Sie sie, die Integrationseinstellung SharePoint abzuschließen.",
        "title": "Anmeldung nicht konfiguriert"
      }
    },
    "viewer": {
      "edit": "Bearbeiten",
      "error": {
        "authFailed": {
          "description": "Es konnte keine Berechtigung zum Lesen Ihrer SharePoint-Dateien erhalten werden. Melden Sie sich erneut an oder bitten Sie einen Administrator, den FileGrant-Zugriff zu genehmigen.",
          "title": "Anmeldung erforderlich"
        },
        "disabled": {
          "description": "Die SharePoint-Integration ist in dieser Installation nicht aktiviert.",
          "title": "Integration nicht verfügbar"
        },
        "forbidden": {
          "description": "Sie sind nicht berechtigt, diese Datei auf SharePoint zu öffnen.",
          "title": "Zugriff verweigert"
        },
        "generic": {
          "description": "Die Datei von SharePoint konnte nicht geöffnet werden. Versuchen Sie es erneut.",
          "title": "Die Datei kann nicht geöffnet werden"
        },
        "invalidLink": {
          "description": "Dieser SharePoint-Link ist ungültig. Öffnen Sie die Datei erneut unter SharePoint.",
          "title": "Ungültiger Link"
        },
        "notFound": {
          "description": "Die Datei wurde nicht gefunden: Möglicherweise wurde sie verschoben oder gelöscht.",
          "title": "Datei nicht gefunden"
        },
        "reopen": {
          "description": "Die Berechtigung zum Öffnen dieser Datei ist abgelaufen oder die Datei wurde zwischenzeitlich geändert. Öffnen Sie es erneut ab SharePoint.",
          "title": "Öffnen Sie die Datei erneut"
        },
        "tooLarge": {
          "description": "Diese Datei überschreitet die Größenbeschränkung des Viewers SharePoint.",
          "title": "Datei zu groß"
        }
      },
      "loading": "Lesen der Datei von SharePoint…",
      "signIn": {
        "button": "Melden Sie sich an, um die Datei zu öffnen",
        "description": "Melden Sie sich mit Ihrem Microsoft-Konto an, um diese Datei zu öffnen. Es wird nur entschlüsselt, wenn Sie es lesen dürfen.",
        "failed": "Die Anmeldung wurde nicht abgeschlossen. Stellen Sie sicher, dass der Browser keine Popups blockiert, und versuchen Sie es dann erneut.",
        "title": "Anmeldung erforderlich"
      },
      "source": "Von SharePoint"
    }
  }
}
